// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-loading-skeleton/dist/skeleton.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noiseFilter%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%271%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noiseFilter%29%27 opacity=%270.02%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800;900&family=Ubuntu+Mono:wght@400;600&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Auto-generated by scripts/merge-styles.js — edit styles/css/*.css instead */

@property --card-lift {
  syntax: '<length>';
  inherits: false;
  initial-value: 0px;
}
@property --card-shadow-y {
  syntax: '<length>';
  inherits: false;
  initial-value: 8px;
}
@property --card-shadow-blur {
  syntax: '<length>';
  inherits: false;
  initial-value: 28px;
}
@property --card-shadow-spread {
  syntax: '<length>';
  inherits: false;
  initial-value: -6px;
}
@property --card-shadow-alpha {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.08;
}
@property --card-shadow-y2 {
  syntax: '<length>';
  inherits: false;
  initial-value: 1px;
}
@property --card-shadow-blur2 {
  syntax: '<length>';
  inherits: false;
  initial-value: 2px;
}
@property --card-shadow-alpha2 {
  syntax: '<number>';
  inherits: false;
  initial-value: 0.04;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Manrope, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: Ubuntu Mono, Monaco, Cascadia Code, Segoe UI Mono, Roboto Mono, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
    --noise: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

*{
  border-color: rgb(226 232 240 / 0.5);
}

html {
    scroll-behavior: smooth;
    text-size-adjust: 100%;
  }

body{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
  font-family: Manrope, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
    font-feature-settings: "rlig" 1, "calt" 1, "ss01" 1;
    background-image: var(--noise);
    min-height: 100vh;
    min-height: 100dvh;
    overflow-x: clip;
}

@supports (color: rgb(0 0 0 / 0)){
body{
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  }
}

@supports (color: rgb(0 0 0 / 0)){
body{
    --tw-gradient-to: rgb(255 251 235 / 0.3) var(--tw-gradient-to-position);
  }
}

/* Selection styles */

::selection{
  background-color: rgb(251 146 60 / 0.2);
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}

:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

.\\!container{
  width: 100% !important;
}

.container{
  width: 100%;
}

@media (min-width: 640px){

  .\\!container{
    max-width: 640px !important;
  }

  .container{
    max-width: 640px;
  }
}

@media (min-width: 768px){

  .\\!container{
    max-width: 768px !important;
  }

  .container{
    max-width: 768px;
  }
}

@media (min-width: 1024px){

  .\\!container{
    max-width: 1024px !important;
  }

  .container{
    max-width: 1024px;
  }
}

@media (min-width: 1280px){

  .\\!container{
    max-width: 1280px !important;
  }

  .container{
    max-width: 1280px;
  }
}

@media (min-width: 1536px){

  .\\!container{
    max-width: 1536px !important;
  }

  .container{
    max-width: 1536px;
  }
}

/* Legacy button utility classes — prefer <Button variant="..." /> in components */

/* Premium Card Styles */

.card{
  overflow: hidden;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(255 255 255 / 0.5);
  background-color: rgb(255 255 255 / 0.7);
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: color,background-color,border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.card:hover{
  background-color: rgb(255 255 255 / 0.8);
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.card-premium{
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.55);
  background-color: rgb(255 255 255 / 0.95);
    --card-ease: cubic-bezier(0.22, 1, 0.36, 1);
    --card-duration: 500ms;
    box-shadow:
      0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
      0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
    transform: translateY(var(--card-lift));
    transition:
      --card-lift var(--card-duration) var(--card-ease),
      --card-shadow-y var(--card-duration) var(--card-ease),
      --card-shadow-blur var(--card-duration) var(--card-ease),
      --card-shadow-spread var(--card-duration) var(--card-ease),
      --card-shadow-alpha var(--card-duration) var(--card-ease),
      --card-shadow-y2 var(--card-duration) var(--card-ease),
      --card-shadow-blur2 var(--card-duration) var(--card-ease),
      --card-shadow-alpha2 var(--card-duration) var(--card-ease),
      transform var(--card-duration) var(--card-ease),
      border-color var(--card-duration) var(--card-ease),
      box-shadow var(--card-duration) var(--card-ease);
}

.card-premium:hover {
    --card-lift: -1px;
    --card-shadow-y: 16px;
    --card-shadow-blur: 40px;
    --card-shadow-spread: -10px;
    --card-shadow-alpha: 0.1;
    --card-shadow-y2: 3px;
    --card-shadow-blur2: 6px;
    --card-shadow-alpha2: 0.04;
  }

.card-premium.interactive-lift:hover {
    --card-lift: -1.5px;
  }

.card-premium-accent{
  border-color: rgb(253 186 116 / 0.45);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.card-premium-accent:hover {
    border-color: rgb(255 255 255 / 0.32);
  }

.safe-top {
    padding-top: env(safe-area-inset-top, 0px);
  }

.safe-bottom {
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

.safe-x {
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);
  }

.touch-target{
  min-height: 44px;
  min-width: 44px;
}

@media (max-width: 1023px) {
    .mobile-scroll-x {
      -webkit-overflow-scrolling: touch;
    }
  }

.mobile-scroll-x{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-bottom: 0.25rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}

.mobile-scroll-x::-webkit-scrollbar {
    display: none;
  }

@media (max-width: 1023px) {
    .table-shell,
    .overflow-x-auto {
      -webkit-overflow-scrolling: touch;
    }
  }

.modal-sheet{
  width: 100%;
  max-width: 32rem;
  border-radius: 1.5rem;
}

.modal-sheet-lg{
  width: 100%;
  max-width: 42rem;
  border-radius: 1.5rem;
}

.modal-sheet-prospect{
  width: 100%;
  max-width: 42rem;
  border-radius: 1.5rem;
}

@media (min-width: 1024px){

  .modal-sheet-prospect{
    max-width: 64rem;
  }
}

.modal-sheet-xl{
  width: 100%;
  max-width: 56rem;
  border-radius: 1.5rem;
}

@media (min-width: 1024px){

  .modal-sheet-xl{
    max-width: 64rem;
  }
}

.modal-sheet-sm{
  width: 100%;
  max-width: 28rem;
  border-radius: 1.5rem;
}

.empty-state-panel{
  border-radius: 1.5rem;
  border-width: 1px;
  border-style: dashed;
  border-color: rgb(254 215 170 / 0.8);
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  --tw-gradient-from: rgb(255 247 237 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}

.interactive-lift:not(.card-premium){
  transition-property: transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.interactive-lift:not(.card-premium):hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.filter-chip{
  border-radius: 0.75rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  transition-property: color,background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.filter-chip:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.filter-chip:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.6);
  --tw-ring-offset-width: 2px;
}

.filter-chip-active{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 4px 14px rgba(249,115,22,0.35);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.filter-chip-inactive{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.filter-chip-inactive:hover{
  background-color: rgb(241 245 249 / 0.8);
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}

/* Form Styles — iOS premium filled controls */

.input-field{
  display: block;
  width: 100%;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(255 255 255 / 0.8);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.input-field::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}

.input-field{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: color,background-color,border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.input-field:focus{
  border-color: rgb(253 186 116 / 0.8);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.25);
}

.input-field:disabled{
  cursor: not-allowed;
  background-color: rgb(241 245 249 / 0.8);
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.input-premium{
  display: block;
  width: 100%;
  border-radius: 1rem;
  border-width: 0px;
  background-color: rgb(255 255 255 / 0.85);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.input-premium::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}

.input-premium{
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(226 232 240 / 0.45);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: color,background-color,box-shadow,ring-color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.input-premium:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.35);
}

.textarea-field{
  display: block;
  width: 100%;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(255 255 255 / 0.8);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.textarea-field::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}

.textarea-field{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: color,background-color,border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.textarea-field:focus{
  border-color: rgb(253 186 116 / 0.8);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.25);
}

.textarea-field:disabled{
  cursor: not-allowed;
  background-color: rgb(241 245 249 / 0.8);
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}


  .input-icon-left .textarea-field{
  padding-left: 2.5rem;
}

@media (min-width: 640px){

  
  .input-icon-left .textarea-field{
    padding-left: 3rem;
  }
}


  .input-icon-right .textarea-field{
  padding-right: 2.5rem;
}

@media (min-width: 640px){

  
  .input-icon-right .textarea-field{
    padding-right: 3rem;
  }
}

.textarea-field{
  min-height: 96px;
  resize: vertical;
  line-height: 1.625;
}

.select-field{
  display: block;
  width: 100%;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(255 255 255 / 0.8);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: color,background-color,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.select-field:focus{
  border-color: rgb(253 186 116 / 0.8);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.25);
}

.select-field:disabled{
  background-color: rgb(241 245 249 / 0.8);
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.ios-date-wrap{
  position: relative;
}

.ios-date-input{
  padding-right: 2.5rem;
    color-scheme: light;
}

.ios-date-icon{
  position: absolute;
  right: 0.875rem;
  top: 50%;
  height: 1rem;
  width: 1rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  color: rgb(249 115 22 / 0.8);
}

.ios-search-wrap{
  position: relative;
  display: flex;
  align-items: center;
}

.ios-search-input{
  width: 100%;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(255 255 255 / 0.8);
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 2.75rem;
  padding-right: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.ios-search-input::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}

.ios-search-input{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: border-color,box-shadow,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ios-search-input:focus{
  border-color: rgb(253 186 116 / 0.8);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.25);
}

.ios-search-icon{
  position: absolute;
  left: 0.875rem;
  top: 50%;
  height: 1.25rem;
  width: 1.25rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  color: rgb(249 115 22 / 0.75);
}

.ios-search-clear{
  position: absolute;
  right: 0.5rem;
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 0.75rem;
  padding: 0.375rem;
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.ios-search-clear:hover{
  background-color: rgb(241 245 249 / 0.8);
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.ios-switch{
  position: relative;
  display: inline-flex;
  height: 31px;
  width: 51px;
  flex-shrink: 0;
  align-items: center;
  border-radius: 9999px;
  border-width: 1px;
  border-color: transparent;
  background-color: rgb(226 232 240 / 0.9);
  padding: 0.125rem;
  --tw-shadow: inset 0 1px 2px rgba(15,23,42,0.08);
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ios-switch:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.ios-switch:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.5);
  --tw-ring-offset-width: 2px;
}

.ios-switch-on{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.ios-switch-thumb{
  display: block;
  height: 27px;
  width: 27px;
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 2px 8px rgba(15,23,42,0.18);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: transform,width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ios-switch:active .ios-switch-thumb{
  width: 31px;
}

.ios-switch-on:active .ios-switch-thumb{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.ios-switch-on .ios-switch-thumb{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.ios-checkbox{
  position: relative;
  display: inline-flex;
  height: 1.25rem;
  width: 1.25rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: rgb(203 213 225 / 0.8);
  background-color: rgb(255 255 255 / 0.9);
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.7);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: background-color,border-color,transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ios-checkbox:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.ios-checkbox:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.5);
  --tw-ring-offset-width: 2px;
}

.ios-checkbox-checked{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.ios-checkbox-icon{
  display: flex;
  align-items: center;
  justify-content: center;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.ios-checkbox-row{
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.ios-checkbox-label{
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.ios-checkbox-description{
  margin-top: 0.125rem;
  display: block;
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.ios-segmented{
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(241 245 249 / 0.7);
  padding: 0.25rem;
  --tw-shadow: inset 0 1px 2px rgba(15,23,42,0.05);
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.ios-segmented-compact .ios-segment{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

.ios-segmented-default .ios-segment{
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

@media (min-width: 640px){

  .ios-segmented-default .ios-segment{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

.ios-segment{
  position: relative;
  z-index: 1;
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ios-segment:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.ios-segment:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.5);
}

.ios-segment-active{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}

.ios-segment-pill{
  position: absolute;
  inset: 0px;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.ios-segment-label{
  position: relative;
  z-index: 1;
}

.ios-tabs-nav-vertical{
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.55);
  background-color: rgb(255 255 255 / 0.95);
    --card-ease: cubic-bezier(0.22, 1, 0.36, 1);
    --card-duration: 500ms;
    box-shadow:
      0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
      0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
    transform: translateY(var(--card-lift));
    transition:
      --card-lift var(--card-duration) var(--card-ease),
      --card-shadow-y var(--card-duration) var(--card-ease),
      --card-shadow-blur var(--card-duration) var(--card-ease),
      --card-shadow-spread var(--card-duration) var(--card-ease),
      --card-shadow-alpha var(--card-duration) var(--card-ease),
      --card-shadow-y2 var(--card-duration) var(--card-ease),
      --card-shadow-blur2 var(--card-duration) var(--card-ease),
      --card-shadow-alpha2 var(--card-duration) var(--card-ease),
      transform var(--card-duration) var(--card-ease),
      border-color var(--card-duration) var(--card-ease),
      box-shadow var(--card-duration) var(--card-ease);
}

.ios-tabs-nav-vertical:hover {
    --card-lift: -1px;
    --card-shadow-y: 16px;
    --card-shadow-blur: 40px;
    --card-shadow-spread: -10px;
    --card-shadow-alpha: 0.1;
    --card-shadow-y2: 3px;
    --card-shadow-blur2: 6px;
    --card-shadow-alpha2: 0.04;
  }

.ios-tabs-nav-vertical.interactive-lift:hover {
    --card-lift: -1.5px;
  }

.ios-tabs-nav-vertical{
  width: 100%;
  flex-shrink: 0;
  padding: 0.5rem;
  box-shadow:
    0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
    0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
  transform: translateY(var(--card-lift));
  transition:
    --card-lift var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-spread var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    transform var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    border-color var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    box-shadow var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1));
}

a:not(.ios-tabs-nav-vertical),
button:not(.ios-tabs-nav-vertical),
.interactive-lift:not(.ios-tabs-nav-vertical) {
  transition-property: color, background-color, border-color, box-shadow, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;
}

@media (prefers-reduced-motion: reduce) {
  .ios-tabs-nav-vertical:hover,.ios-tabs-nav-vertical.interactive-lift:hover {
    --card-lift: 0px;
  }
}

@media (prefers-contrast: high) {
  .ios-tabs-nav-vertical{
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  }
}

@media (min-width: 1024px){

  .ios-tabs-nav-vertical{
    width: 16rem;
  }
}

.ios-tabs-nav-horizontal{
  width: 100%;
}

@media (max-width: 1023px) {
    .ios-tabs-scroll {
      -webkit-overflow-scrolling: touch;
    }
  }

.ios-tabs-scroll{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-bottom: 0.25rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}

.ios-tabs-scroll::-webkit-scrollbar {
    display: none;
  }

.ios-tabs-scroll{
  padding-bottom: 0.25rem;
}

.ios-tab{
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  border-radius: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ios-tab:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.ios-tab:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.ios-tab:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.5);
}

.ios-tab-active{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}

.ios-tab-indicator{
  position: absolute;
  inset: 0px;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(254 215 170 / 0.7);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: rgb(249 115 22 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-shadow: inset 2.5px 0 0 0 rgb(234 88 12);
  --tw-shadow-colored: inset 2.5px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@supports (color: rgb(0 0 0 / 0)){
.ios-tab-indicator{
    --tw-gradient-to: rgb(245 158 11 / 0.1) var(--tw-gradient-to-position);
  }
}

.ios-tab-icon{
  position: relative;
  z-index: 1;
  color: currentColor;
}

.ios-tab span:last-child{
  position: relative;
  z-index: 1;
}

.ios-modal-footer{
  flex-shrink: 0;
  border-top-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1rem;
}

@media (min-width: 640px){

  .ios-modal-footer{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 1.5rem;
    padding-top: 1rem;
  }
}

/* Hide browser's default password toggle icons */

input[type="password"]::-webkit-credentials-auto-fill-button,
  input[type="password"]::-webkit-textfield-decoration-container,
  input[type="password"]::-webkit-caps-lock-indicator,
  input[type="password"]::-webkit-strong-password-auto-fill-button,
  input[type="password"]::-ms-reveal,
  input[type="password"]::-ms-clear {
    display: none !important;
    appearance: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    position: absolute !important;
    right: -9999px !important;
  }

/* Additional rules for Edge and Chrome */

input[type="password"] {
    appearance: none !important;
  }

/* Target password inputs specifically */

input[type="password"]::-webkit-outer-spin-button,
  input[type="password"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

/* Background Styles */

.gradient-bg{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: rgb(255 247 237 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}

@supports (color: rgb(0 0 0 / 0)){
.gradient-bg{
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  }
}

@supports (color: rgb(0 0 0 / 0)){
.gradient-bg{
    --tw-gradient-to: rgb(255 251 235 / 0.3) var(--tw-gradient-to-position);
  }
}

.glass-strong{
  border-width: 1px;
  border-color: rgb(255 255 255 / 0.5);
  background-color: rgb(255 255 255 / 0.8);
  --tw-shadow: 0 4px 20px -2px rgba(249, 115, 22, 0.1), 0 25px 50px -12px rgba(15, 23, 42, 0.12);
  --tw-shadow-colored: 0 4px 20px -2px var(--tw-shadow-color), 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

/* Text Styles */

.text-gradient{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}

.eyebrow{
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: rgb(234 88 12 / 0.9);
}

.badge-premium{
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border-radius: 9999px;
  border-width: 1px;
  border-color: rgb(254 215 170 / 0.6);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@supports (color: rgb(0 0 0 / 0)){
.badge-premium{
    --tw-gradient-to: rgb(255 251 235 / 0.8) var(--tw-gradient-to-position);
  }
}

.divider-gradient{
  height: 1px;
  width: 100%;
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

@supports (color: rgb(0 0 0 / 0)){
.divider-gradient{
    --tw-gradient-to: rgb(253 186 116 / 0)  var(--tw-gradient-to-position);
  }
}

@supports (color: rgb(0 0 0 / 0)){
.divider-gradient{
    --tw-gradient-stops: var(--tw-gradient-from), rgb(253 186 116 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
  }
}

.surface-elevated{
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(255 255 255 / 0.6);
  background-color: rgb(255 255 255 / 0.75);
  --tw-shadow: 0 1px 0 rgba(255,255,255,0.6) inset, 0 4px 24px -4px rgba(249, 115, 22, 0.15), 0 12px 40px -8px rgba(15, 23, 42, 0.1);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 4px 24px -4px var(--tw-shadow-color), 0 12px 40px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.app-shell{
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.dashboard-shell{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: rgb(255 247 237 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}

@supports (color: rgb(0 0 0 / 0)){
.dashboard-shell{
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  }
}

@supports (color: rgb(0 0 0 / 0)){
.dashboard-shell{
    --tw-gradient-to: rgb(255 251 235 / 0.25) var(--tw-gradient-to-position);
  }
}

.dashboard-main{
  position: relative;
}

.dashboard-main > .container-premium{
  position: relative;
  z-index: 1;
}

.dashboard-main::before {
    content: '';
    pointer-events: none;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    z-index: 2;
    height: 2rem;
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
    --tw-gradient-from: rgb(255 247 237 / 0.4) var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
    --tw-gradient-to: transparent var(--tw-gradient-to-position);
  }

.content-flow > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}

@media (min-width: 1280px){

  .content-flow > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }
}

.auth-page{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: rgb(255 247 237 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}

@supports (color: rgb(0 0 0 / 0)){
.auth-page{
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  }
}

@supports (color: rgb(0 0 0 / 0)){
.auth-page{
    --tw-gradient-to: rgb(255 251 235 / 0.2) var(--tw-gradient-to-position);
  }
}

.shell-sidebar{
  border-right-width: 1px;
  border-color: rgb(255 237 213 / 0.5);
  background-color: rgb(255 255 255 / 0.7);
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.sidebar-brand-divider{
  height: 1px;
  flex-shrink: 0;
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

@supports (color: rgb(0 0 0 / 0)){
.sidebar-brand-divider{
    --tw-gradient-to: rgb(253 186 116 / 0)  var(--tw-gradient-to-position);
  }
}

@supports (color: rgb(0 0 0 / 0)){
.sidebar-brand-divider{
    --tw-gradient-stops: var(--tw-gradient-from), rgb(253 186 116 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
  }
}

.topbar-blend{
  border-bottom-width: 1px;
  border-color: rgb(255 237 213 / 0.35);
}

.chart-card{
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.55);
  background-color: rgb(255 255 255 / 0.95);
    --card-ease: cubic-bezier(0.22, 1, 0.36, 1);
    --card-duration: 500ms;
    box-shadow:
      0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
      0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
    transform: translateY(var(--card-lift));
    transition:
      --card-lift var(--card-duration) var(--card-ease),
      --card-shadow-y var(--card-duration) var(--card-ease),
      --card-shadow-blur var(--card-duration) var(--card-ease),
      --card-shadow-spread var(--card-duration) var(--card-ease),
      --card-shadow-alpha var(--card-duration) var(--card-ease),
      --card-shadow-y2 var(--card-duration) var(--card-ease),
      --card-shadow-blur2 var(--card-duration) var(--card-ease),
      --card-shadow-alpha2 var(--card-duration) var(--card-ease),
      transform var(--card-duration) var(--card-ease),
      border-color var(--card-duration) var(--card-ease),
      box-shadow var(--card-duration) var(--card-ease);
}

.chart-card:hover {
    --card-lift: -1px;
    --card-shadow-y: 16px;
    --card-shadow-blur: 40px;
    --card-shadow-spread: -10px;
    --card-shadow-alpha: 0.1;
    --card-shadow-y2: 3px;
    --card-shadow-blur2: 6px;
    --card-shadow-alpha2: 0.04;
  }

.chart-card.interactive-lift:hover {
    --card-lift: -1.5px;
  }

.chart-card{
  overflow: hidden;
  box-shadow:
    0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
    0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
  transform: translateY(var(--card-lift));
  transition:
    --card-lift var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-spread var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    transform var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    border-color var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    box-shadow var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1));
}

a:not(.chart-card),
button:not(.chart-card),
.interactive-lift:not(.chart-card) {
  transition-property: color, background-color, border-color, box-shadow, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;
}

@media (prefers-reduced-motion: reduce) {
  .chart-card:hover,.chart-card.interactive-lift:hover {
    --card-lift: 0px;
  }
}

@media (prefers-contrast: high) {
  .chart-card{
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  }
}

.chart-card-header{
  display: flex;
  align-items: center;
  gap: 0.625rem;
  border-bottom-width: 1px;
  border-color: rgb(241 245 249 / 0.8);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}

@media (min-width: 640px){

  .chart-card-header{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

.chart-card-icon{
  height: 1.25rem;
  width: 1.25rem;
  flex-shrink: 0;
  color: rgb(249 115 22 / 0.9);
}

.chart-card-title{
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.chart-card-body{
  padding: 1.25rem;
}

@media (min-width: 640px){

  .chart-card-body{
    padding: 1.5rem;
  }
}

.chart-card-footer{
  border-top-width: 1px;
  border-color: rgb(241 245 249 / 0.8);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

@media (min-width: 640px){

  .chart-card-footer{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.list-row-soft{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(248 250 252 / 0.45);
  padding: 1rem;
  transition-property: background-color,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.list-row-soft:hover{
  border-color: rgb(254 215 170 / 0.7);
  background-color: rgb(255 255 255 / 0.8);
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.alert-soft-success{
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(187 247 208 / 0.6);
  background-color: rgb(240 253 244 / 0.8);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}

.alert-soft-error{
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(254 202 202 / 0.6);
  background-color: rgb(254 242 242 / 0.8);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.strength-meter{
  height: 0.375rem;
  overflow: hidden;
  border-radius: 9999px;
  background-color: rgb(241 245 249 / 0.9);
}

.strength-meter-fill{
  height: 100%;
  border-radius: 9999px;
  transition-property: width,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.sidebar-overlay{
  background-color: rgb(2 6 23 / 0.4);
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.back-to-top-btn:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.back-to-top-btn:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 146 60 / var(--tw-ring-opacity, 1));
  --tw-ring-offset-width: 2px;
}

.skip-link{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.skip-link:focus{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
  position: fixed;
  left: 1rem;
  top: 1rem;
  z-index: 10000;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.toolbar-panel{
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(255 237 213 / 0.6);
  background-color: rgb(255 255 255 / 0.7);
  padding: 1rem;
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.toolbar-result-count{
  margin-top: 0.75rem;
  border-top-width: 1px;
  border-color: rgb(226 232 240 / 0.5);
  padding-top: 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.filter-clear-btn{
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border-radius: 0.75rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.7);
  background-color: rgb(255 255 255 / 0.7);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
  transition-property: color,background-color,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.filter-clear-btn:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}

.input-icon-wrap{
  position: relative;
}

.input-icon-wrap .input-icon{
  pointer-events: none;
  position: absolute;
  top: 50%;
  height: 1.25rem;
  width: 1.25rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.input-icon-left .input-icon{
  left: 0.875rem;
}

@media (min-width: 640px){

  .input-icon-left .input-icon{
    left: 1rem;
  }
}

.input-icon-left .input-premium,
  .input-icon-left .input-field{
  padding-left: 2.5rem;
}

@media (min-width: 640px){

  .input-icon-left .input-premium,
  .input-icon-left .input-field{
    padding-left: 3rem;
  }
}

.input-icon-right .input-icon{
  right: 0.875rem;
}

@media (min-width: 640px){

  .input-icon-right .input-icon{
    right: 1rem;
  }
}

.input-icon-right .input-premium,
  .input-icon-right .input-field{
  padding-right: 2.5rem;
}

@media (min-width: 640px){

  .input-icon-right .input-premium,
  .input-icon-right .input-field{
    padding-right: 3rem;
  }
}

.auth-card{
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.55);
  background-color: rgb(255 255 255 / 0.95);
    --card-ease: cubic-bezier(0.22, 1, 0.36, 1);
    --card-duration: 500ms;
    box-shadow:
      0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
      0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
    transform: translateY(var(--card-lift));
    transition:
      --card-lift var(--card-duration) var(--card-ease),
      --card-shadow-y var(--card-duration) var(--card-ease),
      --card-shadow-blur var(--card-duration) var(--card-ease),
      --card-shadow-spread var(--card-duration) var(--card-ease),
      --card-shadow-alpha var(--card-duration) var(--card-ease),
      --card-shadow-y2 var(--card-duration) var(--card-ease),
      --card-shadow-blur2 var(--card-duration) var(--card-ease),
      --card-shadow-alpha2 var(--card-duration) var(--card-ease),
      transform var(--card-duration) var(--card-ease),
      border-color var(--card-duration) var(--card-ease),
      box-shadow var(--card-duration) var(--card-ease);
}

.auth-card:hover {
    --card-lift: -1px;
    --card-shadow-y: 16px;
    --card-shadow-blur: 40px;
    --card-shadow-spread: -10px;
    --card-shadow-alpha: 0.1;
    --card-shadow-y2: 3px;
    --card-shadow-blur2: 6px;
    --card-shadow-alpha2: 0.04;
  }

.auth-card.interactive-lift:hover {
    --card-lift: -1.5px;
  }

.auth-card{
  position: relative;
  overflow: hidden;
  --tw-shadow: 0 1px 0 rgba(255,255,255,0.6) inset, 0 4px 24px -4px rgba(249, 115, 22, 0.15), 0 12px 40px -8px rgba(15, 23, 42, 0.1);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 4px 24px -4px var(--tw-shadow-color), 0 12px 40px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow:
    0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
    0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
  transform: translateY(var(--card-lift));
  transition:
    --card-lift var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-spread var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    transform var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    border-color var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    box-shadow var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1));
}

a:not(.auth-card),
button:not(.auth-card),
.interactive-lift:not(.auth-card) {
  transition-property: color, background-color, border-color, box-shadow, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;
}

@media (prefers-reduced-motion: reduce) {
  .auth-card:hover,.auth-card.interactive-lift:hover {
    --card-lift: 0px;
  }
}

@media (prefers-contrast: high) {
  .auth-card{
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  }
}

.auth-card::before {
    content: '';
    pointer-events: none;
    position: absolute;
    right: -5rem;
    top: -5rem;
    height: 12rem;
    width: 12rem;
    border-radius: 9999px;
    background-color: rgb(251 146 60 / 0.1);
    --tw-blur: blur(64px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }

.select-wrap{
  position: relative;
  display: inline-block;
  min-width: 0px;
  vertical-align: middle;
}

.select-wrap-open{
  z-index: 10020;
}

.select-chevron{
  pointer-events: none;
  height: 1rem;
  width: 1rem;
  flex-shrink: 0;
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.select-ios-trigger{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  text-align: left;
  transition-property: border-color,background-color,box-shadow,transform;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.select-ios-trigger[data-headlessui-state~="open"],
  .select-ios-trigger-open{
  border-color: rgb(253 186 116 / 0.7);
  background-color: rgb(255 255 255 / 0.9);
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.2);
}

.dropdown-panel-ios{
  overflow: auto;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(255 255 255 / 0.7);
  background-color: rgb(255 255 255 / 0.85);
  padding: 0.375rem;
  --tw-shadow: 0 12px 40px rgba(15,23,42,0.14);
  --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.dropdown-option-ios{
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
  transition-property: background-color,color,transform;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-option-ios:hover,
  .dropdown-option-ios:focus-visible,
  .dropdown-option-ios-active{
  background-color: rgb(241 245 249 / 0.8);
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.dropdown-option-ios-selected{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}

.dropdown-option-check{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}

.tooltip-bubble{
  white-space: nowrap;
  border-radius: 0.75rem;
  border-width: 1px;
  border-color: rgb(254 215 170 / 0.4);
  background-color: rgb(15 23 42 / 0.95);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 4px 20px -2px rgba(249, 115, 22, 0.1), 0 25px 50px -12px rgba(15, 23, 42, 0.12);
  --tw-shadow-colored: 0 4px 20px -2px var(--tw-shadow-color), 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.table-shell{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(226 232 240 / 0.4);
}

.table-head-sticky{
  position: sticky;
  top: 0px;
  z-index: 1;
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.table-zebra tbody tr:nth-child(even){
  background-color: rgb(248 250 252 / 0.35);
}

.app-shell::before,
  .app-shell::after {
    content: '';
    pointer-events: none;
    position: absolute;
    border-radius: 9999px;
    --tw-blur: blur(64px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }

.app-shell::before{
  right: -6rem;
  top: -6rem;
  height: 18rem;
  width: 18rem;
  background-color: rgb(251 146 60 / 0.1);
}

.app-shell::after{
  bottom: 0px;
  left: 0px;
  height: 20rem;
  width: 20rem;
  --tw-translate-x: -6rem;
  --tw-translate-y: 25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  background-color: rgb(251 191 36 / 0.1);
}

.dashboard-main > .container-premium{
  position: relative;
  z-index: 1;
}

.stat-label{
  font-size: 0.66rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.icon-tile{
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(255 255 255 / 0.3);
}

.nav-icon-active{
  display: flex;
  aspect-ratio: 1 / 1;
  width: 2.75rem;
  height: 2.75rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.nav-icon-inactive{
  display: flex;
  aspect-ratio: 1 / 1;
  width: 2.75rem;
  height: 2.75rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background-color: rgb(241 245 249 / 0.8);
}

.section-title{
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.metric-tile{
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.55);
  background-color: rgb(255 255 255 / 0.95);
    --card-ease: cubic-bezier(0.22, 1, 0.36, 1);
    --card-duration: 500ms;
    box-shadow:
      0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
      0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
    transform: translateY(var(--card-lift));
    transition:
      --card-lift var(--card-duration) var(--card-ease),
      --card-shadow-y var(--card-duration) var(--card-ease),
      --card-shadow-blur var(--card-duration) var(--card-ease),
      --card-shadow-spread var(--card-duration) var(--card-ease),
      --card-shadow-alpha var(--card-duration) var(--card-ease),
      --card-shadow-y2 var(--card-duration) var(--card-ease),
      --card-shadow-blur2 var(--card-duration) var(--card-ease),
      --card-shadow-alpha2 var(--card-duration) var(--card-ease),
      transform var(--card-duration) var(--card-ease),
      border-color var(--card-duration) var(--card-ease),
      box-shadow var(--card-duration) var(--card-ease);
}

.metric-tile:hover {
    --card-lift: -1px;
    --card-shadow-y: 16px;
    --card-shadow-blur: 40px;
    --card-shadow-spread: -10px;
    --card-shadow-alpha: 0.1;
    --card-shadow-y2: 3px;
    --card-shadow-blur2: 6px;
    --card-shadow-alpha2: 0.04;
  }

.metric-tile.interactive-lift:hover {
    --card-lift: -1.5px;
  }

.card-premium.metric-tile:hover {
    --card-lift: -1.5px;
  }

.metric-tile:not(.card-premium){
  transition-property: transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.metric-tile:not(.card-premium):hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.metric-tile{
  padding: 1rem;
  box-shadow:
    0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
    0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
  transform: translateY(var(--card-lift));
  transition:
    --card-lift var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-spread var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    transform var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    border-color var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    box-shadow var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1));
}

a:not(.metric-tile),
button:not(.metric-tile),
.interactive-lift:not(.metric-tile) {
  transition-property: color, background-color, border-color, box-shadow, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;
}

.metric-tile:not(.card-premium) {
  transition-property: color, background-color, border-color, box-shadow, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;
}

@media (prefers-reduced-motion: reduce) {
  .metric-tile:hover,.metric-tile.interactive-lift:hover {
    --card-lift: 0px;
  }
  
  .card-premium.metric-tile:hover {
    --card-lift: 0px;
  }
}

@media (prefers-contrast: high) {
  .metric-tile{
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  }
}

@media (min-width: 1280px){

  .metric-tile{
    padding: 1.25rem;
  }
}

.metric-tile-accent{
  border-color: rgb(253 230 138 / 0.4);
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: rgb(255 251 235 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

@supports (color: rgb(0 0 0 / 0)){
.metric-tile-accent{
    --tw-gradient-to: rgb(255 247 237 / 0.5) var(--tw-gradient-to-position);
  }
}

.metric-tile-value{
  margin-top: 0.25rem;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
  letter-spacing: -0.025em;
}

.toggle-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(255 255 255 / 0.7);
  padding: 1rem;
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: background-color,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.toggle-row:hover{
  border-color: rgb(254 215 170 / 0.7);
  background-color: rgb(255 255 255 / 0.85);
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.notifications-panel{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.notification-item{
  position: relative;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1rem;
  padding-left: 1.25rem;
  transition-property: background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.notification-item:hover{
  background-color: rgb(255 247 237 / 0.6);
}

.notification-item-unread{
  background-color: rgb(255 247 237 / 0.8);
}

.notification-item-unread::before {
    content: '';
    position: absolute;
    bottom: 0.875rem;
    left: 0.375rem;
    top: 0.875rem;
    width: 3px;
    border-radius: 9999px;
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
    --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
    --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
  }

/* Status pill with leading dot (Stripe/Linear pattern) */

.status-pill::before {
    content: '';
    height: 0.375rem;
    width: 0.375rem;
    flex-shrink: 0;
    border-radius: 9999px;
    background-color: currentColor;
    opacity: 0.7;
  }

.form-label{
  margin-bottom: 0.5rem;
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.feature-row{
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(255 255 255 / 0.4);
  background-color: rgb(255 255 255 / 0.45);
  padding: 0.75rem;
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: background-color,border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.feature-row:hover{
  border-color: rgb(254 215 170 / 0.5);
  background-color: rgb(255 255 255 / 0.65);
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 640px){

  .feature-row{
    gap: 1rem;
    padding: 1rem;
  }
}

.stepper-shell{
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.55);
  background-color: rgb(255 255 255 / 0.95);
    --card-ease: cubic-bezier(0.22, 1, 0.36, 1);
    --card-duration: 500ms;
    box-shadow:
      0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
      0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
    transform: translateY(var(--card-lift));
    transition:
      --card-lift var(--card-duration) var(--card-ease),
      --card-shadow-y var(--card-duration) var(--card-ease),
      --card-shadow-blur var(--card-duration) var(--card-ease),
      --card-shadow-spread var(--card-duration) var(--card-ease),
      --card-shadow-alpha var(--card-duration) var(--card-ease),
      --card-shadow-y2 var(--card-duration) var(--card-ease),
      --card-shadow-blur2 var(--card-duration) var(--card-ease),
      --card-shadow-alpha2 var(--card-duration) var(--card-ease),
      transform var(--card-duration) var(--card-ease),
      border-color var(--card-duration) var(--card-ease),
      box-shadow var(--card-duration) var(--card-ease);
}

.stepper-shell:hover {
    --card-lift: -1px;
    --card-shadow-y: 16px;
    --card-shadow-blur: 40px;
    --card-shadow-spread: -10px;
    --card-shadow-alpha: 0.1;
    --card-shadow-y2: 3px;
    --card-shadow-blur2: 6px;
    --card-shadow-alpha2: 0.04;
  }

.stepper-shell.interactive-lift:hover {
    --card-lift: -1.5px;
  }

.stepper-shell{
  padding: 1.25rem;
  box-shadow:
    0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
    0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
  transform: translateY(var(--card-lift));
  transition:
    --card-lift var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-spread var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    transform var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    border-color var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    box-shadow var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1));
}

a:not(.stepper-shell),
button:not(.stepper-shell),
.interactive-lift:not(.stepper-shell) {
  transition-property: color, background-color, border-color, box-shadow, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;
}

@media (prefers-reduced-motion: reduce) {
  .stepper-shell:hover,.stepper-shell.interactive-lift:hover {
    --card-lift: 0px;
  }
}

@media (prefers-contrast: high) {
  .stepper-shell{
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  }
}

@media (min-width: 640px){

  .stepper-shell{
    padding: 1.5rem;
  }
}

/* Border Styles */

/* Animation Classes */

.hover-lift{
  transition-property: transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.hover-lift:hover{
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 4px 20px -2px rgba(249, 115, 22, 0.1), 0 25px 50px -12px rgba(15, 23, 42, 0.12);
  --tw-shadow-colored: 0 4px 20px -2px var(--tw-shadow-color), 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Loading States */

@keyframes shimmer{

  0%{
    transform: translateX(-100%);
  }

  100%{
    transform: translateX(100%);
  }
}

.skeleton{
  animation: shimmer 2s linear infinite;
  border-radius: 0.25rem;
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #e2e8f0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-stops: var(--tw-gradient-from), #cbd5e1 var(--tw-gradient-via-position), var(--tw-gradient-to);
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
  background-size: 200px 100%;
}

@supports (color: rgb(0 0 0 / 0)){
.skeleton{
    --tw-gradient-to: rgb(203 213 225 / 0)  var(--tw-gradient-to-position);
  }
}

.skeleton::before{
  position: absolute;
  inset: 0px;
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes shimmer{

  0%{
    transform: translateX(-100%);
  }

  100%{
    transform: translateX(100%);
  }
}

.skeleton::before{
  animation: shimmer 2s linear infinite;
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
    content: '';
}

@supports (color: rgb(0 0 0 / 0)){
.skeleton::before{
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  }
}

@supports (color: rgb(0 0 0 / 0)){
.skeleton::before{
    --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
  }
}

/* Status Indicators */

/* Premium Layout Classes */

.container-premium{
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1600px;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 640px){

  .container-premium{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1536px){

  .container-premium{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.section-padding{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

@media (min-width: 1024px){

  .section-padding{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
}

/* Navigation Styles */

.nav-link{
  position: relative;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
  transition-property: color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.nav-link:hover{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}

.nav-link::after{
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 0.125rem;
  width: 0px;
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
    content: '';
}

.nav-link:hover::after,
  .nav-link.active::after{
  width: 100%;
}

.nav-link--compact{
  white-space: nowrap;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

@media (min-width: 1280px){

  .nav-link--compact{
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

/* Notification Styles */

.\\!notification{
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(255 237 213 / 0.5);
  background-color: rgb(255 255 255 / 0.9);
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.notification{
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(255 237 213 / 0.5);
  background-color: rgb(255 255 255 / 0.9);
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

/* Shine sweep on filled buttons */

.btn-shine {
    position: relative;
    overflow: hidden;
  }

.btn-shine::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(105deg, transparent 40%, rgba(255, 255, 255, 0.38) 50%, transparent 60%);
    transform: translateX(-130%);
    transition: transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);
    pointer-events: none;
  }

.btn-shine:hover::after,
  .btn-shine:focus-visible::after {
    transform: translateX(130%);
  }

.btn-shine:active::after {
    transition-duration: 0.2s;
    transform: translateX(40%);
  }

@media (prefers-reduced-motion: reduce) {
    .btn-shine::after {
      transition: none;
      transform: none;
      opacity: 0;
    }
  }

/* Crystalline CTA shine — used on NextBestAction button */

.btn-crystal-shine{
  position: relative;
  isolation: isolate;
  overflow: hidden;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(255, 255, 255, 0.82) 45%, rgba(255, 247, 237, 0.92) 100%);
    box-shadow:
      0 0 0 1px rgba(255, 255, 255, 0.65),
      inset 0 1px 0 rgba(255, 255, 255, 1),
      inset 0 -1px 0 rgba(249, 115, 22, 0.1),
      0 10px 30px rgba(255, 255, 255, 0.4),
      0 4px 18px rgba(249, 115, 22, 0.25);
}

.btn-crystal-shine::before {
    content: '';
    position: absolute;
    top: -20%;
    bottom: -20%;
    left: 0;
    width: 45%;
    border-radius: inherit;
    background: linear-gradient(
      105deg,
      transparent 0%,
      rgba(255, 255, 255, 0.15) 35%,
      rgba(255, 255, 255, 0.7) 50%,
      rgba(255, 255, 255, 0.2) 65%,
      transparent 100%
    );
    transform: translateX(-160%) skewX(-16deg);
    animation: crystal-shine-sweep 2.8s ease-in-out infinite;
    pointer-events: none;
    z-index: 1;
    mix-blend-mode: soft-light;
  }

@keyframes crystal-shine-sweep {
    0%,
    18% {
      transform: translateX(-160%) skewX(-16deg);
      opacity: 0;
    }
    28% {
      opacity: 1;
    }
    55% {
      transform: translateX(280%) skewX(-16deg);
      opacity: 0.9;
    }
    56%,
    100% {
      transform: translateX(280%) skewX(-16deg);
      opacity: 0;
    }
  }

@media (prefers-reduced-motion: reduce) {
    .btn-crystal-shine::before {
      animation: none;
      opacity: 0.4;
      transform: translateX(40%) skewX(-16deg);
    }
  }

/* ── Design-system roles (unified source of truth) ─────────────── */

.surface{
  border-radius: 1rem;
  border-width: 1px;
  border-color: rgb(226 232 240 / 0.6);
  background-color: rgb(255 255 255 / 0.7);
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.title-line{
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.micro{
  font-size: 0.66rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.divider-soft{
  height: 1px;
  width: 100%;
  background-color: rgb(226 232 240 / 0.6);
}

.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.pointer-events-none{
  pointer-events: none;
}

.pointer-events-auto{
  pointer-events: auto;
}

.visible{
  visibility: visible;
}

.invisible{
  visibility: hidden;
}

.static{
  position: static;
}

.fixed{
  position: fixed;
}

.absolute{
  position: absolute;
}

.relative{
  position: relative;
}

.sticky{
  position: sticky;
}

.inset-0{
  inset: 0px;
}

.inset-x-0{
  left: 0px;
  right: 0px;
}

.-bottom-0\\.5{
  bottom: -0.125rem;
}

.-bottom-12{
  bottom: -3rem;
}

.-bottom-40{
  bottom: -10rem;
}

.-left-10{
  left: -2.5rem;
}

.-left-40{
  left: -10rem;
}

.-right-0\\.5{
  right: -0.125rem;
}

.-right-1{
  right: -0.25rem;
}

.-right-1\\.5{
  right: -0.375rem;
}

.-right-10{
  right: -2.5rem;
}

.-right-2{
  right: -0.5rem;
}

.-right-3{
  right: -0.75rem;
}

.-right-40{
  right: -10rem;
}

.-right-6{
  right: -1.5rem;
}

.-right-8{
  right: -2rem;
}

.-top-1{
  top: -0.25rem;
}

.-top-1\\.5{
  top: -0.375rem;
}

.-top-10{
  top: -2.5rem;
}

.-top-2{
  top: -0.5rem;
}

.-top-40{
  top: -10rem;
}

.-top-6{
  top: -1.5rem;
}

.-top-8{
  top: -2rem;
}

.bottom-0{
  bottom: 0px;
}

.bottom-2{
  bottom: 0.5rem;
}

.bottom-2\\.5{
  bottom: 0.625rem;
}

.bottom-4{
  bottom: 1rem;
}

.bottom-6{
  bottom: 1.5rem;
}

.bottom-8{
  bottom: 2rem;
}

.bottom-full{
  bottom: 100%;
}

.left-0{
  left: 0px;
}

.left-1\\/2{
  left: 50%;
}

.left-2{
  left: 0.5rem;
}

.left-2\\.5{
  left: 0.625rem;
}

.left-3{
  left: 0.75rem;
}

.left-4{
  left: 1rem;
}

.left-\\[max\\(1rem\\2c env\\(safe-area-inset-left\\)\\)\\]{
  left: max(1rem,env(safe-area-inset-left));
}

.left-full{
  left: 100%;
}

.right-0{
  right: 0px;
}

.right-2{
  right: 0.5rem;
}

.right-2\\.5{
  right: 0.625rem;
}

.right-3{
  right: 0.75rem;
}

.right-4{
  right: 1rem;
}

.right-5{
  right: 1.25rem;
}

.right-6{
  right: 1.5rem;
}

.right-8{
  right: 2rem;
}

.right-\\[max\\(1rem\\2c env\\(safe-area-inset-right\\)\\)\\]{
  right: max(1rem,env(safe-area-inset-right));
}

.right-full{
  right: 100%;
}

.top-0{
  top: 0px;
}

.top-1\\/2{
  top: 50%;
}

.top-2{
  top: 0.5rem;
}

.top-2\\.5{
  top: 0.625rem;
}

.top-3{
  top: 0.75rem;
}

.top-4{
  top: 1rem;
}

.top-8{
  top: 2rem;
}

.top-\\[max\\(1rem\\2c env\\(safe-area-inset-top\\)\\)\\]{
  top: max(1rem,env(safe-area-inset-top));
}

.top-full{
  top: 100%;
}

.z-0{
  z-index: 0;
}

.z-10{
  z-index: 10;
}

.z-20{
  z-index: 20;
}

.z-30{
  z-index: 30;
}

.z-50{
  z-index: 50;
}

.z-\\[10000\\]{
  z-index: 10000;
}

.z-\\[10019\\]{
  z-index: 10019;
}

.z-\\[10020\\]{
  z-index: 10020;
}

.z-\\[100\\]{
  z-index: 100;
}

.z-\\[120\\]{
  z-index: 120;
}

.z-\\[1\\]{
  z-index: 1;
}

.z-\\[200\\]{
  z-index: 200;
}

.z-\\[300\\]{
  z-index: 300;
}

.z-\\[310\\]{
  z-index: 310;
}

.z-\\[320\\]{
  z-index: 320;
}

.z-\\[340\\]{
  z-index: 340;
}

.z-\\[345\\]{
  z-index: 345;
}

.z-\\[350\\]{
  z-index: 350;
}

.z-\\[5\\]{
  z-index: 5;
}

.z-\\[9990\\]{
  z-index: 9990;
}

.z-\\[9998\\]{
  z-index: 9998;
}

.z-\\[9999\\]{
  z-index: 9999;
}

.order-1{
  order: 1;
}

.order-2{
  order: 2;
}

.col-span-2{
  grid-column: span 2 / span 2;
}

.col-span-full{
  grid-column: 1 / -1;
}

.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.mx-0{
  margin-left: 0px;
  margin-right: 0px;
}

.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}

.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.mx-auto{
  margin-left: auto;
  margin-right: auto;
}

.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}

.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}

.-ml-2{
  margin-left: -0.5rem;
}

.-ml-2\\.5{
  margin-left: -0.625rem;
}

.mb-0\\.5{
  margin-bottom: 0.125rem;
}

.mb-1{
  margin-bottom: 0.25rem;
}

.mb-1\\.5{
  margin-bottom: 0.375rem;
}

.mb-10{
  margin-bottom: 2.5rem;
}

.mb-2{
  margin-bottom: 0.5rem;
}

.mb-2\\.5{
  margin-bottom: 0.625rem;
}

.mb-3{
  margin-bottom: 0.75rem;
}

.mb-4{
  margin-bottom: 1rem;
}

.mb-5{
  margin-bottom: 1.25rem;
}

.mb-6{
  margin-bottom: 1.5rem;
}

.mb-8{
  margin-bottom: 2rem;
}

.ml-0\\.5{
  margin-left: 0.125rem;
}

.ml-1\\.5{
  margin-left: 0.375rem;
}

.ml-2{
  margin-left: 0.5rem;
}

.ml-2\\.5{
  margin-left: 0.625rem;
}

.ml-3{
  margin-left: 0.75rem;
}

.ml-auto{
  margin-left: auto;
}

.mr-1{
  margin-right: 0.25rem;
}

.mr-1\\.5{
  margin-right: 0.375rem;
}

.mr-2{
  margin-right: 0.5rem;
}

.mr-2\\.5{
  margin-right: 0.625rem;
}

.mt-0\\.5{
  margin-top: 0.125rem;
}

.mt-1{
  margin-top: 0.25rem;
}

.mt-1\\.5{
  margin-top: 0.375rem;
}

.mt-12{
  margin-top: 3rem;
}

.mt-2{
  margin-top: 0.5rem;
}

.mt-2\\.5{
  margin-top: 0.625rem;
}

.mt-3{
  margin-top: 0.75rem;
}

.mt-4{
  margin-top: 1rem;
}

.mt-5{
  margin-top: 1.25rem;
}

.mt-6{
  margin-top: 1.5rem;
}

.mt-7{
  margin-top: 1.75rem;
}

.mt-8{
  margin-top: 2rem;
}

.mt-auto{
  margin-top: auto;
}

.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.block{
  display: block;
}

.inline-block{
  display: inline-block;
}

.inline{
  display: inline;
}

.flex{
  display: flex;
}

.inline-flex{
  display: inline-flex;
}

.table{
  display: table;
}

.grid{
  display: grid;
}

.contents{
  display: contents;
}

.hidden{
  display: none;
}

.aspect-\\[16\\/10\\]{
  aspect-ratio: 16/10;
}

.aspect-\\[16\\/9\\]{
  aspect-ratio: 16/9;
}

.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}

.aspect-\\[6\\/5\\]{
  aspect-ratio: 6/5;
}

.aspect-square{
  aspect-ratio: 1 / 1;
}

.aspect-video{
  aspect-ratio: 16 / 9;
}

.size-12{
  width: 3rem;
  height: 3rem;
}

.h-0{
  height: 0px;
}

.h-0\\.5{
  height: 0.125rem;
}

.h-1{
  height: 0.25rem;
}

.h-1\\.5{
  height: 0.375rem;
}

.h-1\\/3{
  height: 33.333333%;
}

.h-10{
  height: 2.5rem;
}

.h-11{
  height: 2.75rem;
}

.h-12{
  height: 3rem;
}

.h-14{
  height: 3.5rem;
}

.h-16{
  height: 4rem;
}

.h-2{
  height: 0.5rem;
}

.h-2\\.5{
  height: 0.625rem;
}

.h-20{
  height: 5rem;
}

.h-24{
  height: 6rem;
}

.h-28{
  height: 7rem;
}

.h-3{
  height: 0.75rem;
}

.h-3\\.5{
  height: 0.875rem;
}

.h-32{
  height: 8rem;
}

.h-36{
  height: 9rem;
}

.h-4{
  height: 1rem;
}

.h-40{
  height: 10rem;
}

.h-44{
  height: 11rem;
}

.h-48{
  height: 12rem;
}

.h-5{
  height: 1.25rem;
}

.h-6{
  height: 1.5rem;
}

.h-64{
  height: 16rem;
}

.h-7{
  height: 1.75rem;
}

.h-8{
  height: 2rem;
}

.h-80{
  height: 20rem;
}

.h-9{
  height: 2.25rem;
}

.h-\\[1\\.125rem\\]{
  height: 1.125rem;
}

.h-\\[100dvh\\]{
  height: 100dvh;
}

.h-\\[88px\\]{
  height: 88px;
}

.h-full{
  height: 100%;
}

.h-px{
  height: 1px;
}

.max-h-48{
  max-height: 12rem;
}

.max-h-64{
  max-height: 16rem;
}

.max-h-96{
  max-height: 24rem;
}

.max-h-\\[100dvh\\]{
  max-height: 100dvh;
}

.max-h-\\[92dvh\\]{
  max-height: 92dvh;
}

.max-h-\\[calc\\(100dvh-env\\(safe-area-inset-top\\2c 0px\\)-env\\(safe-area-inset-bottom\\2c 0px\\)-2rem\\)\\]{
  max-height: calc(100dvh - env(safe-area-inset-top,0px) - env(safe-area-inset-bottom,0px) - 2rem);
}

.max-h-\\[min\\(42dvh\\2c 100\\%\\)\\]{
  max-height: min(42dvh,100%);
}

.max-h-\\[min\\(85dvh\\2c 48rem\\)\\]{
  max-height: min(85dvh,48rem);
}

.max-h-\\[min\\(92dvh\\2c 560px\\)\\]{
  max-height: min(92dvh,560px);
}

.max-h-full{
  max-height: 100%;
}

.min-h-0{
  min-height: 0px;
}

.min-h-10{
  min-height: 2.5rem;
}

.min-h-\\[100dvh\\]{
  min-height: 100dvh;
}

.min-h-\\[120px\\]{
  min-height: 120px;
}

.min-h-\\[2\\.25rem\\]{
  min-height: 2.25rem;
}

.min-h-\\[2\\.75rem\\]{
  min-height: 2.75rem;
}

.min-h-\\[240px\\]{
  min-height: 240px;
}

.min-h-\\[2rem\\]{
  min-height: 2rem;
}

.min-h-\\[3\\.25rem\\]{
  min-height: 3.25rem;
}

.min-h-\\[3\\.5rem\\]{
  min-height: 3.5rem;
}

.min-h-\\[4\\.5rem\\]{
  min-height: 4.5rem;
}

.min-h-\\[40px\\]{
  min-height: 40px;
}

.min-h-\\[44px\\]{
  min-height: 44px;
}

.min-h-\\[4rem\\]{
  min-height: 4rem;
}

.min-h-\\[6\\.5rem\\]{
  min-height: 6.5rem;
}

.min-h-\\[64px\\]{
  min-height: 64px;
}

.min-h-\\[80px\\]{
  min-height: 80px;
}

.min-h-\\[88px\\]{
  min-height: 88px;
}

.min-h-full{
  min-height: 100%;
}

.min-h-screen{
  min-height: 100vh;
}

.w-0{
  width: 0px;
}

.w-1\\.5{
  width: 0.375rem;
}

.w-10{
  width: 2.5rem;
}

.w-11{
  width: 2.75rem;
}

.w-12{
  width: 3rem;
}

.w-14{
  width: 3.5rem;
}

.w-16{
  width: 4rem;
}

.w-2{
  width: 0.5rem;
}

.w-2\\.5{
  width: 0.625rem;
}

.w-2\\/5{
  width: 40%;
}

.w-20{
  width: 5rem;
}

.w-24{
  width: 6rem;
}

.w-3{
  width: 0.75rem;
}

.w-3\\.5{
  width: 0.875rem;
}

.w-32{
  width: 8rem;
}

.w-36{
  width: 9rem;
}

.w-4{
  width: 1rem;
}

.w-4\\/5{
  width: 80%;
}

.w-40{
  width: 10rem;
}

.w-48{
  width: 12rem;
}

.w-5{
  width: 1.25rem;
}

.w-6{
  width: 1.5rem;
}

.w-7{
  width: 1.75rem;
}

.w-8{
  width: 2rem;
}

.w-80{
  width: 20rem;
}

.w-9{
  width: 2.25rem;
}

.w-\\[176px\\]{
  width: 176px;
}

.w-\\[min\\(100vw-2rem\\2c 20rem\\)\\]{
  width: min(100vw - 2rem,20rem);
}

.w-\\[min\\(16rem\\2c calc\\(100vw-2rem\\)\\)\\]{
  width: min(16rem,calc(100vw - 2rem));
}

.w-auto{
  width: auto;
}

.w-full{
  width: 100%;
}

.min-w-0{
  min-width: 0px;
}

.min-w-\\[1\\.125rem\\]{
  min-width: 1.125rem;
}

.min-w-\\[1\\.25rem\\]{
  min-width: 1.25rem;
}

.min-w-\\[1\\.75rem\\]{
  min-width: 1.75rem;
}

.min-w-\\[1\\.85rem\\]{
  min-width: 1.85rem;
}

.min-w-\\[11rem\\]{
  min-width: 11rem;
}

.min-w-\\[168px\\]{
  min-width: 168px;
}

.min-w-\\[172px\\]{
  min-width: 172px;
}

.min-w-\\[2\\.25rem\\]{
  min-width: 2.25rem;
}

.min-w-\\[2\\.5rem\\]{
  min-width: 2.5rem;
}

.min-w-\\[2rem\\]{
  min-width: 2rem;
}

.min-w-\\[3\\.25rem\\]{
  min-width: 3.25rem;
}

.min-w-\\[800px\\]{
  min-width: 800px;
}

.min-w-full{
  min-width: 100%;
}

.max-w-24{
  max-width: 6rem;
}

.max-w-2xl{
  max-width: 42rem;
}

.max-w-32{
  max-width: 8rem;
}

.max-w-3xl{
  max-width: 48rem;
}

.max-w-4xl{
  max-width: 56rem;
}

.max-w-5xl{
  max-width: 64rem;
}

.max-w-6xl{
  max-width: 72rem;
}

.max-w-7xl{
  max-width: 80rem;
}

.max-w-\\[10rem\\]{
  max-width: 10rem;
}

.max-w-\\[11rem\\]{
  max-width: 11rem;
}

.max-w-\\[12rem\\]{
  max-width: 12rem;
}

.max-w-\\[14rem\\]{
  max-width: 14rem;
}

.max-w-\\[16rem\\]{
  max-width: 16rem;
}

.max-w-\\[200px\\]{
  max-width: 200px;
}

.max-w-\\[8rem\\]{
  max-width: 8rem;
}

.max-w-\\[9\\.5rem\\]{
  max-width: 9.5rem;
}

.max-w-\\[90\\%\\]{
  max-width: 90%;
}

.max-w-\\[9rem\\]{
  max-width: 9rem;
}

.max-w-\\[min\\(92vw\\2c 56rem\\)\\]{
  max-width: min(92vw,56rem);
}

.max-w-full{
  max-width: 100%;
}

.max-w-lg{
  max-width: 32rem;
}

.max-w-md{
  max-width: 28rem;
}

.max-w-sm{
  max-width: 24rem;
}

.max-w-xl{
  max-width: 36rem;
}

.max-w-xs{
  max-width: 20rem;
}

.flex-1{
  flex: 1 1;
}

.flex-shrink-0{
  flex-shrink: 0;
}

.shrink-0{
  flex-shrink: 0;
}

.grow{
  flex-grow: 1;
}

.origin-bottom{
  transform-origin: bottom;
}

.origin-center{
  transform-origin: center;
}

.origin-top{
  transform-origin: top;
}

.-translate-x-0\\.5{
  --tw-translate-x: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-0\\.5{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-150{
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

.animate-bounce{
  animation: bounce 1s infinite;
}

@keyframes pulse{

  50%{
    opacity: .5;
  }
}

.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.cursor-default{
  cursor: default;
}

.cursor-grab{
  cursor: grab;
}

.cursor-not-allowed{
  cursor: not-allowed;
}

.cursor-pointer{
  cursor: pointer;
}

.cursor-zoom-in{
  cursor: zoom-in;
}

.touch-none{
  touch-action: none;
}

.touch-pan-y{
  --tw-pan-y: pan-y;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}

.select-none{
  -webkit-user-select: none;
          user-select: none;
}

.resize-y{
  resize: vertical;
}

.resize{
  resize: both;
}

.snap-x{
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}

.snap-y{
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}

.snap-mandatory{
  --tw-scroll-snap-strictness: mandatory;
}

.snap-start{
  scroll-snap-align: start;
}

.snap-always{
  scroll-snap-stop: always;
}

.scroll-mt-28{
  scroll-margin-top: 7rem;
}

.list-inside{
  list-style-position: inside;
}

.list-disc{
  list-style-type: disc;
}

.list-none{
  list-style-type: none;
}

.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.grid-rows-\\[0fr\\]{
  grid-template-rows: 0fr;
}

.grid-rows-\\[1fr\\]{
  grid-template-rows: 1fr;
}

.flex-col{
  flex-direction: column;
}

.flex-col-reverse{
  flex-direction: column-reverse;
}

.flex-wrap{
  flex-wrap: wrap;
}

.place-items-center{
  place-items: center;
}

.items-start{
  align-items: flex-start;
}

.items-end{
  align-items: flex-end;
}

.items-center{
  align-items: center;
}

.items-baseline{
  align-items: baseline;
}

.items-stretch{
  align-items: stretch;
}

.justify-end{
  justify-content: flex-end;
}

.justify-center{
  justify-content: center;
}

.justify-between{
  justify-content: space-between;
}

.gap-0\\.5{
  gap: 0.125rem;
}

.gap-1{
  gap: 0.25rem;
}

.gap-1\\.5{
  gap: 0.375rem;
}

.gap-10{
  gap: 2.5rem;
}

.gap-2{
  gap: 0.5rem;
}

.gap-2\\.5{
  gap: 0.625rem;
}

.gap-3{
  gap: 0.75rem;
}

.gap-4{
  gap: 1rem;
}

.gap-5{
  gap: 1.25rem;
}

.gap-6{
  gap: 1.5rem;
}

.gap-8{
  gap: 2rem;
}

.gap-x-1{
  column-gap: 0.25rem;
}

.gap-x-1\\.5{
  column-gap: 0.375rem;
}

.gap-x-2{
  column-gap: 0.5rem;
}

.gap-x-3{
  column-gap: 0.75rem;
}

.gap-x-4{
  column-gap: 1rem;
}

.gap-y-0\\.5{
  row-gap: 0.125rem;
}

.gap-y-1{
  row-gap: 0.25rem;
}

.gap-y-1\\.5{
  row-gap: 0.375rem;
}

.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}

.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}

.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}

.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}

.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}

.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}

.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}

.divide-secondary-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}

.divide-secondary-100\\/90 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(241 245 249 / 0.9);
}

.divide-secondary-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-divide-opacity, 1));
}

.divide-secondary-200\\/80 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(226 232 240 / 0.8);
}

.divide-white\\/20 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.2);
}

.self-start{
  align-self: flex-start;
}

.self-end{
  align-self: flex-end;
}

.overflow-auto{
  overflow: auto;
}

.overflow-hidden{
  overflow: hidden;
}

.overflow-visible{
  overflow: visible;
}

.overflow-x-auto{
  overflow-x: auto;
}

.overflow-y-auto{
  overflow-y: auto;
}

.overflow-x-hidden{
  overflow-x: hidden;
}

.overscroll-contain{
  overscroll-behavior: contain;
}

.overscroll-x-none{
  overscroll-behavior-x: none;
}

.scroll-smooth{
  scroll-behavior: smooth;
}

.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whitespace-nowrap{
  white-space: nowrap;
}

.whitespace-pre-line{
  white-space: pre-line;
}

.whitespace-pre-wrap{
  white-space: pre-wrap;
}

.break-words{
  overflow-wrap: break-word;
}

.break-all{
  word-break: break-all;
}

.rounded{
  border-radius: 0.25rem;
}

.rounded-2xl{
  border-radius: 1rem;
}

.rounded-3xl{
  border-radius: 1.5rem;
}

.rounded-\\[inherit\\]{
  border-radius: inherit;
}

.rounded-full{
  border-radius: 9999px;
}

.rounded-lg{
  border-radius: 0.5rem;
}

.rounded-md{
  border-radius: 0.375rem;
}

.rounded-xl{
  border-radius: 0.75rem;
}

.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}

.rounded-tl-3xl{
  border-top-left-radius: 1.5rem;
}

.border{
  border-width: 1px;
}

.border-0{
  border-width: 0px;
}

.border-2{
  border-width: 2px;
}

.border-4{
  border-width: 4px;
}

.border-b{
  border-bottom-width: 1px;
}

.border-l{
  border-left-width: 1px;
}

.border-l-4{
  border-left-width: 4px;
}

.border-t{
  border-top-width: 1px;
}

.border-dashed{
  border-style: dashed;
}

.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}

.border-amber-200\\/50{
  border-color: rgb(253 230 138 / 0.5);
}

.border-amber-200\\/80{
  border-color: rgb(253 230 138 / 0.8);
}

.border-amber-300\\/60{
  border-color: rgb(252 211 77 / 0.6);
}

.border-amber-300\\/70{
  border-color: rgb(252 211 77 / 0.7);
}

.border-current{
  border-color: currentColor;
}

.border-cyan-200\\/70{
  border-color: rgb(165 243 252 / 0.7);
}

.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}

.border-emerald-100\\/50{
  border-color: rgb(209 250 229 / 0.5);
}

.border-emerald-200\\/70{
  border-color: rgb(167 243 208 / 0.7);
}

.border-error-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}

.border-error-200\\/70{
  border-color: rgb(254 202 202 / 0.7);
}

.border-error-200\\/80{
  border-color: rgb(254 202 202 / 0.8);
}

.border-error-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}

.border-orange-100\\/30{
  border-color: rgb(255 237 213 / 0.3);
}

.border-orange-100\\/40{
  border-color: rgb(255 237 213 / 0.4);
}

.border-orange-100\\/50{
  border-color: rgb(255 237 213 / 0.5);
}

.border-orange-100\\/60{
  border-color: rgb(255 237 213 / 0.6);
}

.border-orange-100\\/80{
  border-color: rgb(255 237 213 / 0.8);
}

.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}

.border-orange-200\\/30{
  border-color: rgb(254 215 170 / 0.3);
}

.border-orange-200\\/50{
  border-color: rgb(254 215 170 / 0.5);
}

.border-orange-200\\/60{
  border-color: rgb(254 215 170 / 0.6);
}

.border-orange-200\\/70{
  border-color: rgb(254 215 170 / 0.7);
}

.border-orange-200\\/80{
  border-color: rgb(254 215 170 / 0.8);
}

.border-orange-300\\/70{
  border-color: rgb(253 186 116 / 0.7);
}

.border-orange-300\\/80{
  border-color: rgb(253 186 116 / 0.8);
}

.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}

.border-orange-400\\/80{
  border-color: rgb(251 146 60 / 0.8);
}

.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}

.border-pink-200\\/80{
  border-color: rgb(251 207 232 / 0.8);
}

.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}

.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}

.border-secondary-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}

.border-secondary-100\\/90{
  border-color: rgb(241 245 249 / 0.9);
}

.border-secondary-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}

.border-secondary-200\\/40{
  border-color: rgb(226 232 240 / 0.4);
}

.border-secondary-200\\/50{
  border-color: rgb(226 232 240 / 0.5);
}

.border-secondary-200\\/60{
  border-color: rgb(226 232 240 / 0.6);
}

.border-secondary-200\\/70{
  border-color: rgb(226 232 240 / 0.7);
}

.border-secondary-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}

.border-secondary-200\\/90{
  border-color: rgb(226 232 240 / 0.9);
}

.border-secondary-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.border-secondary-300\\/60{
  border-color: rgb(203 213 225 / 0.6);
}

.border-secondary-300\\/70{
  border-color: rgb(203 213 225 / 0.7);
}

.border-secondary-300\\/80{
  border-color: rgb(203 213 225 / 0.8);
}

.border-secondary-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}

.border-sky-100\\/80{
  border-color: rgb(224 242 254 / 0.8);
}

.border-sky-200\\/70{
  border-color: rgb(186 230 253 / 0.7);
}

.border-sky-200\\/80{
  border-color: rgb(186 230 253 / 0.8);
}

.border-success-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}

.border-success-200\\/60{
  border-color: rgb(187 247 208 / 0.6);
}

.border-success-200\\/80{
  border-color: rgb(187 247 208 / 0.8);
}

.border-success-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}

.border-success-300\\/80{
  border-color: rgb(134 239 172 / 0.8);
}

.border-success-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}

.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity, 1));
}

.border-violet-200\\/60{
  border-color: rgb(221 214 254 / 0.6);
}

.border-violet-200\\/80{
  border-color: rgb(221 214 254 / 0.8);
}

.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}

.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}

.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}

.border-white\\/70{
  border-color: rgb(255 255 255 / 0.7);
}

.border-l-amber-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}

.border-l-orange-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}

.border-l-red-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.border-l-success-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}

.border-t-transparent{
  border-top-color: transparent;
}

.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.bg-\\[\\#229ED9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 158 217 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#25D366\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity, 1));
}

.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.bg-amber-100\\/90{
  background-color: rgb(254 243 199 / 0.9);
}

.bg-amber-300\\/25{
  background-color: rgb(252 211 77 / 0.25);
}

.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.bg-amber-50\\/60{
  background-color: rgb(255 251 235 / 0.6);
}

.bg-amber-50\\/80{
  background-color: rgb(255 251 235 / 0.8);
}

.bg-amber-50\\/90{
  background-color: rgb(255 251 235 / 0.9);
}

.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}

.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.bg-black\\/10{
  background-color: rgb(0 0 0 / 0.1);
}

.bg-black\\/15{
  background-color: rgb(0 0 0 / 0.15);
}

.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}

.bg-black\\/55{
  background-color: rgb(0 0 0 / 0.55);
}

.bg-blue-100\\/90{
  background-color: rgb(219 234 254 / 0.9);
}

.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}

.bg-cyan-100\\/90{
  background-color: rgb(207 250 254 / 0.9);
}

.bg-cyan-200{
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}

.bg-cyan-50\\/70{
  background-color: rgb(236 254 255 / 0.7);
}

.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}

.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.bg-emerald-100\\/90{
  background-color: rgb(209 250 229 / 0.9);
}

.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.bg-emerald-50\\/60{
  background-color: rgb(236 253 245 / 0.6);
}

.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}

.bg-error-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.bg-error-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}

.bg-error-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.bg-error-50\\/50{
  background-color: rgb(254 242 242 / 0.5);
}

.bg-error-50\\/60{
  background-color: rgb(254 242 242 / 0.6);
}

.bg-error-50\\/70{
  background-color: rgb(254 242 242 / 0.7);
}

.bg-error-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}

.bg-green-100\\/90{
  background-color: rgb(220 252 231 / 0.9);
}

.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

.bg-indigo-100\\/90{
  background-color: rgb(224 231 255 / 0.9);
}

.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}

.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.bg-lime-100\\/90{
  background-color: rgb(236 252 203 / 0.9);
}

.bg-lime-500{
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity, 1));
}

.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.bg-orange-100\\/90{
  background-color: rgb(255 237 213 / 0.9);
}

.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}

.bg-orange-200\\/30{
  background-color: rgb(254 215 170 / 0.3);
}

.bg-orange-200\\/70{
  background-color: rgb(254 215 170 / 0.7);
}

.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}

.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}

.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}

.bg-orange-50\\/20{
  background-color: rgb(255 247 237 / 0.2);
}

.bg-orange-50\\/30{
  background-color: rgb(255 247 237 / 0.3);
}

.bg-orange-50\\/40{
  background-color: rgb(255 247 237 / 0.4);
}

.bg-orange-50\\/50{
  background-color: rgb(255 247 237 / 0.5);
}

.bg-orange-50\\/75{
  background-color: rgb(255 247 237 / 0.75);
}

.bg-orange-50\\/80{
  background-color: rgb(255 247 237 / 0.8);
}

.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}

.bg-orange-500\\/10{
  background-color: rgb(249 115 22 / 0.1);
}

.bg-orange-500\\/20{
  background-color: rgb(249 115 22 / 0.2);
}

.bg-orange-500\\/90{
  background-color: rgb(249 115 22 / 0.9);
}

.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}

.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}

.bg-pink-100\\/90{
  background-color: rgb(252 231 243 / 0.9);
}

.bg-pink-50\\/80{
  background-color: rgb(253 242 248 / 0.8);
}

.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}

.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}

.bg-primary-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.bg-red-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}

.bg-rose-100\\/90{
  background-color: rgb(255 228 230 / 0.9);
}

.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}

.bg-secondary-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.bg-secondary-100\\/40{
  background-color: rgb(241 245 249 / 0.4);
}

.bg-secondary-100\\/50{
  background-color: rgb(241 245 249 / 0.5);
}

.bg-secondary-100\\/80{
  background-color: rgb(241 245 249 / 0.8);
}

.bg-secondary-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.bg-secondary-200\\/80{
  background-color: rgb(226 232 240 / 0.8);
}

.bg-secondary-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}

.bg-secondary-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}

.bg-secondary-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.bg-secondary-50\\/30{
  background-color: rgb(248 250 252 / 0.3);
}

.bg-secondary-50\\/40{
  background-color: rgb(248 250 252 / 0.4);
}

.bg-secondary-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}

.bg-secondary-50\\/60{
  background-color: rgb(248 250 252 / 0.6);
}

.bg-secondary-50\\/70{
  background-color: rgb(248 250 252 / 0.7);
}

.bg-secondary-50\\/80{
  background-color: rgb(248 250 252 / 0.8);
}

.bg-secondary-50\\/90{
  background-color: rgb(248 250 252 / 0.9);
}

.bg-secondary-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}

.bg-secondary-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}

.bg-secondary-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.bg-secondary-900\\/45{
  background-color: rgb(15 23 42 / 0.45);
}

.bg-secondary-900\\/50{
  background-color: rgb(15 23 42 / 0.5);
}

.bg-secondary-900\\/80{
  background-color: rgb(15 23 42 / 0.8);
}

.bg-secondary-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}

.bg-secondary-950\\/0{
  background-color: rgb(2 6 23 / 0);
}

.bg-secondary-950\\/55{
  background-color: rgb(2 6 23 / 0.55);
}

.bg-secondary-950\\/85{
  background-color: rgb(2 6 23 / 0.85);
}

.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}

.bg-sky-100\\/80{
  background-color: rgb(224 242 254 / 0.8);
}

.bg-sky-100\\/90{
  background-color: rgb(224 242 254 / 0.9);
}

.bg-sky-400\\/20{
  background-color: rgb(56 189 248 / 0.2);
}

.bg-sky-400\\/30{
  background-color: rgb(56 189 248 / 0.3);
}

.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}

.bg-sky-50\\/80{
  background-color: rgb(240 249 255 / 0.8);
}

.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}

.bg-success-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.bg-success-100\\/90{
  background-color: rgb(220 252 231 / 0.9);
}

.bg-success-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}

.bg-success-400\\/30{
  background-color: rgb(74 222 128 / 0.3);
}

.bg-success-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.bg-success-50\\/80{
  background-color: rgb(240 253 244 / 0.8);
}

.bg-success-50\\/90{
  background-color: rgb(240 253 244 / 0.9);
}

.bg-success-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

.bg-teal-100\\/90{
  background-color: rgb(204 251 241 / 0.9);
}

.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}

.bg-transparent{
  background-color: transparent;
}

.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}

.bg-violet-100\\/90{
  background-color: rgb(237 233 254 / 0.9);
}

.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}

.bg-violet-50\\/50{
  background-color: rgb(245 243 255 / 0.5);
}

.bg-violet-50\\/80{
  background-color: rgb(245 243 255 / 0.8);
}

.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}

.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}

.bg-warning-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.bg-warning-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}

.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}

.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}

.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}

.bg-white\\/25{
  background-color: rgb(255 255 255 / 0.25);
}

.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}

.bg-white\\/35{
  background-color: rgb(255 255 255 / 0.35);
}

.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}

.bg-white\\/45{
  background-color: rgb(255 255 255 / 0.45);
}

.bg-white\\/55{
  background-color: rgb(255 255 255 / 0.55);
}

.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}

.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}

.bg-white\\/75{
  background-color: rgb(255 255 255 / 0.75);
}

.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}

.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}

.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}

.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}

.bg-yellow-100\\/90{
  background-color: rgb(254 249 195 / 0.9);
}

.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}

.bg-\\[radial-gradient\\(circle_at_top\\2c rgba\\(249\\2c 115\\2c 22\\2c 0\\.35\\)\\2c transparent_55\\%\\)\\]{
  background-image: radial-gradient(circle at top,rgba(249,115,22,0.35),transparent 55%);
}

.bg-\\[repeating-linear-gradient\\(to_bottom\\2c transparent\\2c transparent_27px\\2c rgba\\(148\\2c 163\\2c 184\\2c 0\\.12\\)_27px\\2c rgba\\(148\\2c 163\\2c 184\\2c 0\\.12\\)_28px\\)\\]{
  background-image: repeating-linear-gradient(to bottom,transparent,transparent 27px,rgba(148,163,184,0.12) 27px,rgba(148,163,184,0.12) 28px);
}

.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}

.bg-gradient-to-tl{
  background-image: linear-gradient(to top left, var(--tw-gradient-stops));
}

.\\!from-success-600{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}

.from-amber-400{
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-amber-50{
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-amber-50\\/50{
  --tw-gradient-from: rgb(255 251 235 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-amber-500{
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-amber-500\\/10{
  --tw-gradient-from: rgb(245 158 11 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-amber-700{
  --tw-gradient-from: #b45309 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(180 83 9 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-black\\/55{
  --tw-gradient-from: rgb(0 0 0 / 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-emerald-400{
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-emerald-50{
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-error-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-green-500{
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-indigo-400{
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-100{
  --tw-gradient-from: #ffedd5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 237 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-400{
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-400\\/10{
  --tw-gradient-from: rgb(251 146 60 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-50{
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-50\\/40{
  --tw-gradient-from: rgb(255 247 237 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-50\\/50{
  --tw-gradient-from: rgb(255 247 237 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-50\\/80{
  --tw-gradient-from: rgb(255 247 237 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-50\\/90{
  --tw-gradient-from: rgb(255 247 237 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-500{
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-500\\/10{
  --tw-gradient-from: rgb(249 115 22 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-500\\/5{
  --tw-gradient-from: rgb(249 115 22 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-orange-600{
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-red-400{
  --tw-gradient-from: #f87171 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 113 113 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-red-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-rose-400{
  --tw-gradient-from: #fb7185 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 113 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-rose-500{
  --tw-gradient-from: #f43f5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-200{
  --tw-gradient-from: #e2e8f0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-300{
  --tw-gradient-from: #cbd5e1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(203 213 225 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-400{
  --tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-400\\/80{
  --tw-gradient-from: rgb(148 163 184 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-50{
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-50\\/50{
  --tw-gradient-from: rgb(248 250 252 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-50\\/95{
  --tw-gradient-from: rgb(248 250 252 / 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-secondary-900\\/40{
  --tw-gradient-from: rgb(15 23 42 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-sky-400{
  --tw-gradient-from: #38bdf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-sky-50{
  --tw-gradient-from: #f0f9ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 249 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-sky-500{
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-sky-500\\/10{
  --tw-gradient-from: rgb(14 165 233 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-slate-400{
  --tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-slate-50{
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-slate-600{
  --tw-gradient-from: #475569 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(71 85 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-success-400{
  --tw-gradient-from: #4ade80 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(74 222 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-success-50\\/50{
  --tw-gradient-from: rgb(240 253 244 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-success-500{
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-violet-400{
  --tw-gradient-from: #a78bfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(167 139 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-violet-500{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-violet-600{
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-white\\/10{
  --tw-gradient-from: rgb(255 255 255 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-white\\/25{
  --tw-gradient-from: rgb(255 255 255 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-white\\/50{
  --tw-gradient-from: rgb(255 255 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-white\\/90{
  --tw-gradient-from: rgb(255 255 255 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-yellow-500{
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.via-amber-50{
  --tw-gradient-to: rgb(255 251 235 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fffbeb var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-amber-500{
  --tw-gradient-to: rgb(245 158 11 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f59e0b var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-amber-500\\/5{
  --tw-gradient-to: rgb(245 158 11 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(245 158 11 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-black\\/20{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-orange-400\\/40{
  --tw-gradient-to: rgb(251 146 60 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(251 146 60 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-secondary-200\\/80{
  --tw-gradient-to: rgb(226 232 240 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(226 232 240 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-white\\/25{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.25) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-white\\/50{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.\\!to-emerald-600{
  --tw-gradient-to: #059669 var(--tw-gradient-to-position) !important;
}

.to-amber-400{
  --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
}

.to-amber-400\\/5{
  --tw-gradient-to: rgb(251 191 36 / 0.05) var(--tw-gradient-to-position);
}

.to-amber-50{
  --tw-gradient-to: #fffbeb var(--tw-gradient-to-position);
}

.to-amber-50\\/20{
  --tw-gradient-to: rgb(255 251 235 / 0.2) var(--tw-gradient-to-position);
}

.to-amber-50\\/30{
  --tw-gradient-to: rgb(255 251 235 / 0.3) var(--tw-gradient-to-position);
}

.to-amber-50\\/40{
  --tw-gradient-to: rgb(255 251 235 / 0.4) var(--tw-gradient-to-position);
}

.to-amber-50\\/50{
  --tw-gradient-to: rgb(255 251 235 / 0.5) var(--tw-gradient-to-position);
}

.to-amber-500{
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}

.to-amber-500\\/10{
  --tw-gradient-to: rgb(245 158 11 / 0.1) var(--tw-gradient-to-position);
}

.to-amber-500\\/5{
  --tw-gradient-to: rgb(245 158 11 / 0.05) var(--tw-gradient-to-position);
}

.to-amber-600{
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}

.to-blue-50\\/80{
  --tw-gradient-to: rgb(239 246 255 / 0.8) var(--tw-gradient-to-position);
}

.to-blue-500\\/10{
  --tw-gradient-to: rgb(59 130 246 / 0.1) var(--tw-gradient-to-position);
}

.to-blue-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}

.to-emerald-400{
  --tw-gradient-to: #34d399 var(--tw-gradient-to-position);
}

.to-emerald-50\\/30{
  --tw-gradient-to: rgb(236 253 245 / 0.3) var(--tw-gradient-to-position);
}

.to-emerald-500{
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}

.to-emerald-600{
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}

.to-error-600{
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}

.to-indigo-500{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}

.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}

.to-orange-200{
  --tw-gradient-to: #fed7aa var(--tw-gradient-to-position);
}

.to-orange-400{
  --tw-gradient-to: #fb923c var(--tw-gradient-to-position);
}

.to-orange-50{
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}

.to-orange-50\\/25{
  --tw-gradient-to: rgb(255 247 237 / 0.25) var(--tw-gradient-to-position);
}

.to-orange-50\\/30{
  --tw-gradient-to: rgb(255 247 237 / 0.3) var(--tw-gradient-to-position);
}

.to-orange-50\\/50{
  --tw-gradient-to: rgb(255 247 237 / 0.5) var(--tw-gradient-to-position);
}

.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}

.to-orange-500\\/10{
  --tw-gradient-to: rgb(249 115 22 / 0.1) var(--tw-gradient-to-position);
}

.to-orange-600{
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}

.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}

.to-pink-600{
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}

.to-purple-500{
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}

.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}

.to-red-500{
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}

.to-red-600{
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}

.to-rose-600{
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}

.to-secondary-100{
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);
}

.to-secondary-300{
  --tw-gradient-to: #cbd5e1 var(--tw-gradient-to-position);
}

.to-secondary-400{
  --tw-gradient-to: #94a3b8 var(--tw-gradient-to-position);
}

.to-secondary-50\\/70{
  --tw-gradient-to: rgb(248 250 252 / 0.7) var(--tw-gradient-to-position);
}

.to-secondary-500{
  --tw-gradient-to: #64748b var(--tw-gradient-to-position);
}

.to-secondary-600{
  --tw-gradient-to: #475569 var(--tw-gradient-to-position);
}

.to-sky-600{
  --tw-gradient-to: #0284c7 var(--tw-gradient-to-position);
}

.to-slate-500{
  --tw-gradient-to: #64748b var(--tw-gradient-to-position);
}

.to-slate-800{
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}

.to-success-600{
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}

.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}

.to-teal-600{
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}

.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

.to-violet-600{
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}

.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}

.to-white\\/10{
  --tw-gradient-to: rgb(255 255 255 / 0.1) var(--tw-gradient-to-position);
}

.to-white\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0.6) var(--tw-gradient-to-position);
}

.stroke-\\[1\\.5\\]{
  stroke-width: 1.5;
}

.object-contain{
  object-fit: contain;
}

.object-cover{
  object-fit: cover;
}

.object-center{
  object-position: center;
}

.p-0{
  padding: 0px;
}

.p-0\\.5{
  padding: 0.125rem;
}

.p-1{
  padding: 0.25rem;
}

.p-1\\.5{
  padding: 0.375rem;
}

.p-10{
  padding: 2.5rem;
}

.p-12{
  padding: 3rem;
}

.p-2{
  padding: 0.5rem;
}

.p-2\\.5{
  padding: 0.625rem;
}

.p-3{
  padding: 0.75rem;
}

.p-3\\.5{
  padding: 0.875rem;
}

.p-4{
  padding: 1rem;
}

.p-5{
  padding: 1.25rem;
}

.p-6{
  padding: 1.5rem;
}

.p-8{
  padding: 2rem;
}

.\\!px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.\\!py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.\\!py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.px-0{
  padding-left: 0px;
  padding-right: 0px;
}

.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}

.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}

.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}

.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}

.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.pb-1{
  padding-bottom: 0.25rem;
}

.pb-10{
  padding-bottom: 2.5rem;
}

.pb-16{
  padding-bottom: 4rem;
}

.pb-3{
  padding-bottom: 0.75rem;
}

.pb-3\\.5{
  padding-bottom: 0.875rem;
}

.pb-4{
  padding-bottom: 1rem;
}

.pb-6{
  padding-bottom: 1.5rem;
}

.pb-8{
  padding-bottom: 2rem;
}

.pb-\\[max\\(1rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(1rem,env(safe-area-inset-bottom));
}

.pl-10{
  padding-left: 2.5rem;
}

.pl-2{
  padding-left: 0.5rem;
}

.pl-5{
  padding-left: 1.25rem;
}

.pl-9{
  padding-left: 2.25rem;
}

.pr-1{
  padding-right: 0.25rem;
}

.pr-10{
  padding-right: 2.5rem;
}

.pr-11{
  padding-right: 2.75rem;
}

.pr-12{
  padding-right: 3rem;
}

.pr-16{
  padding-right: 4rem;
}

.pr-2{
  padding-right: 0.5rem;
}

.pr-3{
  padding-right: 0.75rem;
}

.pr-8{
  padding-right: 2rem;
}

.pr-9{
  padding-right: 2.25rem;
}

.pt-0{
  padding-top: 0px;
}

.pt-0\\.5{
  padding-top: 0.125rem;
}

.pt-1{
  padding-top: 0.25rem;
}

.pt-10{
  padding-top: 2.5rem;
}

.pt-2{
  padding-top: 0.5rem;
}

.pt-2\\.5{
  padding-top: 0.625rem;
}

.pt-24{
  padding-top: 6rem;
}

.pt-3{
  padding-top: 0.75rem;
}

.pt-4{
  padding-top: 1rem;
}

.pt-5{
  padding-top: 1.25rem;
}

.pt-6{
  padding-top: 1.5rem;
}

.pt-\\[4\\.25rem\\]{
  padding-top: 4.25rem;
}

.text-left{
  text-align: left;
}

.text-center{
  text-align: center;
}

.text-right{
  text-align: right;
}

.font-mono{
  font-family: Ubuntu Mono, Monaco, Cascadia Code, Segoe UI Mono, Roboto Mono, monospace;
}

.\\!text-base{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}

.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-2xs{
  font-size: 0.625rem;
  line-height: 0.75rem;
}

.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-\\[0\\.68rem\\]{
  font-size: 0.68rem;
}

.text-\\[10px\\]{
  font-size: 10px;
}

.text-\\[11px\\]{
  font-size: 11px;
}

.text-\\[15px\\]{
  font-size: 15px;
}

.text-\\[9px\\]{
  font-size: 9px;
}

.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-bold{
  font-weight: 700;
}

.font-medium{
  font-weight: 500;
}

.font-normal{
  font-weight: 400;
}

.font-semibold{
  font-weight: 600;
}

.uppercase{
  text-transform: uppercase;
}

.capitalize{
  text-transform: capitalize;
}

.italic{
  font-style: italic;
}

.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}

.leading-5{
  line-height: 1.25rem;
}

.leading-none{
  line-height: 1;
}

.leading-relaxed{
  line-height: 1.625;
}

.leading-snug{
  line-height: 1.375;
}

.leading-tight{
  line-height: 1.25;
}

.tracking-\\[-0\\.01em\\]{
  letter-spacing: -0.01em;
}

.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}

.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}

.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}

.tracking-\\[0\\.22em\\]{
  letter-spacing: 0.22em;
}

.tracking-\\[0\\.25em\\]{
  letter-spacing: 0.25em;
}

.tracking-tight{
  letter-spacing: -0.025em;
}

.tracking-wide{
  letter-spacing: 0.025em;
}

.tracking-wider{
  letter-spacing: 0.05em;
}

.\\!text-amber-700{
  --tw-text-opacity: 1 !important;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1)) !important;
}

.\\!text-emerald-700{
  --tw-text-opacity: 1 !important;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1)) !important;
}

.\\!text-indigo-700{
  --tw-text-opacity: 1 !important;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1)) !important;
}

.\\!text-orange-700{
  --tw-text-opacity: 1 !important;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1)) !important;
}

.\\!text-rose-700{
  --tw-text-opacity: 1 !important;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1)) !important;
}

.\\!text-secondary-700{
  --tw-text-opacity: 1 !important;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1)) !important;
}

.\\!text-sky-700{
  --tw-text-opacity: 1 !important;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1)) !important;
}

.\\!text-violet-700{
  --tw-text-opacity: 1 !important;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1)) !important;
}

.text-amber-300\\/70{
  color: rgb(252 211 77 / 0.7);
}

.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.text-amber-400\\/90{
  color: rgb(251 191 36 / 0.9);
}

.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}

.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}

.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}

.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}

.text-amber-800\\/90{
  color: rgb(146 64 14 / 0.9);
}

.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}

.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}

.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}

.text-cyan-900{
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}

.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}

.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}

.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}

.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}

.text-emerald-800\\/90{
  color: rgb(6 95 70 / 0.9);
}

.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}

.text-error-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.text-error-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.text-error-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.text-error-700\\/90{
  color: rgb(185 28 28 / 0.9);
}

.text-error-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.text-error-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}

.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}

.text-inherit{
  color: inherit;
}

.text-lime-600{
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity, 1));
}

.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}

.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}

.text-orange-600\\/90{
  color: rgb(234 88 12 / 0.9);
}

.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}

.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}

.text-orange-900{
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}

.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}

.text-pink-900{
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / var(--tw-text-opacity, 1));
}

.text-primary-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}

.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}

.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}

.text-rose-900{
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}

.text-secondary-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.text-secondary-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.text-secondary-400\\/25{
  color: rgb(148 163 184 / 0.25);
}

.text-secondary-400\\/70{
  color: rgb(148 163 184 / 0.7);
}

.text-secondary-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.text-secondary-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.text-secondary-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.text-secondary-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}

.text-secondary-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}

.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}

.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}

.text-success-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.text-success-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.text-success-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.text-success-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}

.text-success-800\\/90{
  color: rgb(22 101 52 / 0.9);
}

.text-success-900{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}

.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}

.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}

.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}

.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}

.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}

.text-warning-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}

.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}

.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}

.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}

.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}

.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}

.underline{
  text-decoration-line: underline;
}

.line-through{
  text-decoration-line: line-through;
}

.decoration-orange-300{
  text-decoration-color: #fdba74;
}

.decoration-secondary-300\\/60{
  text-decoration-color: rgb(203 213 225 / 0.6);
}

.underline-offset-2{
  text-underline-offset: 2px;
}

.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.opacity-0{
  opacity: 0;
}

.opacity-10{
  opacity: 0.1;
}

.opacity-100{
  opacity: 1;
}

.opacity-15{
  opacity: 0.15;
}

.opacity-20{
  opacity: 0.2;
}

.opacity-30{
  opacity: 0.3;
}

.opacity-40{
  opacity: 0.4;
}

.opacity-50{
  opacity: 0.5;
}

.opacity-55{
  opacity: 0.55;
}

.opacity-60{
  opacity: 0.6;
}

.opacity-70{
  opacity: 0.7;
}

.opacity-75{
  opacity: 0.75;
}

.opacity-80{
  opacity: 0.8;
}

.opacity-90{
  opacity: 0.9;
}

.opacity-95{
  opacity: 0.95;
}

.opacity-\\[0\\.07\\]{
  opacity: 0.07;
}

.mix-blend-multiply{
  mix-blend-mode: multiply;
}

.\\!shadow-\\[0_8px_24px_rgba\\(22\\2c 163\\2c 74\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 8px 24px rgba(22,163,74,0.28) !important;
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_-8px_40px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 -8px 40px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 -8px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_0_12px_rgba\\(249\\2c 115\\2c 22\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 0 12px rgba(249,115,22,0.45);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_0_14px_rgba\\(249\\2c 115\\2c 22\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 0 14px rgba(249,115,22,0.35);
  --tw-shadow-colored: 0 0 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_12px_32px_rgba\\(249\\2c 115\\2c 22\\2c 0\\.14\\)\\]{
  --tw-shadow: 0 12px 32px rgba(249,115,22,0.14);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_1px_6px_rgba\\(249\\2c 115\\2c 22\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 1px 6px rgba(249,115,22,0.25);
  --tw-shadow-colored: 0 1px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_24px_64px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.22\\)\\]{
  --tw-shadow: 0 24px 64px rgba(15,23,42,0.22);
  --tw-shadow-colored: 0 24px 64px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_2px_6px_-1px_rgba\\(249\\2c 115\\2c 22\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 2px 6px -1px rgba(249,115,22,0.3);
  --tw-shadow-colored: 0 2px 6px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_4px_18px_-4px_rgba\\(249\\2c 115\\2c 22\\2c 0\\.1\\)\\2c 0_14px_34px_-12px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 4px 18px -4px rgba(249,115,22,0.1),0 14px 34px -12px rgba(15,23,42,0.18);
  --tw-shadow-colored: 0 4px 18px -4px var(--tw-shadow-color), 0 14px 34px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_8px_24px_rgba\\(139\\2c 92\\2c 246\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 8px 24px rgba(139,92,246,0.28);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_8px_24px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 8px 24px rgba(239,68,68,0.28);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_8px_24px_rgba\\(245\\2c 158\\2c 11\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 8px 24px rgba(245,158,11,0.28);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_8px_24px_rgba\\(249\\2c 115\\2c 22\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 8px 24px rgba(249,115,22,0.28);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.55\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.55);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.6\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.65\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.65);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.85\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.85);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[inset_0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]{
  --tw-shadow: inset 0 1px 2px rgba(15,23,42,0.06);
  --tw-shadow-colored: inset 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-elegant{
  --tw-shadow: 0 4px 20px -2px rgba(249, 115, 22, 0.1), 0 25px 50px -12px rgba(15, 23, 42, 0.12);
  --tw-shadow-colored: 0 4px 20px -2px var(--tw-shadow-color), 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-glow{
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-glow-lg{
  --tw-shadow: 0 0 40px rgba(249, 115, 22, 0.28), 0 8px 24px rgba(251, 146, 60, 0.12);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color), 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-medium{
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-premium{
  --tw-shadow: 0 1px 0 rgba(255,255,255,0.6) inset, 0 4px 24px -4px rgba(249, 115, 22, 0.15), 0 12px 40px -8px rgba(15, 23, 42, 0.1);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 4px 24px -4px var(--tw-shadow-color), 0 12px 40px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-soft{
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-green-500\\/25{
  --tw-shadow-color: rgb(34 197 94 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.shadow-orange-500\\/30{
  --tw-shadow-color: rgb(249 115 22 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.shadow-secondary-500\\/20{
  --tw-shadow-color: rgb(100 116 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.shadow-sky-500\\/25{
  --tw-shadow-color: rgb(14 165 233 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}

.shadow-sky-500\\/30{
  --tw-shadow-color: rgb(14 165 233 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.shadow-success-500\\/15{
  --tw-shadow-color: rgb(34 197 94 / 0.15);
  --tw-shadow: var(--tw-shadow-colored);
}

.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline{
  outline-style: solid;
}

.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-inset{
  --tw-ring-inset: inset;
}

.\\!ring-success-400\\/30{
  --tw-ring-color: rgb(74 222 128 / 0.3) !important;
}

.ring-amber-200\\/70{
  --tw-ring-color: rgb(253 230 138 / 0.7);
}

.ring-amber-600\\/20{
  --tw-ring-color: rgb(217 119 6 / 0.2);
}

.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}

.ring-black\\/\\[0\\.04\\]{
  --tw-ring-color: rgb(0 0 0 / 0.04);
}

.ring-emerald-200\\/70{
  --tw-ring-color: rgb(167 243 208 / 0.7);
}

.ring-emerald-600\\/20{
  --tw-ring-color: rgb(5 150 105 / 0.2);
}

.ring-error-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}

.ring-error-400\\/30{
  --tw-ring-color: rgb(248 113 113 / 0.3);
}

.ring-error-500\\/40{
  --tw-ring-color: rgb(239 68 68 / 0.4);
}

.ring-error-500\\/60{
  --tw-ring-color: rgb(239 68 68 / 0.6);
}

.ring-indigo-600\\/20{
  --tw-ring-color: rgb(79 70 229 / 0.2);
}

.ring-orange-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 237 213 / var(--tw-ring-opacity, 1));
}

.ring-orange-100\\/60{
  --tw-ring-color: rgb(255 237 213 / 0.6);
}

.ring-orange-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}

.ring-orange-200\\/60{
  --tw-ring-color: rgb(254 215 170 / 0.6);
}

.ring-orange-200\\/70{
  --tw-ring-color: rgb(254 215 170 / 0.7);
}

.ring-orange-200\\/80{
  --tw-ring-color: rgb(254 215 170 / 0.8);
}

.ring-orange-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity, 1));
}

.ring-orange-300\\/80{
  --tw-ring-color: rgb(253 186 116 / 0.8);
}

.ring-orange-400\\/20{
  --tw-ring-color: rgb(251 146 60 / 0.2);
}

.ring-orange-400\\/25{
  --tw-ring-color: rgb(251 146 60 / 0.25);
}

.ring-orange-400\\/30{
  --tw-ring-color: rgb(251 146 60 / 0.3);
}

.ring-orange-500\\/30{
  --tw-ring-color: rgb(249 115 22 / 0.3);
}

.ring-orange-600\\/20{
  --tw-ring-color: rgb(234 88 12 / 0.2);
}

.ring-primary-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}

.ring-red-200\\/70{
  --tw-ring-color: rgb(254 202 202 / 0.7);
}

.ring-rose-600\\/20{
  --tw-ring-color: rgb(225 29 72 / 0.2);
}

.ring-secondary-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}

.ring-secondary-200\\/40{
  --tw-ring-color: rgb(226 232 240 / 0.4);
}

.ring-secondary-200\\/50{
  --tw-ring-color: rgb(226 232 240 / 0.5);
}

.ring-secondary-200\\/60{
  --tw-ring-color: rgb(226 232 240 / 0.6);
}

.ring-secondary-200\\/70{
  --tw-ring-color: rgb(226 232 240 / 0.7);
}

.ring-secondary-500\\/20{
  --tw-ring-color: rgb(100 116 139 / 0.2);
}

.ring-sky-600\\/20{
  --tw-ring-color: rgb(2 132 199 / 0.2);
}

.ring-success-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}

.ring-success-200\\/50{
  --tw-ring-color: rgb(187 247 208 / 0.5);
}

.ring-success-200\\/60{
  --tw-ring-color: rgb(187 247 208 / 0.6);
}

.ring-success-300\\/50{
  --tw-ring-color: rgb(134 239 172 / 0.5);
}

.ring-success-300\\/70{
  --tw-ring-color: rgb(134 239 172 / 0.7);
}

.ring-success-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 222 128 / var(--tw-ring-opacity, 1));
}

.ring-violet-400\\/30{
  --tw-ring-color: rgb(167 139 250 / 0.3);
}

.ring-violet-500\\/20{
  --tw-ring-color: rgb(139 92 246 / 0.2);
}

.ring-violet-600\\/20{
  --tw-ring-color: rgb(124 58 237 / 0.2);
}

.ring-warning-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}

.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.ring-white\\/25{
  --tw-ring-color: rgb(255 255 255 / 0.25);
}

.ring-white\\/30{
  --tw-ring-color: rgb(255 255 255 / 0.3);
}

.ring-white\\/35{
  --tw-ring-color: rgb(255 255 255 / 0.35);
}

.ring-white\\/40{
  --tw-ring-color: rgb(255 255 255 / 0.4);
}

.ring-white\\/50{
  --tw-ring-color: rgb(255 255 255 / 0.5);
}

.ring-white\\/60{
  --tw-ring-color: rgb(255 255 255 / 0.6);
}

.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.blur-\\[2px\\]{
  --tw-blur: blur(2px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.brightness-75{
  --tw-brightness: brightness(.75);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.brightness-90{
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-\\[1px\\]{
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-\\[6px\\]{
  --tw-backdrop-blur: blur(6px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-none{
  --tw-backdrop-blur:  ;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-saturate-150{
  --tw-backdrop-saturate: saturate(1.5);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[background-color\\2c border-color\\2c box-shadow\\2c transform\\]{
  transition-property: background-color,border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[background-color\\2c border-color\\]{
  transition-property: background-color,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[background-color\\2c box-shadow\\2c border-color\\2c backdrop-filter\\]{
  transition-property: background-color,box-shadow,border-color,backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[background-color\\2c box-shadow\\2c border-color\\]{
  transition-property: background-color,box-shadow,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[background-color\\2c box-shadow\\]{
  transition-property: background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[background-color\\2c transform\\2c box-shadow\\]{
  transition-property: background-color,transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[border-color\\2c background-color\\2c box-shadow\\2c transform\\]{
  transition-property: border-color,background-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[border-color\\2c background-color\\2c box-shadow\\]{
  transition-property: border-color,background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[border-color\\2c background-color\\]{
  transition-property: border-color,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[border-color\\2c box-shadow\\2c background-color\\]{
  transition-property: border-color,box-shadow,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[border-color\\2c box-shadow\\]{
  transition-property: border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[box-shadow\\2c transform\\]{
  transition-property: box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c background-color\\2c border-color\\2c box-shadow\\2c ring-color\\2c transform\\]{
  transition-property: color,background-color,border-color,box-shadow,ring-color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c background-color\\2c border-color\\2c box-shadow\\2c transform\\]{
  transition-property: color,background-color,border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c background-color\\2c box-shadow\\2c transform\\]{
  transition-property: color,background-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c background-color\\2c box-shadow\\]{
  transition-property: color,background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c background-color\\2c transform\\]{
  transition-property: color,background-color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c background-color\\]{
  transition-property: color,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c box-shadow\\2c transform\\]{
  transition-property: color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[color\\2c transform\\2c opacity\\]{
  transition-property: color,transform,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[grid-template-rows\\2c opacity\\]{
  transition-property: grid-template-rows,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[margin-left\\]{
  transition-property: margin-left;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[transform\\2c background-color\\2c border-color\\2c box-shadow\\]{
  transition-property: transform,background-color,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[transform\\2c box-shadow\\]{
  transition-property: transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-150{
  transition-duration: 150ms;
}

.duration-200{
  transition-duration: 200ms;
}

.duration-300{
  transition-duration: 300ms;
}

.duration-500{
  transition-duration: 500ms;
}

.duration-\\[450ms\\]{
  transition-duration: 450ms;
}

.ease-\\[cubic-bezier\\(0\\.22\\2c 1\\2c 0\\.36\\2c 1\\)\\]{
  transition-timing-function: cubic-bezier(0.22,1,0.36,1);
}

.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.\\[-ms-overflow-style\\:none\\]{
  -ms-overflow-style: none;
}

.\\[animation-delay\\:-0\\.15s\\]{
  animation-delay: -0.15s;
}

.\\[animation-delay\\:-0\\.3s\\]{
  animation-delay: -0.3s;
}

.\\[scrollbar-width\\:none\\]{
  scrollbar-width: none;
}

.\\[scrollbar-width\\:thin\\]{
  scrollbar-width: thin;
}

.\\[transform\\:translateZ\\(0\\)\\]{
  transform: translateZ(0);
}
/* Enhanced Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track{
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
::-webkit-scrollbar-thumb{
  border-radius: 9999px;
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  --tw-gradient-from: rgb(253 186 116 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 186 116 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
@supports (color: rgb(0 0 0 / 0)){
::-webkit-scrollbar-thumb{
    --tw-gradient-to: rgb(251 146 60 / 0.9) var(--tw-gradient-to-position);
  }
}
::-webkit-scrollbar-thumb:hover{
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
::-webkit-scrollbar-corner{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
/* Firefox scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: rgb(251 146 60 / 0.7) rgb(248 250 252);
}
/* Keep card-premium shadow animation above utility classes (e.g. shadow-premium). */
.card-premium {
  box-shadow:
    0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),
    0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));
  transform: translateY(var(--card-lift));
  transition:
    --card-lift var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-spread var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-y2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-blur2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    --card-shadow-alpha2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    transform var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    border-color var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),
    box-shadow var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1));
}
/* Scoped transitions — avoid fighting Framer mount animations on every node */
a:not(.card-premium),
button:not(.card-premium),
input,
select,
textarea,
.card,
.card-glass,
.card-gradient,
.btn-primary,
.btn-secondary,
.btn-ghost,
.btn-accent,
.interactive-lift:not(.card-premium),
.filter-chip {
  transition-property: color, background-color, border-color, box-shadow, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;
}
/* Print styles */
@media print {
  .no-print {
    display: none !important;
  }
  * {
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
/* iOS auto-zoom guard: inputs under 16px zoom the whole page on focus (phones/small tablets).
   :not() chain raises specificity above inline .text-sm utilities on touch form factors. */
@media (max-width: 768px) {
  input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='button']):not([type='submit']):not([type='reset']):not([type='image']),
  select,
  textarea {
    font-size: 16px;
  }
}
/* Hero depth background — scrolls with viewport scenes track */
.hero-depth-scene {
  isolation: isolate;
}
.hero-depth-scene--fixed {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100dvh;
}
.hero-depth-scene__base {
  position: absolute;
  inset: 0;
}
.hero-depth-scene__base--track {
  background: linear-gradient(
    180deg,
    rgb(255 247 237 / 0.98) 0%,
    rgb(255 255 255 / 0.94) 14%,
    rgb(255 250 247 / 0.92) 28%,
    rgb(255 237 213 / 0.5) 46%,
    rgb(255 255 255 / 0.9) 64%,
    rgb(255 247 237 / 0.88) 80%,
    rgb(254 226 210 / 0.48) 100%
  );
}
.hero-depth-scene__mesh {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(ellipse 52% 42% at 12% 18%, rgb(251 146 60 / 0.14), transparent 72%),
    radial-gradient(ellipse 48% 38% at 88% 28%, rgb(249 115 22 / 0.1), transparent 70%),
    radial-gradient(ellipse 55% 45% at 72% 82%, rgb(245 158 11 / 0.08), transparent 68%),
    radial-gradient(ellipse 60% 50% at 50% 100%, rgb(254 226 210 / 0.22), transparent 62%);
}
.hero-depth-scene__field {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0.28;
  background-image: radial-gradient(circle, rgb(251 146 60 / 0.14) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: radial-gradient(ellipse 90% 75% at 50% 40%, rgb(0 0 0 / 0.7) 15%, transparent 78%);
}
.hero-depth-scene__horizon {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    transparent 0%,
    transparent 42%,
    rgb(251 146 60 / 0.04) 52%,
    rgb(249 115 22 / 0.07) 58%,
    transparent 68%
  );
}
.hero-depth-scene__vignette {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: radial-gradient(
    ellipse 78% 68% at 50% 44%,
    transparent 34%,
    rgb(255 237 213 / 0.16) 100%
  );
  pointer-events: none;
}
.hero-depth-scene__stage {
  position: absolute;
  inset: 0;
  z-index: 2;
  perspective: 1200px;
  perspective-origin: 50% 50%;
  transform-style: preserve-3d;
}
.hero-depth-scene__ambient {
  position: absolute;
  inset: 0;
}
.hero-depth-scene__ambient--track .hero-depth-scene__orb-anchor {
  position: absolute;
  transform: translate(-50%, -50%);
}
.hero-depth-scene__orb {
  position: relative;
  border-radius: 9999px;
}
.hero-depth-scene__orb--sm {
  width: min(16rem, 34vw);
  height: min(16rem, 34vw);
  background: radial-gradient(
    circle at center,
    rgb(251 146 60 / 0.2) 0%,
    rgb(251 146 60 / 0.09) 36%,
    rgb(251 146 60 / 0.025) 58%,
    transparent 72%
  );
}
.hero-depth-scene__orb--md {
  width: min(20rem, 40vw);
  height: min(20rem, 40vw);
  background: radial-gradient(
    circle at center,
    rgb(249 115 22 / 0.17) 0%,
    rgb(249 115 22 / 0.075) 36%,
    rgb(249 115 22 / 0.02) 58%,
    transparent 72%
  );
}
.hero-depth-scene__orb--lg {
  width: min(24rem, 46vw);
  height: min(24rem, 46vw);
  background: radial-gradient(
    circle at center,
    rgb(234 88 12 / 0.18) 0%,
    rgb(234 88 12 / 0.08) 36%,
    rgb(234 88 12 / 0.025) 58%,
    transparent 72%
  );
}
.hero-depth-scene__orb--amber {
  background: radial-gradient(
    circle at center,
    rgb(251 146 60 / 0.18) 0%,
    rgb(251 146 60 / 0.075) 36%,
    rgb(251 146 60 / 0.02) 58%,
    transparent 72%
  ) !important;
}
.hero-depth-scene__orb--coral {
  background: radial-gradient(
    circle at center,
    rgb(234 88 12 / 0.17) 0%,
    rgb(234 88 12 / 0.07) 36%,
    rgb(234 88 12 / 0.018) 58%,
    transparent 72%
  ) !important;
}
.hero-depth-scene__orb--gold {
  background: radial-gradient(
    circle at center,
    rgb(245 158 11 / 0.16) 0%,
    rgb(245 158 11 / 0.065) 36%,
    rgb(245 158 11 / 0.018) 58%,
    transparent 72%
  ) !important;
}
.hero-depth-scene__icons {
  position: absolute;
  inset: 0;
}
.hero-depth-icon {
  position: absolute;
  transform: translate(-50%, -50%);
}
.hero-depth-icon__depth {
  transform: translate3d(0, 0, var(--depth-z, 0px)) scale(var(--icon-scale, 1));
}
.hero-depth-icon__float {
  position: relative;
  display: grid;
  place-items: center;
  transform: rotate(var(--icon-rotate, 0deg));
}
.hero-depth-icon__float--animated {
  animation: hero-depth-drift cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}
.hero-depth-icon__float--pulse .hero-depth-icon__svg {
  animation: hero-depth-icon-pulse 5.5s ease-in-out infinite;
}
@keyframes hero-depth-drift {
  0%,
  100% {
    transform: translate(0, 0) rotate(var(--icon-rotate, 0deg));
  }
  33% {
    transform: translate(var(--float-x, 4px), var(--float-y, -4px))
      rotate(calc(var(--icon-rotate, 0deg) + 2deg));
  }
  66% {
    transform: translate(calc(var(--float-x, 4px) * -0.65), calc(var(--float-y, -4px) * 0.75))
      rotate(calc(var(--icon-rotate, 0deg) - 1.5deg));
  }
}
@keyframes hero-depth-icon-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.82;
  }
}
.hero-depth-icon__svg {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
  color: rgb(var(--icon-accent-rgb) / 0.95);
}
.hero-depth-icon__svg--mid {
  width: 2.35rem;
  height: 2.35rem;
  opacity: 0.68;
}
.hero-depth-icon__svg--near {
  width: 3rem;
  height: 3rem;
  opacity: 0.9;
}
.hero-depth-icon__svg--very-near {
  width: 3.65rem;
  height: 3.65rem;
  opacity: 1;
}
.hero-depth-icon--mid {
  mix-blend-mode: multiply;
}
@media (prefers-reduced-motion: reduce) {
  .hero-depth-icon__float--animated,
  .hero-depth-icon__float--pulse .hero-depth-icon__svg {
    animation: none !important;
  }
}
/* Landing scenes — tint overlay (no backdrop-filter: re-blurs the animated background on scroll) */
.landing-scene-glass {
  background: rgb(255 255 255 / 0.52);
}
.landing-scene-glass--footer {
  background: linear-gradient(
    180deg,
    rgb(255 255 255 / 0.48) 0%,
    rgb(255 255 255 / 0.62) 100%
  );
}
/* Landing scene proportions — fit one viewport per scene */
.landing-scene-grid{
  display: grid;
  gap: 0.5rem;
}
@media (min-width: 640px){

  .landing-scene-grid{
    gap: 0.75rem;
  }
}
@media (min-width: 1024px){

  .landing-scene-grid{
    gap: 1rem;
  }
}
.landing-scene-card{
  padding: 0.75rem;
}
@media (min-width: 640px){

  .landing-scene-card{
    padding: 1rem;
  }
}
@media (min-width: 1024px){

  .landing-scene-card{
    padding: 1.25rem;
  }
}
.landing-scene-stat{
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 700;
  line-height: 1.25;
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
@media (min-width: 640px){

  .landing-scene-stat{
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
@media (min-width: 1024px){

  .landing-scene-stat{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}
.landing-scene-stat-label{
  font-size: 11px;
  font-weight: 500;
  line-height: 1.375;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
@media (min-width: 640px){

  .landing-scene-stat-label{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 1024px){

  .landing-scene-stat-label{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.landing-scene-card--compact{
  padding: 0.625rem;
}
@media (min-width: 640px){

  .landing-scene-card--compact{
    padding: 0.75rem;
  }
}
@media (min-width: 1024px){

  .landing-scene-card--compact{
    padding: 1rem;
  }
}
@media (max-width: 1023px) {
  .landing-scene-grid{
    gap: 0.625rem;
  }
  .landing-scene-card{
    padding: 0.875rem;
  }
  .landing-scene-stat{
    font-size: 1.25rem;
    line-height: 1.75rem;
    line-height: 1.25;
  }
  .landing-scene-stat-label{
    font-size: 0.75rem;
    line-height: 1rem;
    line-height: 1.375;
  }
  .landing-scene-card--compact{
    padding: 0.75rem;
  }
}
@media (min-width: 1024px) {
  .landing-scene-card.landing-scene-card--compact{
    padding: 1.25rem;
  }
}
@media not all and (min-width: 1024px){

  .landing-pricing-grid{
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 28rem;
  }
}
/* Full-viewport landing scenes */
.viewport-scenes {
  isolation: isolate;
}
.viewport-scene__inner {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.viewport-scene__inner::-webkit-scrollbar {
  display: none;
}
/* Landing scene progress dots */
.scene-progress__dot{
  height: 1.25rem;
  width: 1.25rem;
  cursor: pointer;
  border-width: 0px;
  background-color: transparent;
  padding: 0px;
}
.scene-progress__marker{
  display: block;
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 9999px;
  background-color: rgb(203 213 225 / 0.8);
  transition-property: transform,background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.scene-progress__dot--active .scene-progress__marker,
.scene-progress__dot:hover .scene-progress__marker,
.scene-progress__dot:focus-visible .scene-progress__marker{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.scene-progress__dot:focus-visible{
  border-radius: 9999px;
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(251 146 60 / 0.6);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: transparent;
}
.nav-link--active{
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.viewport-scenes--native {
  scroll-behavior: smooth;
}
/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
  .card-premium:hover,
  .card-premium.interactive-lift:hover {
    --card-lift: 0px;
  }
}
/* High contrast mode */
@media (prefers-contrast: high) {
  .card,
  .card-premium,
  .card-glass{
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  }
  .btn-primary,
  .btn-secondary,
  .btn-accent{
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  }
}
@media not all and (min-width: 1024px){
  .max-lg\\:safe-top {
    padding-top: env(safe-area-inset-top, 0px);
  }
  .max-lg\\:safe-inset-bottom {
    bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));
  }
  @media (min-width: 1024px) {
    .max-lg\\:safe-inset-bottom {
      bottom: calc(2rem + env(safe-area-inset-bottom, 0px));
    }
  }
  .max-lg\\:touch-target{
    min-height: 44px;
    min-width: 44px;
  }
  @media (max-width: 1023px) {
    .max-lg\\:mobile-scroll-x {
      -webkit-overflow-scrolling: touch;
    }
  }
  .max-lg\\:mobile-scroll-x{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
    display: flex;
    gap: 0.5rem;
    overflow-x: auto;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding-bottom: 0.25rem;
  }
  @media (max-width: 1023px) {
    .max-lg\\:mobile-scroll-x {
      -webkit-overflow-scrolling: touch;
    }
  }
  .max-lg\\:mobile-scroll-x{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
    display: flex;
    gap: 0.5rem;
    overflow-x: auto;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding-bottom: 0.25rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  @media (max-width: 1023px) {
    .max-lg\\:mobile-scroll-x {
      -webkit-overflow-scrolling: touch;
    }
  }
  .max-lg\\:mobile-scroll-x{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
    display: flex;
    gap: 0.5rem;
    overflow-x: auto;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding-bottom: 0.25rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .max-lg\\:mobile-scroll-x::-webkit-scrollbar {
    display: none;
  }
}
@media not all and (min-width: 640px){
  .max-sm\\:safe-bottom {
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
  .max-sm\\:touch-target{
    min-height: 44px;
    min-width: 44px;
  }
}
.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}
.file\\:mr-4::file-selector-button{
  margin-right: 1rem;
}
.file\\:rounded-lg::file-selector-button{
  border-radius: 0.5rem;
}
.file\\:rounded-md::file-selector-button{
  border-radius: 0.375rem;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-orange-50::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.file\\:bg-orange-500::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:px-4::file-selector-button{
  padding-left: 1rem;
  padding-right: 1rem;
}
.file\\:py-1\\.5::file-selector-button{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.file\\:py-2::file-selector-button{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-semibold::file-selector-button{
  font-weight: 600;
}
.file\\:text-orange-700::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.file\\:text-white::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-secondary-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.last\\:mb-0:last-child{
  margin-bottom: 0px;
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-orange-400\\/40:focus-within{
  --tw-ring-color: rgb(251 146 60 / 0.4);
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-100:hover{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-orange-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.hover\\:border-orange-200\\/70:hover{
  border-color: rgb(254 215 170 / 0.7);
}
.hover\\:border-orange-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.hover\\:border-orange-300\\/80:hover{
  border-color: rgb(253 186 116 / 0.8);
}
.hover\\:border-secondary-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#1e8fc4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 143 196 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#20bd5a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(32 189 90 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50\\/70:hover{
  background-color: rgb(255 251 235 / 0.7);
}
.hover\\:bg-blue-50\\/70:hover{
  background-color: rgb(239 246 255 / 0.7);
}
.hover\\:bg-cyan-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-50\\/70:hover{
  background-color: rgb(236 254 255 / 0.7);
}
.hover\\:bg-emerald-50\\/70:hover{
  background-color: rgb(236 253 245 / 0.7);
}
.hover\\:bg-error-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-50\\/70:hover{
  background-color: rgb(240 253 244 / 0.7);
}
.hover\\:bg-indigo-50\\/70:hover{
  background-color: rgb(238 242 255 / 0.7);
}
.hover\\:bg-lime-50\\/70:hover{
  background-color: rgb(247 254 231 / 0.7);
}
.hover\\:bg-orange-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-100\\/70:hover{
  background-color: rgb(255 237 213 / 0.7);
}
.hover\\:bg-orange-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-50\\/30:hover{
  background-color: rgb(255 247 237 / 0.3);
}
.hover\\:bg-orange-50\\/35:hover{
  background-color: rgb(255 247 237 / 0.35);
}
.hover\\:bg-orange-50\\/50:hover{
  background-color: rgb(255 247 237 / 0.5);
}
.hover\\:bg-orange-50\\/60:hover{
  background-color: rgb(255 247 237 / 0.6);
}
.hover\\:bg-orange-50\\/70:hover{
  background-color: rgb(255 247 237 / 0.7);
}
.hover\\:bg-orange-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-50\\/70:hover{
  background-color: rgb(253 242 248 / 0.7);
}
.hover\\:bg-pink-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-50\\/70:hover{
  background-color: rgb(255 241 242 / 0.7);
}
.hover\\:bg-secondary-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary-100\\/60:hover{
  background-color: rgb(241 245 249 / 0.6);
}
.hover\\:bg-secondary-100\\/80:hover{
  background-color: rgb(241 245 249 / 0.8);
}
.hover\\:bg-secondary-100\\/90:hover{
  background-color: rgb(241 245 249 / 0.9);
}
.hover\\:bg-secondary-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary-200\\/50:hover{
  background-color: rgb(226 232 240 / 0.5);
}
.hover\\:bg-secondary-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary-50\\/30:hover{
  background-color: rgb(248 250 252 / 0.3);
}
.hover\\:bg-secondary-50\\/70:hover{
  background-color: rgb(248 250 252 / 0.7);
}
.hover\\:bg-secondary-500\\/\\[0\\.04\\]:hover{
  background-color: rgb(100 116 139 / 0.04);
}
.hover\\:bg-secondary-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-50\\/70:hover{
  background-color: rgb(240 249 255 / 0.7);
}
.hover\\:bg-success-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-50\\/70:hover{
  background-color: rgb(240 253 250 / 0.7);
}
.hover\\:bg-violet-50\\/70:hover{
  background-color: rgb(245 243 255 / 0.7);
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/25:hover{
  background-color: rgb(255 255 255 / 0.25);
}
.hover\\:bg-white\\/30:hover{
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-white\\/50:hover{
  background-color: rgb(255 255 255 / 0.5);
}
.hover\\:bg-white\\/60:hover{
  background-color: rgb(255 255 255 / 0.6);
}
.hover\\:bg-white\\/70:hover{
  background-color: rgb(255 255 255 / 0.7);
}
.hover\\:bg-white\\/90:hover{
  background-color: rgb(255 255 255 / 0.9);
}
.hover\\:bg-yellow-50\\/70:hover{
  background-color: rgb(254 252 232 / 0.7);
}
.hover\\:\\!from-success-700:hover{
  --tw-gradient-from: #15803d var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.hover\\:from-amber-600:hover{
  --tw-gradient-from: #d97706 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 119 6 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-error-600:hover{
  --tw-gradient-from: #dc2626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-orange-600:hover{
  --tw-gradient-from: #ea580c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-violet-600:hover{
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:\\!to-emerald-700:hover{
  --tw-gradient-to: #047857 var(--tw-gradient-to-position) !important;
}
.hover\\:to-amber-600:hover{
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}
.hover\\:to-amber-700:hover{
  --tw-gradient-to: #b45309 var(--tw-gradient-to-position);
}
.hover\\:to-error-700:hover{
  --tw-gradient-to: #b91c1c var(--tw-gradient-to-position);
}
.hover\\:to-orange-700:hover{
  --tw-gradient-to: #c2410c var(--tw-gradient-to-position);
}
.hover\\:to-violet-700:hover{
  --tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);
}
.hover\\:text-cyan-600:hover{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-500:hover{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-600:hover{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-700:hover{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-secondary-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-secondary-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-secondary-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-secondary-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:shadow-\\[inset_3px_0_0_0_rgb\\(249_115_22\\)\\]:hover{
  --tw-shadow: inset 3px 0 0 0 rgb(249 115 22);
  --tw-shadow-colored: inset 3px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-glow:hover{
  --tw-shadow: 0 0 24px rgba(249, 115, 22, 0.35), 0 4px 14px rgba(251, 146, 60, 0.15);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-medium:hover{
  --tw-shadow: 0 4px 25px -5px rgba(249, 115, 22, 0.12), 0 10px 30px -5px rgba(15, 23, 42, 0.06);
  --tw-shadow-colored: 0 4px 25px -5px var(--tw-shadow-color), 0 10px 30px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-premium:hover{
  --tw-shadow: 0 1px 0 rgba(255,255,255,0.6) inset, 0 4px 24px -4px rgba(249, 115, 22, 0.15), 0 12px 40px -8px rgba(15, 23, 42, 0.1);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 4px 24px -4px var(--tw-shadow-color), 0 12px 40px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-soft:hover{
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:file\\:bg-orange-100::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.hover\\:file\\:bg-orange-600::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.focus\\:border-error-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.focus\\:border-orange-300\\/80:focus{
  border-color: rgb(253 186 116 / 0.8);
}
.focus\\:border-orange-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.focus\\:border-orange-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:shadow-soft:focus{
  --tw-shadow: 0 2px 15px -3px rgba(249, 115, 22, 0.08), 0 10px 20px -2px rgba(15, 23, 42, 0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-error-500\\/30:focus{
  --tw-ring-color: rgb(239 68 68 / 0.3);
}
.focus\\:ring-error-500\\/40:focus{
  --tw-ring-color: rgb(239 68 68 / 0.4);
}
.focus\\:ring-orange-400\\/25:focus{
  --tw-ring-color: rgb(251 146 60 / 0.25);
}
.focus\\:ring-orange-400\\/30:focus{
  --tw-ring-color: rgb(251 146 60 / 0.3);
}
.focus\\:ring-orange-500\\/30:focus{
  --tw-ring-color: rgb(249 115 22 / 0.3);
}
.focus\\:ring-orange-500\\/40:focus{
  --tw-ring-color: rgb(249 115 22 / 0.4);
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-amber-400\\/40:focus-visible{
  --tw-ring-color: rgb(251 191 36 / 0.4);
}
.focus-visible\\:ring-amber-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-error-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-orange-400:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 146 60 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-orange-400\\/60:focus-visible{
  --tw-ring-color: rgb(251 146 60 / 0.6);
}
.focus-visible\\:ring-orange-400\\/70:focus-visible{
  --tw-ring-color: rgb(251 146 60 / 0.7);
}
.focus-visible\\:ring-orange-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-orange-500\\/40:focus-visible{
  --tw-ring-color: rgb(249 115 22 / 0.4);
}
.focus-visible\\:ring-violet-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(139 92 246 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:cursor-wait:disabled{
  cursor: wait;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-80:disabled{
  opacity: 0.8;
}
.disabled\\:hover\\:scale-100:hover:disabled{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.04\\]{
  --tw-scale-x: 1.04;
  --tw-scale-y: 1.04;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.05\\]{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-secondary-950\\/25{
  background-color: rgb(2 6 23 / 0.25);
}
.group:hover .group-hover\\:text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-90{
  opacity: 0.9;
}
.group:focus-visible .group-focus-visible\\:bg-secondary-950\\/25{
  background-color: rgb(2 6 23 / 0.25);
}
.group:focus-visible .group-focus-visible\\:opacity-100{
  opacity: 1;
}
@media not all and (min-width: 1024px){

  .max-lg\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .max-lg\\:relative{
    position: relative;
  }

  .max-lg\\:bottom-6{
    bottom: 1.5rem;
  }

  .max-lg\\:right-0{
    right: 0px;
  }

  .max-lg\\:right-4{
    right: 1rem;
  }

  .max-lg\\:top-0{
    top: 0px;
  }

  .max-lg\\:order-first{
    order: -9999;
  }

  .max-lg\\:my-auto{
    margin-top: auto;
    margin-bottom: auto;
  }

  .max-lg\\:mb-0{
    margin-bottom: 0px;
  }

  .max-lg\\:mb-0\\.5{
    margin-bottom: 0.125rem;
  }

  .max-lg\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .max-lg\\:mb-2\\.5{
    margin-bottom: 0.625rem;
  }

  .max-lg\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .max-lg\\:mb-4{
    margin-bottom: 1rem;
  }

  .max-lg\\:mt-1\\.5{
    margin-top: 0.375rem;
  }

  .max-lg\\:mt-2{
    margin-top: 0.5rem;
  }

  .max-lg\\:mt-3{
    margin-top: 0.75rem;
  }

  .max-lg\\:mt-4{
    margin-top: 1rem;
  }

  .max-lg\\:line-clamp-2{
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .max-lg\\:flex{
    display: flex;
  }

  .max-lg\\:\\!h-14{
    height: 3.5rem !important;
  }

  .max-lg\\:h-10{
    height: 2.5rem;
  }

  .max-lg\\:h-12{
    height: 3rem;
  }

  .max-lg\\:h-3{
    height: 0.75rem;
  }

  .max-lg\\:h-3\\.5{
    height: 0.875rem;
  }

  .max-lg\\:h-4{
    height: 1rem;
  }

  .max-lg\\:h-5{
    height: 1.25rem;
  }

  .max-lg\\:h-6{
    height: 1.5rem;
  }

  .max-lg\\:h-7{
    height: 1.75rem;
  }

  .max-lg\\:h-8{
    height: 2rem;
  }

  .max-lg\\:h-\\[1\\.125rem\\]{
    height: 1.125rem;
  }

  .max-lg\\:min-h-\\[44px\\]{
    min-height: 44px;
  }

  .max-lg\\:min-h-\\[calc\\(100dvh-3\\.5rem\\)\\]{
    min-height: calc(100dvh - 3.5rem);
  }

  .max-lg\\:\\!w-14{
    width: 3.5rem !important;
  }

  .max-lg\\:w-10{
    width: 2.5rem;
  }

  .max-lg\\:w-12{
    width: 3rem;
  }

  .max-lg\\:w-3{
    width: 0.75rem;
  }

  .max-lg\\:w-3\\.5{
    width: 0.875rem;
  }

  .max-lg\\:w-4{
    width: 1rem;
  }

  .max-lg\\:w-5{
    width: 1.25rem;
  }

  .max-lg\\:w-6{
    width: 1.5rem;
  }

  .max-lg\\:w-7{
    width: 1.75rem;
  }

  .max-lg\\:w-8{
    width: 2rem;
  }

  .max-lg\\:w-\\[1\\.125rem\\]{
    width: 1.125rem;
  }

  .max-lg\\:w-auto{
    width: auto;
  }

  .max-lg\\:w-full{
    width: 100%;
  }

  .max-lg\\:min-w-0{
    min-width: 0px;
  }

  .max-lg\\:max-w-md{
    max-width: 28rem;
  }

  .max-lg\\:flex-1{
    flex: 1 1;
  }

  .max-lg\\:shrink-0{
    flex-shrink: 0;
  }

  .max-lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .max-lg\\:flex-col{
    flex-direction: column;
  }

  .max-lg\\:items-start{
    align-items: flex-start;
  }

  .max-lg\\:items-center{
    align-items: center;
  }

  .max-lg\\:items-stretch{
    align-items: stretch;
  }

  .max-lg\\:justify-start{
    justify-content: flex-start;
  }

  .max-lg\\:justify-between{
    justify-content: space-between;
  }

  .max-lg\\:gap-1{
    gap: 0.25rem;
  }

  .max-lg\\:gap-2{
    gap: 0.5rem;
  }

  .max-lg\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .max-lg\\:gap-3{
    gap: 0.75rem;
  }

  .max-lg\\:gap-x-5{
    column-gap: 1.25rem;
  }

  .max-lg\\:space-x-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }

  .max-lg\\:space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }

  .max-lg\\:self-auto{
    align-self: auto;
  }

  .max-lg\\:self-end{
    align-self: flex-end;
  }

  .max-lg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .max-lg\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .max-lg\\:whitespace-nowrap{
    white-space: nowrap;
  }

  .max-lg\\:p-3\\.5{
    padding: 0.875rem;
  }

  .max-lg\\:p-4{
    padding: 1rem;
  }

  .max-lg\\:p-5{
    padding: 1.25rem;
  }

  .max-lg\\:px-1\\.5{
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }

  .max-lg\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .max-lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-lg\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .max-lg\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .max-lg\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .max-lg\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .max-lg\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .max-lg\\:py-3\\.5{
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .max-lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .max-lg\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .max-lg\\:pb-2\\.5{
    padding-bottom: 0.625rem;
  }

  .max-lg\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .max-lg\\:pb-4{
    padding-bottom: 1rem;
  }

  .max-lg\\:pl-8{
    padding-left: 2rem;
  }

  .max-lg\\:pr-8{
    padding-right: 2rem;
  }

  .max-lg\\:pt-14{
    padding-top: 3.5rem;
  }

  .max-lg\\:\\!text-base{
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .max-lg\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .max-lg\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .max-lg\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .max-lg\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .max-lg\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .max-lg\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .max-lg\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .max-lg\\:leading-snug{
    line-height: 1.375;
  }

  .max-lg\\:ring-2{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }

  .max-lg\\:ring-orange-300\\/60{
    --tw-ring-color: rgb(253 186 116 / 0.6);
  }
}
@media (min-width: 640px){

  .sm\\:-right-3{
    right: -0.75rem;
  }

  .sm\\:-top-3{
    top: -0.75rem;
  }

  .sm\\:bottom-3{
    bottom: 0.75rem;
  }

  .sm\\:left-5{
    left: 1.25rem;
  }

  .sm\\:right-3{
    right: 0.75rem;
  }

  .sm\\:right-4{
    right: 1rem;
  }

  .sm\\:top-4{
    top: 1rem;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-2\\.5{
    margin-bottom: 0.625rem;
  }

  .sm\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-4{
    margin-bottom: 1rem;
  }

  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .sm\\:mb-8{
    margin-bottom: 2rem;
  }

  .sm\\:mr-3{
    margin-right: 0.75rem;
  }

  .sm\\:mt-1{
    margin-top: 0.25rem;
  }

  .sm\\:mt-1\\.5{
    margin-top: 0.375rem;
  }

  .sm\\:mt-10{
    margin-top: 2.5rem;
  }

  .sm\\:mt-3{
    margin-top: 0.75rem;
  }

  .sm\\:mt-4{
    margin-top: 1rem;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:mt-6{
    margin-top: 1.5rem;
  }

  .sm\\:mt-8{
    margin-top: 2rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:table-cell{
    display: table-cell;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:aspect-auto{
    aspect-ratio: auto;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-16{
    height: 4rem;
  }

  .sm\\:h-2\\.5{
    height: 0.625rem;
  }

  .sm\\:h-20{
    height: 5rem;
  }

  .sm\\:h-24{
    height: 6rem;
  }

  .sm\\:h-3{
    height: 0.75rem;
  }

  .sm\\:h-3\\.5{
    height: 0.875rem;
  }

  .sm\\:h-4{
    height: 1rem;
  }

  .sm\\:h-40{
    height: 10rem;
  }

  .sm\\:h-5{
    height: 1.25rem;
  }

  .sm\\:h-6{
    height: 1.5rem;
  }

  .sm\\:h-8{
    height: 2rem;
  }

  .sm\\:h-9{
    height: 2.25rem;
  }

  .sm\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }

  .sm\\:max-h-none{
    max-height: none;
  }

  .sm\\:min-h-0{
    min-height: 0px;
  }

  .sm\\:min-h-\\[3\\.5rem\\]{
    min-height: 3.5rem;
  }

  .sm\\:min-h-\\[320px\\]{
    min-height: 320px;
  }

  .sm\\:min-h-\\[3rem\\]{
    min-height: 3rem;
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-2\\.5{
    width: 0.625rem;
  }

  .sm\\:w-3{
    width: 0.75rem;
  }

  .sm\\:w-3\\.5{
    width: 0.875rem;
  }

  .sm\\:w-4{
    width: 1rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-5{
    width: 1.25rem;
  }

  .sm\\:w-6{
    width: 1.5rem;
  }

  .sm\\:w-64{
    width: 16rem;
  }

  .sm\\:w-8{
    width: 2rem;
  }

  .sm\\:w-9{
    width: 2.25rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:min-w-\\[200px\\]{
    min-width: 200px;
  }

  .sm\\:max-w-2xl{
    max-width: 42rem;
  }

  .sm\\:max-w-3xl{
    max-width: 48rem;
  }

  .sm\\:max-w-\\[11rem\\]{
    max-width: 11rem;
  }

  .sm\\:max-w-\\[16rem\\]{
    max-width: 16rem;
  }

  .sm\\:max-w-\\[9rem\\]{
    max-width: 9rem;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-none{
    max-width: none;
  }

  .sm\\:flex-1{
    flex: 1 1;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:shrink-0{
    flex-shrink: 0;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[1fr_1\\.4fr_auto\\]{
    grid-template-columns: 1fr 1.4fr auto;
  }

  .sm\\:grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: auto minmax(0,1fr);
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_9\\.5rem\\]{
    grid-template-columns: minmax(0,1fr) 9.5rem;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:items-stretch{
    align-items: stretch;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-1{
    gap: 0.25rem;
  }

  .sm\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:gap-x-2{
    column-gap: 0.5rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .sm\\:self-auto{
    align-self: auto;
  }

  .sm\\:overflow-visible{
    overflow: visible;
  }

  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }

  .sm\\:rounded-3xl{
    border-radius: 1.5rem;
  }

  .sm\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .sm\\:p-2{
    padding: 0.5rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-7{
    padding: 1.75rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .sm\\:pb-0{
    padding-bottom: 0px;
  }

  .sm\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .sm\\:pl-12{
    padding-left: 3rem;
  }

  .sm\\:pr-20{
    padding-right: 5rem;
  }

  .sm\\:pt-0{
    padding-top: 0px;
  }

  .sm\\:pt-20{
    padding-top: 5rem;
  }

  .sm\\:pt-28{
    padding-top: 7rem;
  }

  .sm\\:pt-4{
    padding-top: 1rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:\\!text-lg{
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 3.25rem;
  }

  .sm\\:text-\\[1\\.05rem\\]{
    font-size: 1.05rem;
  }

  .sm\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:font-bold{
    font-weight: 700;
  }

  .sm\\:leading-\\[1\\.75rem\\]{
    line-height: 1.75rem;
  }

  .sm\\:tracking-tight{
    letter-spacing: -0.025em;
  }

  @media not all and (min-width: 1280px){

    .sm\\:max-xl\\:grid-cols-2{
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}
@media (min-width: 768px){

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:table-cell{
    display: table-cell;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px){

  .lg\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .lg\\:absolute{
    position: absolute;
  }

  .lg\\:bottom-8{
    bottom: 2rem;
  }

  .lg\\:left-4{
    left: 1rem;
  }

  .lg\\:left-auto{
    left: auto;
  }

  .lg\\:right-3{
    right: 0.75rem;
  }

  .lg\\:right-4{
    right: 1rem;
  }

  .lg\\:right-5{
    right: 1.25rem;
  }

  .lg\\:right-6{
    right: 1.5rem;
  }

  .lg\\:right-8{
    right: 2rem;
  }

  .lg\\:top-3{
    top: 0.75rem;
  }

  .lg\\:order-1{
    order: 1;
  }

  .lg\\:order-2{
    order: 2;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .lg\\:mb-1\\.5{
    margin-bottom: 0.375rem;
  }

  .lg\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .lg\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .lg\\:mb-4{
    margin-bottom: 1rem;
  }

  .lg\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .lg\\:mb-8{
    margin-bottom: 2rem;
  }

  .lg\\:ml-20{
    margin-left: 5rem;
  }

  .lg\\:ml-4{
    margin-left: 1rem;
  }

  .lg\\:ml-\\[256px\\]{
    margin-left: 256px;
  }

  .lg\\:mt-1{
    margin-top: 0.25rem;
  }

  .lg\\:mt-1\\.5{
    margin-top: 0.375rem;
  }

  .lg\\:mt-2{
    margin-top: 0.5rem;
  }

  .lg\\:mt-3{
    margin-top: 0.75rem;
  }

  .lg\\:mt-5{
    margin-top: 1.25rem;
  }

  .lg\\:mt-8{
    margin-top: 2rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:inline{
    display: inline;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:table-cell{
    display: table-cell;
  }

  .lg\\:grid{
    display: grid;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:\\!h-16{
    height: 4rem !important;
  }

  .lg\\:h-10{
    height: 2.5rem;
  }

  .lg\\:h-11{
    height: 2.75rem;
  }

  .lg\\:h-12{
    height: 3rem;
  }

  .lg\\:h-16{
    height: 4rem;
  }

  .lg\\:h-24{
    height: 6rem;
  }

  .lg\\:h-4{
    height: 1rem;
  }

  .lg\\:h-5{
    height: 1.25rem;
  }

  .lg\\:h-6{
    height: 1.5rem;
  }

  .lg\\:h-9{
    height: 2.25rem;
  }

  .lg\\:h-full{
    height: 100%;
  }

  .lg\\:min-h-0{
    min-height: 0px;
  }

  .lg\\:min-h-\\[72px\\]{
    min-height: 72px;
  }

  .lg\\:\\!w-16{
    width: 4rem !important;
  }

  .lg\\:w-10{
    width: 2.5rem;
  }

  .lg\\:w-11{
    width: 2.75rem;
  }

  .lg\\:w-12{
    width: 3rem;
  }

  .lg\\:w-16{
    width: 4rem;
  }

  .lg\\:w-4{
    width: 1rem;
  }

  .lg\\:w-5{
    width: 1.25rem;
  }

  .lg\\:w-6{
    width: 1.5rem;
  }

  .lg\\:w-9{
    width: 2.25rem;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:min-w-\\[220px\\]{
    min-width: 220px;
  }

  .lg\\:max-w-2xl{
    max-width: 42rem;
  }

  .lg\\:max-w-\\[18rem\\]{
    max-width: 18rem;
  }

  .lg\\:max-w-md{
    max-width: 28rem;
  }

  .lg\\:max-w-none{
    max-width: none;
  }

  .lg\\:flex-1{
    flex: 1 1;
  }

  .lg\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[260px_1fr\\]{
    grid-template-columns: 260px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_300px\\]{
    grid-template-columns: minmax(0,1fr) 300px;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_8rem\\]{
    grid-template-columns: minmax(0,1fr) 8rem;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 4fr\\)_minmax\\(0\\2c 6fr\\)\\]{
    grid-template-columns: minmax(0,4fr) minmax(0,6fr);
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:flex-wrap{
    flex-wrap: wrap;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-end{
    align-items: flex-end;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:items-stretch{
    align-items: stretch;
  }

  .lg\\:justify-start{
    justify-content: flex-start;
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }

  .lg\\:justify-center{
    justify-content: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-0{
    gap: 0px;
  }

  .lg\\:gap-10{
    gap: 2.5rem;
  }

  .lg\\:gap-12{
    gap: 3rem;
  }

  .lg\\:gap-2{
    gap: 0.5rem;
  }

  .lg\\:gap-3{
    gap: 0.75rem;
  }

  .lg\\:gap-4{
    gap: 1rem;
  }

  .lg\\:gap-5{
    gap: 1.25rem;
  }

  .lg\\:gap-6{
    gap: 1.5rem;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }

  .lg\\:gap-x-6{
    column-gap: 1.5rem;
  }

  .lg\\:gap-y-3{
    row-gap: 0.75rem;
  }

  .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .lg\\:self-auto{
    align-self: auto;
  }

  .lg\\:overflow-hidden{
    overflow: hidden;
  }

  .lg\\:overflow-visible{
    overflow: visible;
  }

  .lg\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .lg\\:break-normal{
    overflow-wrap: normal;
    word-break: normal;
  }

  .lg\\:rounded-2xl{
    border-radius: 1rem;
  }

  .lg\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:p-10{
    padding: 2.5rem;
  }

  .lg\\:p-3{
    padding: 0.75rem;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .lg\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .lg\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .lg\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .lg\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .lg\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .lg\\:pl-12{
    padding-left: 3rem;
  }

  .lg\\:pr-12{
    padding-right: 3rem;
  }

  .lg\\:pt-1{
    padding-top: 0.25rem;
  }

  .lg\\:pt-\\[5\\.25rem\\]{
    padding-top: 5.25rem;
  }

  .lg\\:text-left{
    text-align: left;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 3.25rem;
  }

  .lg\\:text-\\[0\\]{
    font-size: 0;
  }

  .lg\\:text-\\[1\\.65rem\\]{
    font-size: 1.65rem;
  }

  .lg\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:leading-relaxed{
    line-height: 1.625;
  }
}
@media (min-width: 1280px){

  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .xl\\:mb-4{
    margin-bottom: 1rem;
  }

  .xl\\:h-11{
    height: 2.75rem;
  }

  .xl\\:min-w-\\[2\\.5rem\\]{
    min-width: 2.5rem;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_360px\\]{
    grid-template-columns: minmax(0,1fr) 360px;
  }

  .xl\\:gap-3{
    gap: 0.75rem;
  }

  .xl\\:gap-4{
    gap: 1rem;
  }

  .xl\\:gap-6{
    gap: 1.5rem;
  }

  .xl\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
  }

  .xl\\:p-10{
    padding: 2.5rem;
  }

  .xl\\:p-5{
    padding: 1.25rem;
  }

  .xl\\:p-6{
    padding: 1.5rem;
  }

  .xl\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xl\\:pl-3{
    padding-left: 0.75rem;
  }

  .xl\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .xl\\:text-5xl{
    font-size: 3rem;
    line-height: 3.25rem;
  }

  .xl\\:text-6xl{
    font-size: 3.75rem;
    line-height: 4rem;
  }

  .xl\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .xl\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1600px){

  .min-\\[1600px\\]\\:grid{
    display: grid;
  }

  .min-\\[1600px\\]\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .min-\\[1600px\\]\\:gap-5{
    gap: 1.25rem;
  }

  .min-\\[1600px\\]\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
}
@media (orientation: landscape){

  @media not all and (min-width: 640px){

    .landscape\\:max-sm\\:aspect-auto{
      aspect-ratio: auto;
    }

    .landscape\\:max-sm\\:h-\\[58dvh\\]{
      height: 58dvh;
    }

    .landscape\\:max-sm\\:max-h-none{
      max-height: none;
    }
  }
}
.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb{
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-secondary-300\\/80::-webkit-scrollbar-thumb{
  background-color: rgb(203 213 225 / 0.8);
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{
  display: none;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-1\\.5::-webkit-scrollbar{
  width: 0.375rem;
}
.\\[\\&\\>button\\]\\:flex-1>button{
  flex: 1 1;
}
.\\[\\&_\\*\\]\\:text-inherit *{
  color: inherit;
}
@media not all and (min-width: 1024px){

  .max-lg\\:\\[\\&_\\.ios-segment\\]\\:flex-1 .ios-segment{
    flex: 1 1;
  }
}
.\\[\\&_button\\]\\:w-full button{
  width: 100%;
}
.\\[\\&_button\\]\\:justify-center button{
  justify-content: center;
}
@media not all and (min-width: 1024px){

  .max-lg\\:\\[\\&_button\\]\\:w-full button{
    width: 100%;
  }
}
@media (min-width: 640px){

  .sm\\:\\[\\&_button\\]\\:w-auto button{
    width: auto;
  }
}
@media (min-width: 1024px){

  .lg\\:\\[\\&_button\\]\\:w-auto button{
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAK9E;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd,kEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,gGAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,sFAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,gDAAc;EAAA;;AAAd;EAAA;AAAc;;AAAd;IAAA,uBAAc;IAAd,sBAAc;EAAA;;AAAd;EAAA,4EAAc;EAAd,4DAAc;EAAd,qEAAc;EAAd,mEAAc;EAAd,yGAAc;EAAd,gGAAc;EAAd,oBAAc;EAAd,gDAAc;IAAd,mDAAc;IAAd,8BAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd;AAAc;;AAAd;AAAA;IAAA;EAAc;AAAA;;AAAd;AAAA;IAAA;EAAc;AAAA;;AAAd,qBAAc;;AAAd;EAAA,uCAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,8BAAc;EAAd;AAAc;;AAAd;IAAA;MAAA,qBAAc;IAAA;IAAd;;;MAAA,qCAAc;MAAd,uCAAc;MAAd,sCAAc;IAAA;EAAA;;AA0Cd;EAAA;AAAoB;;AAApB;EAAA;AAAoB;;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;;AAElB,kFAAkF;;AAoBlF,wBAAwB;;AAEtB;EAAA,gBAA8N;EAA9N,mBAA8N;EAA9N,iBAA8N;EAA9N,oCAA8N;EAA9N,wCAA8N;EAA9N,8FAA8N;EAA9N,oGAA8N;EAA9N,uGAA8N;EAA9N,6BAA8N;EAA9N,uQAA8N;EAA9N,6EAA8N;EAA9N,wDAA8N;EAA9N;AAA8N;;AAA9N;EAAA,wCAA8N;EAA9N,8FAA8N;EAA9N,oGAA8N;EAA9N;AAA8N;;AAG9N;EAAA,kBAA8F;EAA9F,kBAA8F;EAA9F,gBAA8F;EAA9F,qBAA8F;EAA9F,iBAA8F;EAA9F,qCAA8F;EAA9F,yCAA8F;IAC9F,2CAA2C;IAC3C,sBAAsB;IACtB;;uHAEmH;IACnH,uCAAuC;IACvC;;;;;;;;;;;;AAP8F;;AAmB/F;IACC,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;IACxB,2BAA2B;IAC3B,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;IACxB,0BAA0B;EAC5B;;AACA;IACE,mBAAmB;EACrB;;AAEE;EAAA,qCAAuC;EAAvC,oBAAuC;EAAvC;AAAuC;;AAEzC;IACE,qCAAqC;EACvC;;AAUA;IACE,0CAA0C;EAC5C;;AACA;IACE,gDAAgD;EAClD;;AACA;IACE,4CAA4C;IAC5C,8CAA8C;EAChD;;AAUE;EAAA,gBAAgC;EAAhC;AAAgC;;AAGhC;IAAA;MAAA,iCAAiD;IAAA;EAAA;;AAAjD;EAAA,qBAAiD;EAAjD,sBAAiD;EAAjD,aAAiD;EAAjD,WAAiD;EAAjD,gBAAiD;EAAjD,qBAAiD;EAAjD,sBAAiD;EAAjD,uBAAiD;IACjD,iCAAiC;IACjC;AAFiD;;AAInD;IACE,aAAa;EACf;;AACA;IACE;;MAEE,iCAAiC;IACnC;EACF;;AAEE;EAAA,WAAkC;EAAlC,gBAAkC;EAAlC;AAAkC;;AAGlC;EAAA,WAAmC;EAAnC,gBAAmC;EAAnC;AAAmC;;AAGnC;EAAA,WAAgD;EAAhD,gBAAgD;EAAhD;AAAgD;;AAAhD;;EAAA;IAAA;EAAgD;AAAA;;AAGhD;EAAA,WAAgD;EAAhD,gBAAgD;EAAhD;AAAgD;;AAAhD;;EAAA;IAAA;EAAgD;AAAA;;AAGhD;EAAA,WAAkC;EAAlC,gBAAkC;EAAlC;AAAkC;;AAGlC;EAAA,qBAA2G;EAA3G,iBAA2G;EAA3G,oBAA2G;EAA3G,oCAA2G;EAA3G,sEAA2G;EAA3G,2EAA2G;EAA3G,qEAA2G;EAA3G,mEAA2G;EAA3G;AAA2G;;AAG3G;EAAA,yCAA8D;EAA9D,wDAA8D;EAA9D,0BAA8D;EAA9D;AAA8D;;AAG9D;EAAA,2BAAqC;EAArC,+LAAqC;EAArC,8FAAqC;EAArC,oGAAqC;EAArC;AAAqC;;AAGrC;EAAA,sBAAmN;EAAnN,qBAAmN;EAAnN,sBAAmN;EAAnN,qBAAmN;EAAnN,wBAAmN;EAAnN,mBAAmN;EAAnN,oBAAmN;EAAnN,gBAAmN;EAAnN,sDAAmN;EAAnN,wDAAmN;EAAnN;AAAmN;;AAAnN;EAAA,8BAAmN;EAAnN;AAAmN;;AAAnN;EAAA,2GAAmN;EAAnN,yGAAmN;EAAnN,4FAAmN;EAAnN,sCAAmN;EAAnN;AAAmN;;AAGnN;EAAA,qEAA2G;EAA3G,4DAA2G;EAA3G,oEAA2G;EAA3G,mEAA2G;EAA3G,wDAA2G;EAA3G,oBAA2G;EAA3G,mDAA2G;EAA3G,6CAA2G;EAA3G,sDAA2G;EAA3G;AAA2G;;AAG3G;EAAA,oBAA+E;EAA/E;AAA+E;;AAA/E;EAAA,wCAA+E;EAA/E,oBAA+E;EAA/E;AAA+E;;AAEjF,8CAA8C;;AAE5C;EAAA,cAAqf;EAArf,WAAqf;EAArf,mBAAqf;EAArf,iBAAqf;EAArf,oCAAqf;EAArf,wCAAqf;EAArf,kBAAqf;EAArf,mBAAqf;EAArf,oBAAqf;EAArf,uBAAqf;EAArf,mBAAqf;EAArf,oBAAqf;EAArf,oBAAqf;EAArf;AAAqf;;AAArf;EAAA,2BAAqf;EAArf;AAAqf;;AAArf;EAAA,gDAAqf;EAArf,yDAAqf;EAArf,uGAAqf;EAArf,8BAAqf;EAArf,uQAAqf;EAArf,6EAAqf;EAArf,wDAAqf;EAArf,0BAAqf;EAArf;AAAqf;;AAArf;EAAA,oCAAqf;EAArf,kBAAqf;EAArf,4DAAqf;EAArf,8FAAqf;EAArf,oGAAqf;EAArf,uGAAqf;EAArf,8BAAqf;EAArf,mBAAqf;EAArf,2GAAqf;EAArf,yGAAqf;EAArf,4FAAqf;EAArf;AAAqf;;AAArf;EAAA,mBAAqf;EAArf,wCAAqf;EAArf,oBAAqf;EAArf;AAAqf;;AAGrf;EAAA,cAAyW;EAAzW,WAAyW;EAAzW,mBAAyW;EAAzW,iBAAyW;EAAzW,yCAAyW;EAAzW,oBAAyW;EAAzW,qBAAyW;EAAzW,iBAAyW;EAAzW,oBAAyW;EAAzW,mBAAyW;EAAzW,oBAAyW;EAAzW,oBAAyW;EAAzW;AAAyW;;AAAzW;EAAA,2BAAyW;EAAzW;AAAyW;;AAAzW;EAAA,8FAAyW;EAAzW,oGAAyW;EAAzW,uGAAyW;EAAzW,2GAAyW;EAAzW,yGAAyW;EAAzW,4FAAyW;EAAzW,wCAAyW;EAAzW,8BAAyW;EAAzW,uQAAyW;EAAzW,2EAAyW;EAAzW,wDAAyW;EAAzW,0BAAyW;EAAzW;AAAyW;;AAAzW;EAAA,kBAAyW;EAAzW,4DAAyW;EAAzW,8FAAyW;EAAzW,oGAAyW;EAAzW,uGAAyW;EAAzW,8BAAyW;EAAzW,mBAAyW;EAAzW,2GAAyW;EAAzW,yGAAyW;EAAzW,4FAAyW;EAAzW;AAAyW;;AAGzW;EAAA,cAAwD;EAAxD,WAAwD;EAAxD,mBAAwD;EAAxD,iBAAwD;EAAxD,oCAAwD;EAAxD,wCAAwD;EAAxD,kBAAwD;EAAxD,mBAAwD;EAAxD,oBAAwD;EAAxD,uBAAwD;EAAxD,mBAAwD;EAAxD,oBAAwD;EAAxD,oBAAwD;EAAxD;AAAwD;;AAAxD;EAAA,2BAAwD;EAAxD;AAAwD;;AAAxD;EAAA,gDAAwD;EAAxD,yDAAwD;EAAxD,uGAAwD;EAAxD,8BAAwD;EAAxD,uQAAwD;EAAxD,6EAAwD;EAAxD,wDAAwD;EAAxD,0BAAwD;EAAxD;AAAwD;;AAAxD;EAAA,oCAAwD;EAAxD,kBAAwD;EAAxD,4DAAwD;EAAxD,8FAAwD;EAAxD,oGAAwD;EAAxD,uGAAwD;EAAxD,8BAAwD;EAAxD,mBAAwD;EAAxD,2GAAwD;EAAxD,yGAAwD;EAAxD,4FAAwD;EAAxD;AAAwD;;AAAxD;EAAA,mBAAwD;EAAxD,wCAAwD;EAAxD,oBAAwD;EAAxD;AAAwD;;AAAxD;;EAAA;AAAwD;;AAAxD;;EAAA;;IAAA;EAAwD;AAAA;;AAAxD;;EAAA;AAAwD;;AAAxD;;EAAA;;IAAA;EAAwD;AAAA;;AAAxD;EAAA,gBAAwD;EAAxD,gBAAwD;EAAxD;AAAwD;;AAGxD;EAAA,cAAmb;EAAnb,WAAmb;EAAnb,mBAAmb;EAAnb,iBAAmb;EAAnb,oCAAmb;EAAnb,wCAAmb;EAAnb,kBAAmb;EAAnb,mBAAmb;EAAnb,oBAAmb;EAAnb,uBAAmb;EAAnb,mBAAmb;EAAnb,oBAAmb;EAAnb,oBAAmb;EAAnb,gDAAmb;EAAnb,gDAAmb;EAAnb,yDAAmb;EAAnb,uGAAmb;EAAnb,8BAAmb;EAAnb,uQAAmb;EAAnb,mEAAmb;EAAnb,wDAAmb;EAAnb,0BAAmb;EAAnb;AAAmb;;AAAnb;EAAA,oCAAmb;EAAnb,kBAAmb;EAAnb,4DAAmb;EAAnb,8FAAmb;EAAnb,oGAAmb;EAAnb,uGAAmb;EAAnb,8BAAmb;EAAnb,mBAAmb;EAAnb,2GAAmb;EAAnb,yGAAmb;EAAnb,4FAAmb;EAAnb;AAAmb;;AAAnb;EAAA,wCAAmb;EAAnb,oBAAmb;EAAnb;AAAmb;;AAGnb;EAAA;AAAe;;AAGf;EAAA,qBAAY;IACZ;AADY;;AAIZ;EAAA,kBAA8E;EAA9E,eAA8E;EAA9E,QAA8E;EAA9E,YAA8E;EAA9E,WAA8E;EAA9E,sBAA8E;EAA9E,+LAA8E;EAA9E;AAA8E;;AAG9E;EAAA,kBAAiC;EAAjC,aAAiC;EAAjC;AAAiC;;AAGjC;EAAA,WAA+X;EAA/X,mBAA+X;EAA/X,iBAA+X;EAA/X,oCAA+X;EAA/X,wCAA+X;EAA/X,qBAA+X;EAA/X,wBAA+X;EAA/X,qBAA+X;EAA/X,qBAA+X;EAA/X,mBAA+X;EAA/X,oBAA+X;EAA/X,oBAA+X;EAA/X;AAA+X;;AAA/X;EAAA,2BAA+X;EAA/X;AAA+X;;AAA/X;EAAA,gDAA+X;EAA/X,yDAA+X;EAA/X,uGAA+X;EAA/X,8BAA+X;EAA/X,uQAA+X;EAA/X,6DAA+X;EAA/X,wDAA+X;EAA/X,0BAA+X;EAA/X;AAA+X;;AAA/X;EAAA,oCAA+X;EAA/X,kBAA+X;EAA/X,4DAA+X;EAA/X,8BAA+X;EAA/X,mBAA+X;EAA/X,2GAA+X;EAA/X,yGAA+X;EAA/X,4FAA+X;EAA/X;AAA+X;;AAG/X;EAAA,kBAA6E;EAA7E,cAA6E;EAA7E,QAA6E;EAA7E,eAA6E;EAA7E,cAA6E;EAA7E,sBAA6E;EAA7E,+LAA6E;EAA7E;AAA6E;;AAG7E;EAAA,kBAA2J;EAA3J,aAA2J;EAA3J,QAA2J;EAA3J,sBAA2J;EAA3J,+LAA2J;EAA3J,sBAA2J;EAA3J,iBAA2J;EAA3J,oBAA2J;EAA3J,mDAA2J;EAA3J,+FAA2J;EAA3J,wDAA2J;EAA3J;AAA2J;;AAA3J;EAAA,wCAA2J;EAA3J,oBAA2J;EAA3J;AAA2J;;AAG3J;EAAA,kBAAuV;EAAvV,oBAAuV;EAAvV,YAAuV;EAAvV,WAAuV;EAAvV,cAAuV;EAAvV,mBAAuV;EAAvV,qBAAuV;EAAvV,iBAAuV;EAAvV,yBAAuV;EAAvV,wCAAuV;EAAvV,iBAAuV;EAAvV,gDAAuV;EAAvV,2DAAuV;EAAvV,uGAAuV;EAAvV,gDAAuV;EAAvV,wDAAuV;EAAvV,0BAAuV;EAAvV;AAAuV;;AAAvV;EAAA,8BAAuV;EAAvV;AAAuV;;AAAvV;EAAA,2GAAuV;EAAvV,yGAAuV;EAAvV,4FAAuV;EAAvV,sCAAuV;EAAvV;AAAuV;;AAGvV;EAAA,qEAAkE;EAAlE,4DAAkE;EAAlE,oEAAkE;EAAlE,mEAAkE;EAAlE,wDAAkE;EAAlE,mFAAkE;EAAlE,uFAAkE;EAAlE;AAAkE;;AAGlE;EAAA,cAA4J;EAA5J,YAA4J;EAA5J,WAA4J;EAA5J,qBAA4J;EAA5J,+LAA4J;EAA5J,qBAA4J;EAA5J,kBAA4J;EAA5J,4DAA4J;EAA5J,0CAA4J;EAA5J,qDAA4J;EAA5J,uGAA4J;EAA5J,oCAA4J;EAA5J,wDAA4J;EAA5J,0BAA4J;EAA5J;AAA4J;;AAG5J;EAAA;AAAe;;AAGf;EAAA,sBAAoB;EAApB;AAAoB;;AAGpB;EAAA,yBAAoB;EAApB;AAAoB;;AAGpB;EAAA,kBAAyW;EAAzW,oBAAyW;EAAzW,eAAyW;EAAzW,cAAyW;EAAzW,cAAyW;EAAzW,mBAAyW;EAAzW,uBAAyW;EAAzW,uBAAyW;EAAzW,iBAAyW;EAAzW,oCAAyW;EAAzW,wCAAyW;EAAzW,gDAAyW;EAAzW,yDAAyW;EAAzW,uGAAyW;EAAzW,uEAAyW;EAAzW,wDAAyW;EAAzW,0BAAyW;EAAzW;AAAyW;;AAAzW;EAAA,8BAAyW;EAAzW;AAAyW;;AAAzW;EAAA,2GAAyW;EAAzW,yGAAyW;EAAzW,4FAAyW;EAAzW,sCAAyW;EAAzW;AAAyW;;AAGzW;EAAA,sBAAgG;EAAhG,2DAAgG;EAAhG,4EAAgG;EAAhG,4DAAgG;EAAhG,oEAAgG;EAAhG,mEAAgG;EAAhG,wDAAgG;EAAhG,oBAAgG;EAAhG,mDAAgG;EAAhG,mFAAgG;EAAhG,uFAAgG;EAAhG;AAAgG;;AAGhG;EAAA,aAAkD;EAAlD,mBAAkD;EAAlD,uBAAkD;EAAlD,oBAAkD;EAAlD;AAAkD;;AAGlD;EAAA,aAA6B;EAA7B,uBAA6B;EAA7B;AAA6B;;AAG7B;EAAA,cAAoD;EAApD,mBAAoD;EAApD,oBAAoD;EAApD,gBAAoD;EAApD,oBAAoD;EAApD;AAAoD;;AAGpD;EAAA,oBAA+D;EAA/D,cAA+D;EAA/D,kBAA+D;EAA/D,iBAA+D;EAA/D,kBAA+D;EAA/D,oBAA+D;EAA/D;AAA+D;;AAG/D;EAAA,kBAA2K;EAA3K,oBAA2K;EAA3K,mBAA2K;EAA3K,mBAA2K;EAA3K,iBAA2K;EAA3K,oCAA2K;EAA3K,wCAA2K;EAA3K,gBAA2K;EAA3K,gDAA2K;EAA3K,2DAA2K;EAA3K,uGAA2K;EAA3K,6BAA2K;EAA3K;AAA2K;;AAG3K;EAAA,qBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B;AAA0B;;AAG1B;EAAA,kBAAmC;EAAnC,mBAAmC;EAAnC,mBAAmC;EAAnC,sBAAmC;EAAnC,kBAAmC;EAAnC;AAAmC;;AAAnC;;EAAA;IAAA,mBAAmC;IAAnC;EAAmC;AAAA;;AAGnC;EAAA,kBAAwO;EAAxO,UAAwO;EAAxO,oBAAwO;EAAxO,gBAAwO;EAAxO,mBAAwO;EAAxO,uBAAwO;EAAxO,sBAAwO;EAAxO,gBAAwO;EAAxO,oBAAwO;EAAxO,iDAAwO;EAAxO,+FAAwO;EAAxO,wDAAwO;EAAxO,0BAAwO;EAAxO;AAAwO;;AAAxO;EAAA,8BAAwO;EAAxO;AAAwO;;AAAxO;EAAA,2GAAwO;EAAxO,yGAAwO;EAAxO,4FAAwO;EAAxO;AAAwO;;AAGxO;EAAA,oBAAuB;EAAvB;AAAuB;;AAGvB;EAAA,kBAAwD;EAAxD,UAAwD;EAAxD,sBAAwD;EAAxD,kBAAwD;EAAxD,4DAAwD;EAAxD,8FAAwD;EAAxD,oGAAwD;EAAxD;AAAwD;;AAGxD;EAAA,kBAAqB;EAArB;AAAqB;;AAGrB;EAAA,kBAA+C;EAA/C,kBAA+C;EAA/C,gBAA+C;EAA/C,qBAA+C;EAA/C,iBAA+C;EAA/C,qCAA+C;EAA/C,yCAA+C;IAA/C,2CAA+C;IAA/C,sBAA+C;IAA/C;;uHAA+C;IAA/C,uCAA+C;IAA/C;;;;;;;;;;;;AAA+C;;AAA/C;IAAA,iBAA+C;IAA/C,qBAA+C;IAA/C,wBAA+C;IAA/C,2BAA+C;IAA/C,wBAA+C;IAA/C,qBAA+C;IAA/C,wBAA+C;IAA/C,0BAA+C;EAAA;;AAA/C;IAAA,mBAA+C;EAAA;;AAA/C;EAAA,WAA+C;EAA/C,cAA+C;EAA/C,eAA+C;EAA/C;;qHAA+C;EAA/C,uCAA+C;EAA/C;;;;;;;;;;;;AAA+C;;AAA/C;;;EAAA,iFAA+C;EAA/C,uCAA+C;EAA/C,0BAA+C;AAAA;;AAA/C;EAAA;IAAA,gBAA+C;EAAA;AAAA;;AAA/C;EAAA;IAAA,iBAA+C;IAA/C,sBAA+C;IAA/C;EAA+C;AAAA;;AAA/C;;EAAA;IAAA;EAA+C;AAAA;;AAG/C;EAAA;AAAa;;AAGb;IAAA;MAAA,iCAA2B;IAAA;EAAA;;AAA3B;EAAA,qBAA2B;EAA3B,sBAA2B;EAA3B,aAA2B;EAA3B,WAA2B;EAA3B,gBAA2B;EAA3B,qBAA2B;EAA3B,sBAA2B;EAA3B,uBAA2B;IAA3B,iCAA2B;IAA3B;AAA2B;;AAA3B;IAAA,aAA2B;EAAA;;AAA3B;EAAA;AAA2B;;AAG3B;EAAA,kBAAiQ;EAAjQ,aAAiQ;EAAjQ,WAAiQ;EAAjQ,mBAAiQ;EAAjQ,YAAiQ;EAAjQ,mBAAiQ;EAAjQ,kBAAiQ;EAAjQ,mBAAiQ;EAAjQ,oBAAiQ;EAAjQ,uBAAiQ;EAAjQ,gBAAiQ;EAAjQ,mBAAiQ;EAAjQ,oBAAiQ;EAAjQ,gBAAiQ;EAAjQ,oBAAiQ;EAAjQ,iDAAiQ;EAAjQ,+FAAiQ;EAAjQ,wDAAiQ;EAAjQ,0BAAiQ;EAAjQ;AAAiQ;;AAAjQ;EAAA,oBAAiQ;EAAjQ;AAAiQ;;AAAjQ;EAAA,8BAAiQ;EAAjQ;AAAiQ;;AAAjQ;EAAA,2GAAiQ;EAAjQ,yGAAiQ;EAAjQ,4FAAiQ;EAAjQ;AAAiQ;;AAGjQ;EAAA,oBAAuB;EAAvB;AAAuB;;AAGvB;EAAA,kBAA+J;EAA/J,UAA+J;EAA/J,mBAA+J;EAA/J,iBAA+J;EAA/J,oCAA+J;EAA/J,qEAA+J;EAA/J,2EAA+J;EAA/J,oEAA+J;EAA/J,mEAA+J;EAA/J,6CAA+J;EAA/J,6DAA+J;EAA/J;AAA+J;;AAA/J;AAAA;IAAA;EAA+J;AAAA;;AAG/J;EAAA,kBAAkC;EAAlC,UAAkC;EAAlC;AAAkC;;AAGlC;EAAA,kBAAqB;EAArB;AAAqB;;AAGrB;EAAA,cAAuF;EAAvF,qBAAuF;EAAvF,oCAAuF;EAAvF,kBAAuF;EAAvF,4DAAuF;EAAvF;AAAuF;;AAAvF;;EAAA;IAAA,oBAAuF;IAAvF,qBAAuF;IAAvF,sBAAuF;IAAvF;EAAuF;AAAA;;AAKzF,iDAAiD;;AACjD;;;;;;IAME,wBAAwB;IAGxB,2BAA2B;IAC3B,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;IAC7B,yBAAyB;EAC3B;;AACA,yCAAyC;;AACzC;IAGE,2BAA2B;EAC7B;;AACA,wCAAwC;;AACxC;;IAEE,mCAAmC;IACnC,oBAAoB;EACtB;;AACA,sBAAsB;;AAEpB;EAAA,4EAAsE;EAAtE,2EAAsE;EAAtE,qEAAsE;EAAtE,mEAAsE;EAAtE;AAAsE;;AAAtE;AAAA;IAAA;EAAsE;AAAA;;AAAtE;AAAA;IAAA;EAAsE;AAAA;;AAStE;EAAA,iBAA4E;EAA5E,oCAA4E;EAA5E,wCAA4E;EAA5E,8FAA4E;EAA5E,qGAA4E;EAA5E,uGAA4E;EAA5E,8BAA4E;EAA5E;AAA4E;;AAE9E,gBAAgB;;AAEd;EAAA,oBAAuB;EAAvB;AAAuB;;AAMvB;EAAA,kBAA8E;EAA9E,gBAA8E;EAA9E,yBAA8E;EAA9E,qBAA8E;EAA9E;AAA8E;;AAG9E;EAAA,oBAAgM;EAAhM,mBAAgM;EAAhM,aAAgM;EAAhM,qBAAgM;EAAhM,iBAAgM;EAAhM,oCAAgM;EAAhM,qEAAgM;EAAhM,4DAAgM;EAAhM,qEAAgM;EAAhM,mEAAgM;EAAhM,qBAAgM;EAAhM,sBAAgM;EAAhM,oBAAgM;EAAhM,uBAAgM;EAAhM,mBAAgM;EAAhM,oBAAgM;EAAhM,gBAAgM;EAAhM,oBAAgM;EAAhM,iDAAgM;EAAhM,8FAAgM;EAAhM,oGAAgM;EAAhM;AAAgM;;AAAhM;AAAA;IAAA;EAAgM;AAAA;;AAGhM;EAAA,WAAsF;EAAtF,WAAsF;EAAtF,qEAAsF;EAAtF,gEAAsF;EAAtF,+DAAsF;EAAtF,mEAAsF;EAAtF;AAAsF;;AAAtF;AAAA;IAAA;EAAsF;AAAA;;AAAtF;AAAA;IAAA;EAAsF;AAAA;;AAGtF;EAAA,qBAAuF;EAAvF,iBAAuF;EAAvF,oCAAuF;EAAvF,yCAAuF;EAAvF,kIAAuF;EAAvF,0IAAuF;EAAvF,uGAAuF;EAAvF,8BAAuF;EAAvF;AAAuF;;AAGvF;EAAA,kBAA4C;EAA5C,iBAA4C;EAA5C;AAA4C;;AAG5C;EAAA,4EAAsE;EAAtE,2EAAsE;EAAtE,qEAAsE;EAAtE,mEAAsE;EAAtE;AAAsE;;AAAtE;AAAA;IAAA;EAAsE;AAAA;;AAAtE;AAAA;IAAA;EAAsE;AAAA;;AAGtE;EAAA;AAAe;;AAGf;EAAA,kBAAqB;EAArB;AAAqB;;AAEvB;IACE,WAAW;IACX,oBAAgH;IAAhH,kBAAgH;IAAhH,SAAgH;IAAhH,UAAgH;IAAhH,QAAgH;IAAhH,UAAgH;IAAhH,YAAgH;IAAhH,sEAAgH;IAAhH,2EAAgH;IAAhH,qEAAgH;IAAhH,mEAAgH;IAAhH,4DAAgH;EAClH;;AAEE;EAAA,uBAA6B;EAA7B,+DAA6B;EAA7B;AAA6B;;AAA7B;;EAAA;IAAA,uBAA6B;IAA7B,8DAA6B;IAA7B;EAA6B;AAAA;;AAG7B;EAAA,4EAAmE;EAAnE,2EAAmE;EAAnE,qEAAmE;EAAnE,mEAAmE;EAAnE;AAAmE;;AAAnE;AAAA;IAAA;EAAmE;AAAA;;AAAnE;AAAA;IAAA;EAAmE;AAAA;;AAGnE;EAAA,uBAAoE;EAApE,oCAAoE;EAApE,wCAAoE;EAApE,8BAAoE;EAApE;AAAoE;;AAGpE;EAAA,WAAwF;EAAxF,cAAwF;EAAxF,qEAAwF;EAAxF,gEAAwF;EAAxF,+DAAwF;EAAxF,mEAAwF;EAAxF;AAAwF;;AAAxF;AAAA;IAAA;EAAwF;AAAA;;AAAxF;AAAA;IAAA;EAAwF;AAAA;;AAGxF;EAAA,wBAAqC;EAArC;AAAqC;;AAGrC;EAAA,kBAAmC;EAAnC,kBAAmC;EAAnC,gBAAmC;EAAnC,qBAAmC;EAAnC,iBAAmC;EAAnC,qCAAmC;EAAnC,yCAAmC;IAAnC,2CAAmC;IAAnC,sBAAmC;IAAnC;;uHAAmC;IAAnC,uCAAmC;IAAnC;;;;;;;;;;;;AAAmC;;AAAnC;IAAA,iBAAmC;IAAnC,qBAAmC;IAAnC,wBAAmC;IAAnC,2BAAmC;IAAnC,wBAAmC;IAAnC,qBAAmC;IAAnC,wBAAmC;IAAnC,0BAAmC;EAAA;;AAAnC;IAAA,mBAAmC;EAAA;;AAAnC;EAAA,gBAAmC;EAAnC;;qHAAmC;EAAnC,uCAAmC;EAAnC;;;;;;;;;;;;AAAmC;;AAAnC;;;EAAA,iFAAmC;EAAnC,uCAAmC;EAAnC,0BAAmC;AAAA;;AAAnC;EAAA;IAAA,gBAAmC;EAAA;AAAA;;AAAnC;EAAA;IAAA,iBAAmC;IAAnC,sBAAmC;IAAnC;EAAmC;AAAA;;AAGnC;EAAA,aAAqF;EAArF,mBAAqF;EAArF,aAAqF;EAArF,wBAAqF;EAArF,oCAAqF;EAArF,kBAAqF;EAArF,mBAAqF;EAArF,qBAAqF;EAArF;AAAqF;;AAArF;;EAAA;IAAA,qBAAqF;IAArF;EAAqF;AAAA;;AAGrF;EAAA,eAA2C;EAA3C,cAA2C;EAA3C,cAA2C;EAA3C;AAA2C;;AAG3C;EAAA,eAAiE;EAAjE,mBAAiE;EAAjE,gBAAiE;EAAjE,wBAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAGjE;EAAA;AAAiB;;AAAjB;;EAAA;IAAA;EAAiB;AAAA;;AAGjB;EAAA,qBAA0D;EAA1D,oCAA0D;EAA1D,qBAA0D;EAA1D,sBAA0D;EAA1D,iBAA0D;EAA1D;AAA0D;;AAA1D;;EAAA;IAAA,oBAA0D;IAA1D;EAA0D;AAAA;;AAG1D;EAAA,aAA8P;EAA9P,mBAA8P;EAA9P,8BAA8P;EAA9P,YAA8P;EAA9P,mBAA8P;EAA9P,iBAA8P;EAA9P,oCAA8P;EAA9P,yCAA8P;EAA9P,aAA8P;EAA9P,6DAA8P;EAA9P,wDAA8P;EAA9P,0BAA8P;EAA9P;AAA8P;;AAA9P;EAAA,oCAA8P;EAA9P,wCAA8P;EAA9P,8FAA8P;EAA9P,oGAA8P;EAA9P;AAA8P;;AAG9P;EAAA,mBAAsG;EAAtG,iBAAsG;EAAtG,oCAAsG;EAAtG,wCAAsG;EAAtG,kBAAsG;EAAtG,mBAAsG;EAAtG,oBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,oBAAsG;EAAtG,oBAAsG;EAAtG;AAAsG;;AAGtG;EAAA,mBAAgG;EAAhG,iBAAgG;EAAhG,oCAAgG;EAAhG,wCAAgG;EAAhG,kBAAgG;EAAhG,mBAAgG;EAAhG,oBAAgG;EAAhG,uBAAgG;EAAhG,mBAAgG;EAAhG,oBAAgG;EAAhG,oBAAgG;EAAhG;AAAgG;;AAGhG;EAAA,gBAA8D;EAA9D,gBAA8D;EAA9D,qBAA8D;EAA9D;AAA8D;;AAG9D;EAAA,YAAoF;EAApF,qBAAoF;EAApF,2CAAoF;EAApF,wDAAoF;EAApF,0BAAoF;EAApF;AAAoF;;AAUpF;EAAA,mCAA2C;EAA3C,6BAA2C;EAA3C;AAA2C;;AAG3C;EAAA,8BAAyG;EAAzG;AAAyG;;AAAzG;EAAA,2GAAyG;EAAzG,yGAAyG;EAAzG,4FAAyG;EAAzG,oBAAyG;EAAzG,4DAAyG;EAAzG;AAAyG;;AAGzG;EAAA,kBAAqN;EAArN,UAAqN;EAArN,WAAqN;EAArN,UAAqN;EAArN,YAAqN;EAArN,gBAAqN;EAArN,sBAAqN;EAArN,mBAAqN;EAArN;AAAqN;;AAArN;EAAA,gBAAqN;EAArN,WAAqN;EAArN,YAAqN;EAArN,UAAqN;EAArN,SAAqN;EAArN,iBAAqN;EAArN,UAAqN;EAArN,mBAAqN;EAArN,eAAqN;EAArN,UAAqN;EAArN,SAAqN;EAArN,cAAqN;EAArN,sBAAqN;EAArN,kBAAqN;EAArN,2DAAqN;EAArN,kBAAqN;EAArN,mBAAqN;EAArN,mBAAqN;EAArN,sBAAqN;EAArN,mBAAqN;EAArN,oBAAqN;EAArN,gBAAqN;EAArN,oBAAqN;EAArN,mDAAqN;EAArN,mFAAqN;EAArN,uFAAqN;EAArN;AAAqN;;AAGrN;EAAA,mBAA4F;EAA5F,iBAA4F;EAA5F,oCAA4F;EAA5F,wCAA4F;EAA5F,aAA4F;EAA5F,8FAA4F;EAA5F,oGAA4F;EAA5F,uGAA4F;EAA5F,8BAA4F;EAA5F;AAA4F;;AAG5F;EAAA,mBAA0F;EAA1F,qBAA0F;EAA1F,oCAA0F;EAA1F,oBAA0F;EAA1F,kBAA0F;EAA1F,iBAA0F;EAA1F,gBAA0F;EAA1F,oBAA0F;EAA1F;AAA0F;;AAG1F;EAAA,oBAA8R;EAA9R,mBAA8R;EAA9R,aAA8R;EAA9R,sBAA8R;EAA9R,iBAA8R;EAA9R,oCAA8R;EAA9R,wCAA8R;EAA9R,qBAA8R;EAA9R,sBAA8R;EAA9R,mBAA8R;EAA9R,sBAA8R;EAA9R,mBAA8R;EAA9R,oBAA8R;EAA9R,gBAA8R;EAA9R,oBAA8R;EAA9R,iDAA8R;EAA9R,mEAA8R;EAA9R,wDAA8R;EAA9R;AAA8R;;AAA9R;EAAA,sBAA8R;EAA9R,4DAA8R;EAA9R,kBAA8R;EAA9R,4DAA8R;EAA9R,oBAA8R;EAA9R;AAA8R;;AAG9R;EAAA;AAAe;;AAGf;EAAA,oBAAoE;EAApE,kBAAoE;EAApE,QAAoE;EAApE,eAAoE;EAApE,cAAoE;EAApE,sBAAoE;EAApE;AAAoE;;AAGpE;EAAA;AAAyB;;AAAzB;;EAAA;IAAA;EAAyB;AAAA;;AAIzB;;EAAA;AAAqB;;AAArB;;EAAA;;IAAA;EAAqB;AAAA;;AAGrB;EAAA;AAA2B;;AAA3B;;EAAA;IAAA;EAA2B;AAAA;;AAI3B;;EAAA;AAAqB;;AAArB;;EAAA;;IAAA;EAAqB;AAAA;;AAGrB;EAAA,kBAA2D;EAA3D,kBAA2D;EAA3D,gBAA2D;EAA3D,qBAA2D;EAA3D,iBAA2D;EAA3D,qCAA2D;EAA3D,yCAA2D;IAA3D,2CAA2D;IAA3D,sBAA2D;IAA3D;;uHAA2D;IAA3D,uCAA2D;IAA3D;;;;;;;;;;;;AAA2D;;AAA3D;IAAA,iBAA2D;IAA3D,qBAA2D;IAA3D,wBAA2D;IAA3D,2BAA2D;IAA3D,wBAA2D;IAA3D,qBAA2D;IAA3D,wBAA2D;IAA3D,0BAA2D;EAAA;;AAA3D;IAAA,mBAA2D;EAAA;;AAA3D;EAAA,kBAA2D;EAA3D,gBAA2D;EAA3D,kIAA2D;EAA3D,0IAA2D;EAA3D,uGAA2D;EAA3D;;qHAA2D;EAA3D,uCAA2D;EAA3D;;;;;;;;;;;;AAA2D;;AAA3D;;;EAAA,iFAA2D;EAA3D,uCAA2D;EAA3D,0BAA2D;AAAA;;AAA3D;EAAA;IAAA,gBAA2D;EAAA;AAAA;;AAA3D;EAAA;IAAA,iBAA2D;IAA3D,sBAA2D;IAA3D;EAA2D;AAAA;;AAE7D;IACE,WAAW;IACX,oBAAsG;IAAtG,kBAAsG;IAAtG,YAAsG;IAAtG,UAAsG;IAAtG,aAAsG;IAAtG,YAAsG;IAAtG,qBAAsG;IAAtG,uCAAsG;IAAtG,qBAAsG;IAAtG,iLAAsG;EACxG;;AAEE;EAAA,kBAAiD;EAAjD,qBAAiD;EAAjD,cAAiD;EAAjD;AAAiD;;AAGjD;EAAA;AAAgB;;AAMhB;EAAA,oBAA+D;EAA/D,YAA+D;EAA/D,WAA+D;EAA/D,cAA+D;EAA/D,oBAA+D;EAA/D;AAA+D;;AAG/D;EAAA,kBAAiK;EAAjK,oBAAiK;EAAjK,mBAAiK;EAAjK,8BAAiK;EAAjK,WAAiK;EAAjK,gBAAiK;EAAjK,uEAAiK;EAAjK,0BAAiK;EAAjK;AAAiK;;AAIjK;;EAAA,oCAAkF;EAAlF,wCAAkF;EAAlF,8FAAkF;EAAlF,oGAAkF;EAAlF,uGAAkF;EAAlF,2GAAkF;EAAlF,yGAAkF;EAAlF,4FAAkF;EAAlF;AAAkF;;AAGlF;EAAA,cAAuI;EAAvI,mBAAuI;EAAvI,iBAAuI;EAAvI,oCAAuI;EAAvI,yCAAuI;EAAvI,iBAAuI;EAAvI,4CAAuI;EAAvI,uDAAuI;EAAvI,uGAAuI;EAAvI,8BAAuI;EAAvI;AAAuI;;AAGvI;EAAA,aAAsN;EAAtN,WAAsN;EAAtN,eAAsN;EAAtN,mBAAsN;EAAtN,8BAAsN;EAAtN,WAAsN;EAAtN,sBAAsN;EAAtN,sBAAsN;EAAtN,uBAAsN;EAAtN,qBAAsN;EAAtN,wBAAsN;EAAtN,gBAAsN;EAAtN,mBAAsN;EAAtN,oBAAsN;EAAtN,gBAAsN;EAAtN,oBAAsN;EAAtN,gDAAsN;EAAtN,qDAAsN;EAAtN,0BAAsN;EAAtN;AAAsN;;AAKtN;;;EAAA,wCAA4D;EAA5D,oBAA4D;EAA5D,gDAA4D;EAA5D,8BAA4D;EAA5D;AAA4D;;AAG5D;EAAA,oBAAuB;EAAvB;AAAuB;;AAGvB;EAAA,oBAAuB;EAAvB;AAAuB;;AAGvB;EAAA,mBAAgK;EAAhK,sBAAgK;EAAhK,iBAAgK;EAAhK,oCAAgK;EAAhK,sCAAgK;EAAhK,qBAAgK;EAAhK,sBAAgK;EAAhK,qBAAgK;EAAhK,wBAAgK;EAAhK,kBAAgK;EAAhK,iBAAgK;EAAhK,gBAAgK;EAAhK,oBAAgK;EAAhK,mDAAgK;EAAhK,8FAAgK;EAAhK,qGAAgK;EAAhK,uGAAgK;EAAhK,8BAAgK;EAAhK;AAAgK;;AAGhK;EAAA,2GAAoC;EAApC,yGAAoC;EAApC,4FAAoC;EAApC;AAAoC;;AAGpC;EAAA,gBAA0C;EAA1C,QAA0C;EAA1C,UAA0C;EAA1C,8BAA0C;EAA1C;AAA0C;;AAG1C;EAAA;AAA0B;;AAe5B;;IAEE,WAAW;IACX,oBAAyD;IAAzD,kBAAyD;IAAzD,qBAAyD;IAAzD,qBAAyD;IAAzD,iLAAyD;EAC3D;;AAEE;EAAA,YAAoD;EAApD,UAAoD;EAApD,aAAoD;EAApD,YAAoD;EAApD;AAAoD;;AAGpD;EAAA,WAAiF;EAAjF,SAAiF;EAAjF,aAAiF;EAAjF,YAAiF;EAAjF,uBAAiF;EAAjF,qBAAiF;EAAjF,+LAAiF;EAAjF;AAAiF;;AAGjF;EAAA,kBAAqB;EAArB;AAAqB;;AAGrB;EAAA,kBAAmF;EAAnF,gBAAmF;EAAnF,yBAAmF;EAAnF,sBAAmF;EAAnF,oBAAmF;EAAnF;AAAmF;;AAGnF;EAAA,aAAgH;EAAhH,cAAgH;EAAhH,mBAAgH;EAAhH,uBAAgH;EAAhH,mBAAgH;EAAhH,4EAAgH;EAAhH,mFAAgH;EAAhH,uFAAgH;EAAhH,uGAAgH;EAAhH,2GAAgH;EAAhH,yGAAgH;EAAhH,4FAAgH;EAAhH;AAAgH;;AAGhH;EAAA,aAA4I;EAA5I,mBAA4I;EAA5I,cAA4I;EAA5I,eAA4I;EAA5I,cAA4I;EAA5I,mBAA4I;EAA5I,uBAA4I;EAA5I,sBAA4I;EAA5I,4EAA4I;EAA5I,4DAA4I;EAA5I,oEAA4I;EAA5I,mEAA4I;EAA5I,wDAA4I;EAA5I,mFAA4I;EAA5I,uFAA4I;EAA5I;AAA4I;;AAG5I;EAAA,aAAsG;EAAtG,mBAAsG;EAAtG,cAAsG;EAAtG,eAAsG;EAAtG,cAAsG;EAAtG,mBAAsG;EAAtG,uBAAsG;EAAtG,sBAAsG;EAAtG;AAAsG;;AAGtG;EAAA,aAAuF;EAAvF,mBAAuF;EAAvF,WAAuF;EAAvF,mBAAuF;EAAvF,oBAAuF;EAAvF,gBAAuF;EAAvF,wBAAuF;EAAvF,oBAAuF;EAAvF;AAAuF;;AAavF;EAAA,kBAA+C;EAA/C,kBAA+C;EAA/C,gBAA+C;EAA/C,qBAA+C;EAA/C,iBAA+C;EAA/C,qCAA+C;EAA/C,yCAA+C;IAA/C,2CAA+C;IAA/C,sBAA+C;IAA/C;;uHAA+C;IAA/C,uCAA+C;IAA/C;;;;;;;;;;;;AAA+C;;AAA/C;IAAA,iBAA+C;IAA/C,qBAA+C;IAA/C,wBAA+C;IAA/C,2BAA+C;IAA/C,wBAA+C;IAA/C,qBAA+C;IAA/C,wBAA+C;IAA/C,0BAA+C;EAAA;;AAA/C;IAAA,mBAA+C;EAAA;;AAA/C;IAAA,mBAA+C;EAAA;;AAA/C;EAAA,yCAA+C;EAA/C,wDAA+C;EAA/C,0BAA+C;EAA/C;AAA+C;;AAA/C;EAAA,2BAA+C;EAA/C,+LAA+C;EAA/C,8FAA+C;EAA/C,oGAA+C;EAA/C;AAA+C;;AAA/C;EAAA,aAA+C;EAA/C;;qHAA+C;EAA/C,uCAA+C;EAA/C;;;;;;;;;;;;AAA+C;;AAA/C;;;EAAA,iFAA+C;EAA/C,uCAA+C;EAA/C,0BAA+C;AAAA;;AAA/C;EAAA,iFAA+C;EAA/C,uCAA+C;EAA/C,0BAA+C;AAAA;;AAA/C;EAAA;IAAA,gBAA+C;EAAA;EAA/C;;IAAA,gBAA+C;EAAA;AAAA;;AAA/C;EAAA;IAAA,iBAA+C;IAA/C,sBAA+C;IAA/C;EAA+C;AAAA;;AAA/C;;EAAA;IAAA;EAA+C;AAAA;;AAG/C;EAAA,oCAAgF;EAAhF,4EAAgF;EAAhF,2EAAgF;EAAhF,qEAAgF;EAAhF;AAAgF;;AAAhF;AAAA;IAAA;EAAgF;AAAA;;AAGhF;EAAA,mBAA0D;EAA1D,mBAA0D;EAA1D,oBAA0D;EAA1D,gBAA0D;EAA1D,kCAA0D;EAA1D,4IAA0D;EAA1D;AAA0D;;AAG1D;EAAA,aAAuB;EAAvB,mBAAuB;EAAvB,8BAAuB;EAAvB,SAAuB;EAAvB,mBAAuB;EAAvB,iBAAuB;EAAvB,oCAAuB;EAAvB,wCAAuB;EAAvB,aAAuB;EAAvB,8FAAuB;EAAvB,oGAAuB;EAAvB,uGAAuB;EAAvB,8BAAuB;EAAvB,uQAAuB;EAAvB,6DAAuB;EAAvB,wDAAuB;EAAvB,0BAAuB;EAAvB;AAAuB;;AAAvB;EAAA,oCAAuB;EAAvB,yCAAuB;EAAvB,8FAAuB;EAAvB,oGAAuB;EAAvB;AAAuB;;AAGvB;EAAA,kBAAgB;EAAhB;AAAgB;;AAGhB;EAAA,kBAAmI;EAAnI,wBAAmI;EAAnI,sBAAmI;EAAnI,4DAAmI;EAAnI,kBAAmI;EAAnI,4DAAmI;EAAnI,aAAmI;EAAnI,qBAAmI;EAAnI,qCAAmI;EAAnI,wDAAmI;EAAnI;AAAmI;;AAAnI;EAAA;AAAmI;;AAGnI;EAAA;AAAwB;;AAE1B;IACE,WAAW;IACX,kBAA8G;IAA9G,gBAA8G;IAA9G,cAA8G;IAA9G,aAA8G;IAA9G,UAA8G;IAA9G,qBAA8G;IAA9G,sEAA8G;IAA9G,4DAA8G;IAA9G,oEAA8G;IAA9G,mEAA8G;IAA9G,wDAA8G;EAChH;;AACA,yDAAyD;;AACzD;IACE,WAAW;IACX,gBAA8D;IAA9D,eAA8D;IAA9D,cAA8D;IAA9D,qBAA8D;IAA9D,8BAA8D;IAA9D,YAA8D;EAChE;;AAEE;EAAA,qBAA2D;EAA3D,cAA2D;EAA3D,mBAA2D;EAA3D,oBAA2D;EAA3D,gBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;;AAG3D;EAAA,aAAkQ;EAAlQ,mBAAkQ;EAAlQ,YAAkQ;EAAlQ,mBAAkQ;EAAlQ,iBAAkQ;EAAlQ,oCAAkQ;EAAlQ,yCAAkQ;EAAlQ,gBAAkQ;EAAlQ,6BAAkQ;EAAlQ,uQAAkQ;EAAlQ,uEAAkQ;EAAlQ,wDAAkQ;EAAlQ;AAAkQ;;AAAlQ;EAAA,oCAAkQ;EAAlQ,yCAAkQ;EAAlQ,8FAAkQ;EAAlQ,oGAAkQ;EAAlQ;AAAkQ;;AAAlQ;;EAAA;IAAA,SAAkQ;IAAlQ;EAAkQ;AAAA;;AAGlQ;EAAA,kBAA8B;EAA9B,kBAA8B;EAA9B,gBAA8B;EAA9B,qBAA8B;EAA9B,iBAA8B;EAA9B,qCAA8B;EAA9B,yCAA8B;IAA9B,2CAA8B;IAA9B,sBAA8B;IAA9B;;uHAA8B;IAA9B,uCAA8B;IAA9B;;;;;;;;;;;;AAA8B;;AAA9B;IAAA,iBAA8B;IAA9B,qBAA8B;IAA9B,wBAA8B;IAA9B,2BAA8B;IAA9B,wBAA8B;IAA9B,qBAA8B;IAA9B,wBAA8B;IAA9B,0BAA8B;EAAA;;AAA9B;IAAA,mBAA8B;EAAA;;AAA9B;EAAA,gBAA8B;EAA9B;;qHAA8B;EAA9B,uCAA8B;EAA9B;;;;;;;;;;;;AAA8B;;AAA9B;;;EAAA,iFAA8B;EAA9B,uCAA8B;EAA9B,0BAA8B;AAAA;;AAA9B;EAAA;IAAA,gBAA8B;EAAA;AAAA;;AAA9B;EAAA;IAAA,iBAA8B;IAA9B,sBAA8B;IAA9B;EAA8B;AAAA;;AAA9B;;EAAA;IAAA;EAA8B;AAAA;;AAEhC,kBAAkB;;AAYlB,sBAAsB;;AAEpB;EAAA,yCAA+F;EAA/F,wDAA+F;EAA/F;AAA+F;;AAA/F;EAAA,yBAA+F;EAA/F,+LAA+F;EAA/F,8FAA+F;EAA/F,qGAA+F;EAA/F;AAA+F;;AAQjG,mBAAmB;;AAEjB;;EAAA;IAAA;EAA+H;;EAA/H;IAAA;EAA+H;AAAA;;AAA/H;EAAA,qCAA+H;EAA/H,sBAA+H;EAA/H,qEAA+H;EAA/H,4DAA+H;EAA/H,qEAA+H;EAA/H,mEAA+H;EAA/H,4GAA+H;EAA/H,wDAA+H;EAA/H;AAA+H;;AAA/H;AAAA;IAAA;EAA+H;AAAA;;AAG/H;EAAA,kBAA0H;EAA1H,UAA0H;EAA1H,uBAA0H;EAA1H;AAA0H;;AAA1H;;EAAA;IAAA;EAA0H;;EAA1H;IAAA;EAA0H;AAAA;;AAA1H;EAAA,qCAA0H;EAA1H,qEAA0H;EAA1H,gEAA0H;EAA1H,+DAA0H;EAA1H,mEAA0H;EAA1H,4DAA0H;IAC1H;AAD0H;;AAA1H;AAAA;IAAA;EAA0H;AAAA;;AAA1H;AAAA;IAAA;EAA0H;AAAA;;AAG5H,sBAAsB;;AAatB,2BAA2B;;AAEzB;EAAA,iBAA0D;EAA1D,kBAA0D;EAA1D,WAA0D;EAA1D,iBAA0D;EAA1D,kBAA0D;EAA1D;AAA0D;;AAA1D;;EAAA;IAAA,oBAA0D;IAA1D;EAA0D;AAAA;;AAA1D;;EAAA;IAAA,kBAA0D;IAA1D;EAA0D;AAAA;;AAM1D;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;;EAAA;IAAA,oBAAmB;IAAnB;EAAmB;AAAA;;AAErB,sBAAsB;;AAEpB;EAAA,kBAAwH;EAAxH,kBAAwH;EAAxH,mBAAwH;EAAxH,mBAAwH;EAAxH,sBAAwH;EAAxH,mBAAwH;EAAxH,oBAAwH;EAAxH,gBAAwH;EAAxH,oBAAwH;EAAxH,iDAAwH;EAAxH,0BAAwH;EAAxH,wDAAwH;EAAxH;AAAwH;;AAAxH;EAAA,oBAAwH;EAAxH;AAAwH;;AAGxH;EAAA,kBAAuH;EAAvH,WAAuH;EAAvH,SAAuH;EAAvH,gBAAuH;EAAvH,UAAuH;EAAvH,qEAAuH;EAAvH,4DAAuH;EAAvH,oEAAuH;EAAvH,mEAAuH;EAAvH,wDAAuH;EAAvH,0BAAuH;EAAvH,wDAAuH;EAAvH,0BAAuH;IACvH;AADuH;;AAKvH;;EAAA;AAAa;;AAGb;EAAA,mBAA6D;EAA7D,oBAA6D;EAA7D,qBAA6D;EAA7D,mBAA6D;EAA7D,sBAA6D;EAA7D,kBAA6D;EAA7D;AAA6D;;AAA7D;;EAAA;IAAA,kBAA6D;IAA7D,mBAA6D;IAA7D,mBAA6D;IAA7D;EAA6D;AAAA;;AAQ/D,wBAAwB;;AAEtB;EAAA,kBAAkH;EAAlH,gBAAkH;EAAlH,mBAAkH;EAAlH,iBAAkH;EAAlH,oCAAkH;EAAlH,wCAAkH;EAAlH,8FAAkH;EAAlH,oGAAkH;EAAlH,uGAAkH;EAAlH,8BAAkH;EAAlH;AAAkH;;AAAlH;EAAA,kBAAkH;EAAlH,gBAAkH;EAAlH,mBAAkH;EAAlH,iBAAkH;EAAlH,oCAAkH;EAAlH,wCAAkH;EAAlH,8FAAkH;EAAlH,oGAAkH;EAAlH,uGAAkH;EAAlH,8BAAkH;EAAlH;AAAkH;;AAEpH,kCAAkC;;AAClC;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oGAAoG;IACpG,4BAA4B;IAC5B,0DAA0D;IAC1D,oBAAoB;EACtB;;AACA;;IAEE,2BAA2B;EAC7B;;AACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;AAEA;IACE;MACE,gBAAgB;MAChB,eAAe;MACf,UAAU;IACZ;EACF;;AAEA,0DAA0D;;AAExD;EAAA,kBAAuC;EAAvC,kBAAuC;EAAvC,gBAAuC;IACvC;0HACsH;IACtH;;;;;;AAHuC;;AAUzC;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,OAAO;IACP,UAAU;IACV,sBAAsB;IACtB;;;;;;;KAOC;IACD,0CAA0C;IAC1C,wDAAwD;IACxD,oBAAoB;IACpB,UAAU;IACV,0BAA0B;EAC5B;;AACA;IACE;;MAEE,0CAA0C;MAC1C,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,yCAAyC;MACzC,YAAY;IACd;IACA;;MAEE,yCAAyC;MACzC,UAAU;IACZ;EACF;;AACA;IACE;MACE,eAAe;MACf,YAAY;MACZ,wCAAwC;IAC1C;EACF;;AAEA,qEAAqE;;AAEnE;EAAA,mBAA0F;EAA1F,iBAA0F;EAA1F,oCAA0F;EAA1F,wCAA0F;EAA1F,8FAA0F;EAA1F,oGAA0F;EAA1F,uGAA0F;EAA1F,8BAA0F;EAA1F;AAA0F;;AAS1F;EAAA,mBAA8D;EAA9D,oBAA8D;EAA9D,gBAA8D;EAA9D,wBAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;;AAM9D;EAAA,kBAAkF;EAAlF,gBAAkF;EAAlF,yBAAkF;EAAlF,sBAAkF;EAAlF,oBAAkF;EAAlF;AAAkF;;AAGlF;EAAA,WAAsC;EAAtC,WAAsC;EAAtC;AAAsC;;AAI1C;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uEAAmB;EAAnB,8EAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uDAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uFAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8FAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mFAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mFAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8FAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kIAAmB;EAAnB,0IAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8FAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6EAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wFAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6EAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uEAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;AACnB,uBAAuB;AACvB;EACE,UAAU;EACV,WAAW;AACb;AAEE;EAAA,qBAAoC;EAApC,kBAAoC;EAApC;AAAoC;AAGpC;EAAA,qBAAsH;EAAtH,sEAAsH;EAAtH,2EAAsH;EAAtH,qEAAsH;EAAtH;AAAsH;AAAtH;AAAA;IAAA;EAAsH;AAAA;AAAtH;EAAA,4DAAsH;EAAtH,oEAAsH;EAAtH,mEAAsH;EAAtH;AAAsH;AAGtH;EAAA,kBAAuB;EAAvB;AAAuB;AAEzB,sBAAsB;AACtB;EACE,qBAAqB;EACrB,uDAAuD;AACzD;AACA,oFAAoF;AACpF;EACE;;qHAEmH;EACnH,uCAAuC;EACvC;;;;;;;;;;;2FAWyF;AAC3F;AACA,8EAA8E;AAC9E;;;;;;;;;;;;;;EAcE,iFAAiF;EACjF,uCAAuC;EACvC,0BAA0B;AAC5B;AACA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;AACA;2FAC2F;AAC3F;EACE;;;IAGE,eAAe;EACjB;AACF;AACA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE;;;;;;;;;GASC;AACH;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB;;;;0FAIwF;AAC1F;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sFAAsF;EACtF,0BAA0B;EAC1B,8FAA8F;AAChG;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB;;;;;;;GAOC;AACH;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;;;GAIC;EACD,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB;;;;;;GAMC;AACH;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB;;;;;;GAMC;AACH;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB;;;;;;GAMC;AACH;AACA;EACE;;;;;;cAMY;AACd;AACA;EACE;;;;;;cAMY;AACd;AACA;EACE;;;;;;cAMY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,0DAA0D;AAC5D;AACA;EACE;;IAEE,2DAA2D;EAC7D;EACA;IACE;mDAC+C;EACjD;EACA;IACE;qDACiD;EACnD;AACF;AACA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF;AACA,mGAAmG;AACnG;EACE,mCAAmC;AACrC;AACA;EACE;;;;GAIC;AACH;AACA,2DAA2D;AAEzD;EAAA,aAAmC;EAAnC;AAAmC;AAAnC;;EAAA;IAAA;EAAmC;AAAA;AAAnC;;EAAA;IAAA;EAAmC;AAAA;AAGnC;EAAA;AAAwB;AAAxB;;EAAA;IAAA;EAAwB;AAAA;AAAxB;;EAAA;IAAA;EAAwB;AAAA;AAGxB;EAAA,mBAA+E;EAA/E,oBAA+E;EAA/E,gBAA+E;EAA/E,iBAA+E;EAA/E,oBAA+E;EAA/E;AAA+E;AAA/E;;EAAA;IAAA,iBAA+E;IAA/E;EAA+E;AAAA;AAA/E;;EAAA;IAAA,mBAA+E;IAA/E;EAA+E;AAAA;AAG/E;EAAA,eAAoF;EAApF,gBAAoF;EAApF,kBAAoF;EAApF,oBAAoF;EAApF;AAAoF;AAApF;;EAAA;IAAA,kBAAoF;IAApF;EAAoF;AAAA;AAApF;;EAAA;IAAA,mBAAoF;IAApF;EAAoF;AAAA;AAGpF;EAAA;AAA0B;AAA1B;;EAAA;IAAA;EAA0B;AAAA;AAA1B;;EAAA;IAAA;EAA0B;AAAA;AAE5B;EAEI;IAAA;EAAc;EAGd;IAAA;EAAY;EAGZ;IAAA,kBAA4B;IAA5B,oBAA4B;IAA5B;EAA4B;EAG5B;IAAA,kBAA2B;IAA3B,iBAA2B;IAA3B;EAA2B;EAG3B;IAAA;EAAU;AAEd;AACA;EAEI;IAAA;EAAU;AAEd;AAEE;;EAAA;IAAA,iBAAmD;IAAnD,kBAAmD;IAAnD,WAAmD;IAAnD;EAAmD;AAAA;AAErD,iCAAiC;AACjC;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA,gCAAgC;AAE9B;EAAA,eAAyD;EAAzD,cAAyD;EAAzD,eAAyD;EAAzD,iBAAyD;EAAzD,6BAAyD;EAAzD;AAAyD;AAGzD;EAAA,cAAqH;EAArH,cAAqH;EAArH,aAAqH;EAArH,qBAAqH;EAArH,wCAAqH;EAArH,0DAAqH;EAArH,wDAAqH;EAArH;AAAqH;AAKrH;;;EAAA,kBAA0C;EAA1C,kBAA0C;EAA1C,+LAA0C;EAA1C,kBAA0C;EAA1C,2DAA0C;EAA1C,mFAA0C;EAA1C,uFAA0C;EAA1C;AAA0C;AAG1C;EAAA,qBAAgG;EAAhG,8BAAgG;EAAhG,mBAAgG;EAAhG,2GAAgG;EAAhG,yGAAgG;EAAhG,4FAAgG;EAAhG,sCAAgG;EAAhG,2BAAgG;EAAhG;AAAgG;AAGhG;EAAA,gBAAoC;EAApC,oBAAoC;EAApC;AAAoC;AAEtC;EACE,uBAAuB;AACzB;AACA,mBAAmB;AACnB;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;EACA;;IAEE,gBAAgB;EAClB;AACF;AACA,uBAAuB;AACvB;EAII;;;IAAA,iBAAoC;IAApC,sBAAoC;IAApC;EAAoC;EAKpC;;;IAAA,iBAAoC;IAApC,sBAAoC;IAApC;EAAoC;AAExC;AAjwCA;EAkKE;IACE,0CAA0C;EAC5C;EAQA;IACE,uDAAuD;EACzD;EACA;IACE;MACE,qDAAqD;IACvD;EACF;EAEE;IAAA,gBAAgC;IAAhC;EAAgC;EAGhC;IAAA;MAAA,iCAAiD;IAAA;EAAA;EAAjD;IAAA,qBAAiD;IAAjD,sBAAiD;IAAjD,aAAiD;IAAjD,WAAiD;IAAjD,gBAAiD;IAAjD,qBAAiD;IAAjD,sBAAiD;IAAjD;EAAiD;EAAjD;IAAA;MAAA,iCAAiD;IAAA;EAAA;EAAjD;IAAA,qBAAiD;IAAjD,sBAAiD;IAAjD,aAAiD;IAAjD,WAAiD;IAAjD,gBAAiD;IAAjD,qBAAiD;IAAjD,sBAAiD;IAAjD,uBAAiD;IACjD,iCAAiC;IACjC;EAFiD;EAAjD;IAAA;MAAA,iCAAiD;IAAA;EAAA;EAAjD;IAAA,qBAAiD;IAAjD,sBAAiD;IAAjD,aAAiD;IAAjD,WAAiD;IAAjD,gBAAiD;IAAjD,qBAAiD;IAAjD,sBAAiD;IAAjD,uBAAiD;IACjD,iCAAiC;IACjC;EAFiD;EAInD;IACE,aAAa;EACf;AAokCF;AAlwCA;EAqKE;IACE,gDAAgD;EAClD;EAcE;IAAA,gBAAgC;IAAhC;EAAgC;AA6kCpC;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,qBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,qBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,mBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,mBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,2GAkwCA;EAlwCA,yGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,2BAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,eAkwCA;EAlwCA,eAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,iBAkwCA;EAlwCA,iBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,sBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,sBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,sBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,uEAkwCA;EAlwCA,8EAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,4DAkwCA;EAlwCA,mEAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,4DAkwCA;EAlwCA,mEAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,4DAkwCA;EAlwCA,mEAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,4DAkwCA;EAlwCA,oEAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,4CAkwCA;EAlwCA,2DAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,mFAkwCA;EAlwCA,uFAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,+EAkwCA;EAlwCA,mGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,6EAkwCA;EAlwCA,iGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,8FAkwCA;EAlwCA,oGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kIAkwCA;EAlwCA,0IAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,8FAkwCA;EAlwCA,oGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,sBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,sBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,sBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,8FAkwCA;EAlwCA,oGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,8BAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,2GAkwCA;EAlwCA,yGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,8BAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,2GAkwCA;EAlwCA,yGAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,eAkwCA;EAlwCA,eAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,qBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,0BAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,iBAkwCA;EAlwCA,iBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,kBAkwCA;EAlwCA,kBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA,oBAkwCA;EAlwCA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;;EAAA;IAAA,kBAkwCA;IAlwCA,UAkwCA;IAlwCA,WAkwCA;IAlwCA,UAkwCA;IAlwCA,YAkwCA;IAlwCA,gBAkwCA;IAlwCA,sBAkwCA;IAlwCA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,gBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,gBAkwCA;IAlwCA,oBAkwCA;IAlwCA,4BAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,mDAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,8DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,sBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,oBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,0BAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,eAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,2GAkwCA;IAlwCA,yGAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;AAAA;AAlwCA;;EAAA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,gBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,sDAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,oDAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,4DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,+DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,8DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,4DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,oBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,sBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,oBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,oBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,oBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,8BAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,eAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,eAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;;IAAA;MAAA;IAkwCA;EAAA;AAAA;AAlwCA;;EAAA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,oDAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;AAAA;AAlwCA;;EAAA;IAAA,kBAkwCA;IAlwCA,UAkwCA;IAlwCA,WAkwCA;IAlwCA,UAkwCA;IAlwCA,YAkwCA;IAlwCA,gBAkwCA;IAlwCA,sBAkwCA;IAlwCA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,gBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,2DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,+DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,gEAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,+DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,4DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,8DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,gBAkwCA;IAlwCA,uBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,sBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,oBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,gBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,oBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,iBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,eAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,eAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;AAAA;AAlwCA;;EAAA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,+DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,8DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,+DAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,qBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,eAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,kBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;;EAlwCA;IAAA,mBAkwCA;IAlwCA;EAkwCA;AAAA;AAlwCA;;EAAA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA;EAkwCA;;EAlwCA;IAAA,uBAkwCA;IAlwCA,2DAkwCA;IAlwCA;EAkwCA;AAAA;AAlwCA;;EAAA;;IAAA;MAAA;IAkwCA;;IAlwCA;MAAA;IAkwCA;;IAlwCA;MAAA;IAkwCA;EAAA;AAAA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;;EAAA;IAAA;EAkwCA;AAAA;AAlwCA;EAAA;AAkwCA;AAlwCA;EAAA;AAkwCA;AAlwCA;;EAAA;IAAA;EAkwCA;AAAA;AAlwCA;;EAAA;IAAA;EAkwCA;AAAA;AAlwCA;;EAAA;IAAA;EAkwCA;AAAA","sourcesContent":["/* Auto-generated by scripts/merge-styles.js — edit styles/css/*.css instead */\n\n@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800;900&family=Ubuntu+Mono:wght@400;600&display=swap');\n@import 'react-loading-skeleton/dist/skeleton.css';\n\n@property --card-lift {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: 0px;\n}\n@property --card-shadow-y {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: 8px;\n}\n@property --card-shadow-blur {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: 28px;\n}\n@property --card-shadow-spread {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: -6px;\n}\n@property --card-shadow-alpha {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.08;\n}\n@property --card-shadow-y2 {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: 1px;\n}\n@property --card-shadow-blur2 {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: 2px;\n}\n@property --card-shadow-alpha2 {\n  syntax: '<number>';\n  inherits: false;\n  initial-value: 0.04;\n}\n\n@tailwind base;\n@layer base {\n  :root {\n    --noise: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='1' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.02'/%3E%3C/svg%3E\");\n  }\n  * {\n    @apply border-secondary-200/50 ;\n  }\n  html {\n    scroll-behavior: smooth;\n    -webkit-text-size-adjust: 100%;\n    text-size-adjust: 100%;\n  }\n  body {\n    @apply bg-gradient-to-br from-orange-50 via-white to-amber-50/30 text-secondary-900 font-sans    ;\n    font-feature-settings: \"rlig\" 1, \"calt\" 1, \"ss01\" 1;\n    background-image: var(--noise);\n    min-height: 100vh;\n    min-height: 100dvh;\n    overflow-x: clip;\n  }\n  /* Selection styles */\n  ::selection {\n    @apply bg-orange-400/20 text-orange-800  ;\n  }\n  :focus-visible {\n    @apply outline-none;\n  }\n  @media (prefers-reduced-motion: reduce) {\n    html {\n      scroll-behavior: auto;\n    }\n    *,\n    *::before,\n    *::after {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n}\n\n@tailwind components;\n@layer components {\n  /* Legacy button utility classes — prefer <Button variant=\"...\" /> in components */\n  .btn-primary {\n    @apply relative inline-flex items-center justify-center rounded-2xl bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-3 text-sm font-semibold text-white shadow-[0_8px_24px_rgba(249,115,22,0.28)] transition-[color,background-color,border-color,box-shadow,transform] duration-200 ease-out hover:from-orange-600 hover:to-orange-700 hover:scale-[1.02] hover:shadow-glow focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/70 focus-visible:ring-offset-2 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100 ;\n  }\n  .btn-primary::before {\n    @apply absolute inset-0 rounded-xl bg-gradient-to-r from-white/20 to-transparent opacity-0 transition-opacity duration-300;\n    content: '';\n  }\n  .btn-primary:hover::before {\n    @apply opacity-100;\n  }\n  .btn-secondary {\n    @apply relative inline-flex items-center justify-center rounded-2xl border border-secondary-200/70 bg-white/75 px-6 py-3 text-sm font-semibold text-secondary-700 shadow-[inset_0_1px_0_rgba(255,255,255,0.65)] backdrop-blur-md transition-[color,background-color,border-color,box-shadow,transform] duration-200 ease-out hover:bg-white hover:scale-[1.02] hover:shadow-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/70 focus-visible:ring-offset-2 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50     ;\n  }\n  .btn-ghost {\n    @apply inline-flex items-center justify-center rounded-2xl px-6 py-3 text-sm font-semibold text-secondary-600 transition-[color,background-color,transform] duration-200 ease-out hover:bg-secondary-100/60 hover:text-secondary-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/70 focus-visible:ring-offset-2 active:scale-[0.98]    ;\n  }\n  .btn-accent {\n    @apply relative inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-amber-400 to-amber-500 px-6 py-3 text-sm font-semibold text-white shadow-elegant transition-[color,background-color,border-color,box-shadow,transform] duration-300 hover:from-amber-500 hover:to-amber-500 hover:scale-105 hover:shadow-glow focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 active:scale-95;\n  }\n  /* Premium Card Styles */\n  .card {\n    @apply bg-white/70 backdrop-blur-sm rounded-2xl shadow-soft border border-white/50 overflow-hidden transition-[color,background-color,border-color,box-shadow,transform] duration-300 hover:shadow-medium hover:bg-white/80   ;\n  }\n  .card-premium {\n    @apply relative isolate bg-white/95 rounded-3xl border border-secondary-200/55 overflow-hidden;\n    --card-ease: cubic-bezier(0.22, 1, 0.36, 1);\n    --card-duration: 500ms;\n    box-shadow:\n      0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),\n      0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));\n    transform: translateY(var(--card-lift));\n    transition:\n      --card-lift var(--card-duration) var(--card-ease),\n      --card-shadow-y var(--card-duration) var(--card-ease),\n      --card-shadow-blur var(--card-duration) var(--card-ease),\n      --card-shadow-spread var(--card-duration) var(--card-ease),\n      --card-shadow-alpha var(--card-duration) var(--card-ease),\n      --card-shadow-y2 var(--card-duration) var(--card-ease),\n      --card-shadow-blur2 var(--card-duration) var(--card-ease),\n      --card-shadow-alpha2 var(--card-duration) var(--card-ease),\n      transform var(--card-duration) var(--card-ease),\n      border-color var(--card-duration) var(--card-ease),\n      box-shadow var(--card-duration) var(--card-ease);\n  }.card-premium:hover {\n    --card-lift: -1px;\n    --card-shadow-y: 16px;\n    --card-shadow-blur: 40px;\n    --card-shadow-spread: -10px;\n    --card-shadow-alpha: 0.1;\n    --card-shadow-y2: 3px;\n    --card-shadow-blur2: 6px;\n    --card-shadow-alpha2: 0.04;\n  }\n  .card-premium.interactive-lift:hover {\n    --card-lift: -1.5px;\n  }\n  .card-premium-accent {\n    @apply border-orange-300/45 text-white ;\n  }\n  .card-premium-accent:hover {\n    border-color: rgb(255 255 255 / 0.32);\n  }\n  .card-glass {\n    @apply bg-white/20 backdrop-blur-xl rounded-3xl border border-white/30 shadow-glass overflow-hidden  ;\n  }\n  .card-gradient {\n    @apply bg-gradient-to-br from-white/90 via-white/60 to-orange-50/50 backdrop-blur-sm rounded-3xl border border-white/40 shadow-elegant overflow-hidden    ;\n  }\n  .view-section-header {\n    @apply flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between;\n  }\n  .safe-top {\n    padding-top: env(safe-area-inset-top, 0px);\n  }\n  .safe-bottom {\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n  .safe-x {\n    padding-left: env(safe-area-inset-left, 0px);\n    padding-right: env(safe-area-inset-right, 0px);\n  }\n  .safe-inset-bottom {\n    bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));\n  }\n  @media (min-width: 1024px) {\n    .safe-inset-bottom {\n      bottom: calc(2rem + env(safe-area-inset-bottom, 0px));\n    }\n  }\n  .touch-target {\n    @apply min-h-[44px] min-w-[44px];\n  }\n  .mobile-scroll-x {\n    @apply -mx-1 flex gap-2 overflow-x-auto px-1 pb-1;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  .mobile-scroll-x::-webkit-scrollbar {\n    display: none;\n  }\n  @media (max-width: 1023px) {\n    .table-shell,\n    .overflow-x-auto {\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n  .modal-sheet {\n    @apply w-full max-w-lg rounded-3xl;\n  }\n  .modal-sheet-lg {\n    @apply w-full max-w-2xl rounded-3xl;\n  }\n  .modal-sheet-prospect {\n    @apply w-full max-w-2xl rounded-3xl lg:max-w-5xl;\n  }\n  .modal-sheet-xl {\n    @apply w-full max-w-4xl rounded-3xl lg:max-w-5xl;\n  }\n  .modal-sheet-sm {\n    @apply w-full max-w-md rounded-3xl;\n  }\n  .empty-state-panel {\n    @apply rounded-3xl border border-dashed border-orange-200/80 bg-gradient-to-b from-orange-50/90 to-white   ;\n  }\n  .interactive-lift:not(.card-premium) {\n    @apply transition-[transform,box-shadow] duration-300 ease-out;\n  }\n  .interactive-lift:not(.card-premium):hover {\n    @apply -translate-y-0.5 shadow-medium;\n  }\n  .filter-chip {\n    @apply rounded-xl px-3 py-1.5 text-sm font-medium transition-[color,background-color,box-shadow] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/60 focus-visible:ring-offset-2 ;\n  }\n  .filter-chip-active {\n    @apply bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-[0_4px_14px_rgba(249,115,22,0.35)]  ;\n  }\n  .filter-chip-inactive {\n    @apply text-secondary-500 hover:bg-secondary-100/80 hover:text-secondary-800   ;\n  }\n  /* Form Styles — iOS premium filled controls */\n  .input-field {\n    @apply block w-full rounded-2xl border border-secondary-200/60 bg-white/80 px-4 py-3 text-sm text-secondary-900 placeholder-secondary-400 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)] backdrop-blur-md transition-[color,background-color,border-color,box-shadow,transform] duration-200 ease-out focus:border-orange-300/80 focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-400/25 focus:shadow-soft disabled:cursor-not-allowed disabled:bg-secondary-100/80 disabled:text-secondary-500        ;\n  }\n  .input-premium {\n    @apply block w-full rounded-2xl border-0 bg-white/85 px-6 py-4 text-sm text-secondary-900 placeholder-secondary-400 shadow-soft ring-1 ring-secondary-200/45 backdrop-blur-md transition-[color,background-color,box-shadow,ring-color,transform] duration-200 ease-out focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-400/35 focus:shadow-medium      ;\n  }\n  .textarea-field {\n    @apply input-field min-h-[96px] resize-y leading-relaxed;\n  }\n  .select-field {\n    @apply block w-full rounded-2xl border border-secondary-200/60 bg-white/80 px-4 py-3 text-sm text-secondary-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)] backdrop-blur-md transition-[color,background-color,border-color,box-shadow] duration-200 ease-out focus:border-orange-300/80 focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-400/25 focus:shadow-soft disabled:bg-secondary-100/80 disabled:text-secondary-500      ;\n  }\n  .ios-date-wrap {\n    @apply relative;\n  }\n  .ios-date-input {\n    @apply pr-10;\n    color-scheme: light;\n  }\n  .ios-date-icon {\n    @apply absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-orange-500/80 ;\n  }\n  .ios-search-wrap {\n    @apply relative flex items-center;\n  }\n  .ios-search-input {\n    @apply w-full rounded-2xl border border-secondary-200/60 bg-white/80 py-2.5 pl-11 pr-10 text-sm text-secondary-900 placeholder-secondary-400 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)] backdrop-blur-md transition-[border-color,box-shadow,background-color] duration-200 ease-out focus:border-orange-300/80 focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-400/25      ;\n  }\n  .ios-search-icon {\n    @apply absolute left-3.5 top-1/2 h-5 w-5 -translate-y-1/2 text-orange-500/75 ;\n  }\n  .ios-search-clear {\n    @apply absolute right-2 top-1/2 -translate-y-1/2 rounded-xl p-1.5 text-secondary-400 transition-colors hover:bg-secondary-100/80 hover:text-secondary-700  ;\n  }\n  .ios-switch {\n    @apply relative inline-flex h-[31px] w-[51px] shrink-0 items-center rounded-full border border-transparent bg-secondary-200/90 p-0.5 shadow-[inset_0_1px_2px_rgba(15,23,42,0.08)] transition-[background-color,box-shadow] duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50 focus-visible:ring-offset-2  ;\n  }\n  .ios-switch-on {\n    @apply bg-gradient-to-r from-orange-500 to-amber-500 shadow-glow  ;\n  }\n  .ios-switch-thumb {\n    @apply block h-[27px] w-[27px] translate-x-0 rounded-full bg-white shadow-[0_2px_8px_rgba(15,23,42,0.18)] transition-[transform,width] duration-200 ease-out;\n  }\n  .ios-switch:active .ios-switch-thumb {\n    @apply w-[31px];\n  }\n  .ios-switch-on:active .ios-switch-thumb {\n    @apply translate-x-4;\n  }\n  .ios-switch-on .ios-switch-thumb {\n    @apply translate-x-5;\n  }\n  .ios-checkbox {\n    @apply relative inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-secondary-300/80 bg-white/90 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)] transition-[background-color,border-color,transform,box-shadow] duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50 focus-visible:ring-offset-2   ;\n  }\n  .ios-checkbox-checked {\n    @apply border-orange-500 bg-gradient-to-br from-orange-500 to-amber-500 text-white shadow-glow  ;\n  }\n  .ios-checkbox-icon {\n    @apply flex items-center justify-center text-white;\n  }\n  .ios-checkbox-row {\n    @apply flex items-start gap-3;\n  }\n  .ios-checkbox-label {\n    @apply block text-sm font-medium text-secondary-900 ;\n  }\n  .ios-checkbox-description {\n    @apply mt-0.5 block text-xs leading-relaxed text-secondary-500 ;\n  }\n  .ios-segmented {\n    @apply relative inline-flex items-center rounded-2xl border border-secondary-200/60 bg-secondary-100/70 p-1 shadow-[inset_0_1px_2px_rgba(15,23,42,0.05)] backdrop-blur-sm  ;\n  }\n  .ios-segmented-compact .ios-segment {\n    @apply px-3 py-1.5 text-xs;\n  }\n  .ios-segmented-default .ios-segment {\n    @apply px-4 py-2 text-xs sm:text-sm;\n  }\n  .ios-segment {\n    @apply relative z-[1] inline-flex min-h-[36px] items-center justify-center rounded-xl font-semibold text-secondary-600 transition-colors duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50 ;\n  }\n  .ios-segment-active {\n    @apply text-orange-700 ;\n  }\n  .ios-segment-pill {\n    @apply absolute inset-0 rounded-xl bg-white shadow-soft ;\n  }\n  .ios-segment-label {\n    @apply relative z-[1];\n  }\n  .ios-tabs-nav-vertical {\n    @apply card-premium w-full shrink-0 p-2 lg:w-64;\n  }\n  .ios-tabs-nav-horizontal {\n    @apply w-full;\n  }\n  .ios-tabs-scroll {\n    @apply mobile-scroll-x pb-1;\n  }\n  .ios-tab {\n    @apply relative flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-left text-sm font-medium text-secondary-600 transition-colors duration-200 ease-out hover:text-secondary-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50  ;\n  }\n  .ios-tab-active {\n    @apply text-orange-700 ;\n  }\n  .ios-tab-indicator {\n    @apply absolute inset-0 rounded-2xl border border-orange-200/70 bg-gradient-to-r from-orange-500/15 to-amber-500/10 shadow-[inset_2.5px_0_0_0_rgb(234_88_12)]  ;\n  }\n  .ios-tab-icon {\n    @apply relative z-[1] text-current;\n  }\n  .ios-tab span:last-child {\n    @apply relative z-[1];\n  }\n  .ios-modal-footer {\n    @apply shrink-0 border-t border-secondary-200/60 bg-white p-4   sm:px-6 sm:pb-6 sm:pt-4;\n  }\n  .ios-settings-row {\n    @apply flex items-center justify-between gap-4 rounded-2xl border border-secondary-200/60 bg-white/70 p-4 shadow-soft backdrop-blur-md transition-[background-color,border-color,box-shadow] duration-200 ease-out hover:border-orange-200/70 hover:bg-white/85 hover:shadow-medium   ;\n  }\n  /* Hide browser's default password toggle icons */\n  input[type=\"password\"]::-webkit-credentials-auto-fill-button,\n  input[type=\"password\"]::-webkit-textfield-decoration-container,\n  input[type=\"password\"]::-webkit-caps-lock-indicator,\n  input[type=\"password\"]::-webkit-strong-password-auto-fill-button,\n  input[type=\"password\"]::-ms-reveal,\n  input[type=\"password\"]::-ms-clear {\n    display: none !important;\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    appearance: none !important;\n    visibility: hidden !important;\n    opacity: 0 !important;\n    width: 0 !important;\n    height: 0 !important;\n    position: absolute !important;\n    right: -9999px !important;\n  }\n  /* Additional rules for Edge and Chrome */\n  input[type=\"password\"] {\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    appearance: none !important;\n  }\n  /* Target password inputs specifically */\n  input[type=\"password\"]::-webkit-outer-spin-button,\n  input[type=\"password\"]::-webkit-inner-spin-button {\n    -webkit-appearance: none !important;\n    margin: 0 !important;\n  }\n  /* Background Styles */\n  .gradient-bg {\n    @apply bg-gradient-to-br from-orange-50/50 via-white to-amber-50/30   ;\n  }\n  .gradient-mesh {\n    @apply bg-mesh-gradient;\n  }\n  .glass-effect {\n    @apply bg-white/60 backdrop-blur-xl border border-white/30 shadow-glass  ;\n  }\n  .glass-strong {\n    @apply bg-white/80 backdrop-blur-2xl border border-white/50 shadow-elegant  ;\n  }\n  /* Text Styles */\n  .text-gradient {\n    @apply text-orange-600 ;\n  }\n  .text-gradient-accent {\n    @apply text-amber-600 ;\n  }\n  .eyebrow {\n    @apply text-[0.65rem] font-bold uppercase tracking-[0.2em] text-orange-600/90 ;\n  }\n  .badge-premium {\n    @apply inline-flex items-center gap-1.5 rounded-full border border-orange-200/60 bg-gradient-to-r from-orange-50 to-amber-50/80 px-3 py-1 text-2xs font-semibold text-orange-800 shadow-soft    ;\n  }\n  .divider-gradient {\n    @apply h-px w-full bg-gradient-to-r from-transparent via-orange-300/50 to-transparent ;\n  }\n  .surface-elevated {\n    @apply rounded-3xl border border-white/60 bg-white/75 shadow-premium backdrop-blur-md  ;\n  }\n  .app-shell {\n    @apply relative min-h-screen overflow-hidden;\n  }\n  .dashboard-shell {\n    @apply bg-gradient-to-br from-orange-50/80 via-white to-amber-50/25   ;\n  }\n  .dashboard-main {\n    @apply relative;\n  }\n  .dashboard-main > .container-premium {\n    @apply relative z-[1];\n  }\n  .dashboard-main::before {\n    content: '';\n    @apply pointer-events-none absolute inset-x-0 top-0 z-[2] h-8 bg-gradient-to-b from-orange-50/40 to-transparent ;\n  }\n  .content-flow {\n    @apply space-y-5 xl:space-y-6;\n  }\n  .auth-page {\n    @apply bg-gradient-to-br from-orange-50/70 via-white to-amber-50/20;\n  }\n  .shell-sidebar {\n    @apply border-r border-orange-100/50 bg-white/70 backdrop-blur-2xl  ;\n  }\n  .sidebar-brand-divider {\n    @apply h-px shrink-0 bg-gradient-to-r from-transparent via-orange-300/60 to-transparent ;\n  }\n  .topbar-blend {\n    @apply border-b border-orange-100/35 ;\n  }\n  .chart-card {\n    @apply card-premium overflow-hidden;\n  }\n  .chart-card-header {\n    @apply flex items-center gap-2.5 border-b border-secondary-100/80 px-4 py-3.5 sm:px-5;\n  }\n  .chart-card-icon {\n    @apply h-5 w-5 shrink-0 text-orange-500/90 ;\n  }\n  .chart-card-title {\n    @apply text-base font-semibold tracking-tight text-secondary-900 ;\n  }\n  .chart-card-body {\n    @apply p-5 sm:p-6;\n  }\n  .chart-card-footer {\n    @apply border-t border-secondary-100/80 px-5 py-4 sm:px-6 ;\n  }\n  .list-row-soft {\n    @apply flex items-center justify-between gap-3 rounded-2xl border border-secondary-200/60 bg-secondary-50/45 p-4 transition-[background-color,border-color,box-shadow] duration-300 ease-out hover:border-orange-200/70 hover:bg-white/80 hover:shadow-soft   ;\n  }\n  .alert-soft-success {\n    @apply rounded-2xl border border-success-200/60 bg-success-50/80 px-4 py-3 text-sm text-success-800   ;\n  }\n  .alert-soft-error {\n    @apply rounded-2xl border border-error-200/60 bg-error-50/80 px-4 py-3 text-sm text-error-800   ;\n  }\n  .strength-meter {\n    @apply h-1.5 overflow-hidden rounded-full bg-secondary-100/90 ;\n  }\n  .strength-meter-fill {\n    @apply h-full rounded-full transition-[width,background-color] duration-500 ease-out;\n  }\n  .reward-modal-scroll {\n    @apply [scrollbar-gutter:stable];\n  }\n  .reward-modal-scroll::after {\n    content: '';\n    @apply pointer-events-none sticky bottom-0 -mb-2 mt-2 block h-6 w-full bg-gradient-to-t from-white to-transparent ;\n  }\n  .sidebar-overlay {\n    @apply bg-secondary-950/40 backdrop-blur-sm;\n  }\n  .back-to-top-btn {\n    @apply focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-2 ;\n  }\n  .skip-link {\n    @apply sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[10000] focus:rounded-xl focus:bg-orange-500 focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white focus:shadow-glow;\n  }\n  .toolbar-panel {\n    @apply rounded-2xl border border-orange-100/60 bg-white/70 p-4 shadow-soft backdrop-blur-md ;\n  }\n  .toolbar-result-count {\n    @apply mt-3 border-t border-secondary-200/50 pt-3 text-xs font-medium text-secondary-500  ;\n  }\n  .filter-clear-btn {\n    @apply inline-flex items-center gap-1.5 rounded-xl border border-secondary-200/70 bg-white/70 px-3 py-2 text-sm font-medium text-secondary-600 transition-[color,background-color,border-color,box-shadow] duration-200 hover:border-orange-200 hover:bg-orange-50 hover:text-orange-700      ;\n  }\n  .input-icon-wrap {\n    @apply relative;\n  }\n  .input-icon-wrap .input-icon {\n    @apply pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2;\n  }\n  .input-icon-left .input-icon {\n    @apply left-3.5 sm:left-4;\n  }\n  .input-icon-left .input-premium,\n  .input-icon-left .input-field {\n    @apply pl-10 sm:pl-12;\n  }\n  .input-icon-right .input-icon {\n    @apply right-3.5 sm:right-4;\n  }\n  .input-icon-right .input-premium,\n  .input-icon-right .input-field {\n    @apply pr-10 sm:pr-12;\n  }\n  .auth-card {\n    @apply card-premium shadow-premium relative overflow-hidden;\n  }\n  .auth-card::before {\n    content: '';\n    @apply pointer-events-none absolute -right-20 -top-20 h-48 w-48 rounded-full bg-orange-400/10 blur-3xl;\n  }\n  .select-wrap {\n    @apply relative inline-block min-w-0 align-middle;\n  }\n  .select-wrap-open {\n    @apply z-[10020];\n  }\n  .select-with-chevron {\n    @apply appearance-none pr-9;\n  }\n  .select-chevron {\n    @apply pointer-events-none h-4 w-4 shrink-0 text-secondary-400 ;\n  }\n  .select-ios-trigger {\n    @apply relative inline-flex items-center justify-between gap-2 text-left transition-[border-color,background-color,box-shadow,transform] duration-200 ease-in-out;\n  }\n  .select-ios-trigger[data-headlessui-state~=\"open\"],\n  .select-ios-trigger-open {\n    @apply border-orange-300/70 bg-white/90 shadow-medium ring-2 ring-orange-400/20   ;\n  }\n  .dropdown-panel-ios {\n    @apply overflow-auto rounded-2xl border border-white/70 bg-white/85 p-1.5 shadow-[0_12px_40px_rgba(15,23,42,0.14)] backdrop-blur-2xl   ;\n  }\n  .dropdown-option-ios {\n    @apply flex w-full cursor-pointer items-center justify-between gap-2 rounded-xl px-3.5 py-2.5 text-left text-sm font-medium text-secondary-700 transition-[background-color,color,transform] duration-150 ease-in-out ;\n  }\n  .dropdown-option-ios:hover,\n  .dropdown-option-ios:focus-visible,\n  .dropdown-option-ios-active {\n    @apply bg-secondary-100/80 text-secondary-900 outline-none  ;\n  }\n  .dropdown-option-ios-selected {\n    @apply text-orange-600 ;\n  }\n  .dropdown-option-check {\n    @apply text-orange-500 ;\n  }\n  .tooltip-bubble {\n    @apply whitespace-nowrap rounded-xl border border-orange-200/40 bg-secondary-900/95 px-3 py-1.5 text-xs font-medium text-white shadow-elegant backdrop-blur-md  ;\n  }\n  .table-shell {\n    @apply ring-1 ring-secondary-200/40 ;\n  }\n  .table-head-sticky {\n    @apply sticky top-0 z-[1] backdrop-blur-md;\n  }\n  .table-zebra tbody tr:nth-child(even) {\n    @apply bg-secondary-50/35 ;\n  }\n  .progress-bar-premium {\n    @apply h-2 overflow-hidden rounded-full bg-secondary-100 ring-1 ring-secondary-200/50  ;\n  }\n  .progress-bar-premium-fill {\n    @apply h-full rounded-full bg-gradient-to-r from-orange-500 to-amber-500 shadow-glow;\n  }\n  .points-hero-card {\n    @apply relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-500 to-amber-500 p-6 text-center text-white shadow-glow;\n  }\n  .points-hero-card::after {\n    content: '';\n    @apply pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.22),transparent_55%)];\n  }\n  .app-shell::before,\n  .app-shell::after {\n    content: '';\n    @apply pointer-events-none absolute rounded-full blur-3xl;\n  }\n  .app-shell::before {\n    @apply -right-24 -top-24 h-72 w-72 bg-orange-400/10 ;\n  }\n  .app-shell::after {\n    @apply bottom-0 left-0 h-80 w-80 -translate-x-24 translate-y-1/4 bg-amber-400/10 ;\n  }\n  .dashboard-main > .container-premium {\n    @apply relative z-[1];\n  }\n  .stat-label {\n    @apply text-[0.66rem] font-semibold uppercase tracking-[0.14em] text-secondary-500 ;\n  }\n  .icon-tile {\n    @apply flex shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br shadow-glow ring-1 ring-white/30 ;\n  }\n  .nav-icon-active {\n    @apply flex size-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 shadow-glow aspect-square;\n  }\n  .nav-icon-inactive {\n    @apply flex size-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100/80 aspect-square ;\n  }\n  .section-title {\n    @apply flex items-center gap-2 text-lg font-semibold tracking-tight text-secondary-900 ;\n  }\n  .section-title-icon {\n    @apply h-5 w-5 shrink-0 text-orange-500 ;\n  }\n  .welcome-hero {\n    @apply card-premium relative overflow-hidden p-5 sm:p-7 bg-gradient-to-br from-orange-50/60 via-white/80 to-amber-50/40 border-orange-200/40    ;\n  }\n  .welcome-hero::before {\n    content: '';\n    @apply pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-orange-400/10 blur-3xl ;\n  }\n  .metric-tile {\n    @apply card-premium interactive-lift p-4 xl:p-5;\n  }\n  .metric-tile-accent {\n    @apply bg-gradient-to-br from-amber-50/90 to-orange-50/50 border-amber-200/40   ;\n  }\n  .metric-tile-value {\n    @apply mt-1 text-3xl font-bold tracking-tight tabular-nums;\n  }\n  .toggle-row {\n    @apply ios-settings-row;\n  }\n  .notifications-panel {\n    @apply bg-white ;\n  }\n  .notification-item {\n    @apply relative border-b border-secondary-100 bg-white p-4 pl-5 transition-[background-color] duration-200 hover:bg-orange-50/60   ;\n  }\n  .notification-item-unread {\n    @apply bg-orange-50/80  ;\n  }\n  .notification-item-unread::before {\n    content: '';\n    @apply absolute bottom-3.5 left-1.5 top-3.5 w-[3px] rounded-full bg-gradient-to-b from-orange-500 to-amber-400;\n  }\n  /* Status pill with leading dot (Stripe/Linear pattern) */\n  .status-pill::before {\n    content: '';\n    @apply h-1.5 w-1.5 shrink-0 rounded-full bg-current opacity-70;\n  }\n  .form-label {\n    @apply mb-2 block text-sm font-semibold text-secondary-700 ;\n  }\n  .feature-row {\n    @apply flex items-center gap-3 sm:gap-4 rounded-2xl border border-white/40 bg-white/45 p-3 sm:p-4 backdrop-blur-sm transition-[background-color,border-color,box-shadow,transform] duration-300 hover:border-orange-200/50 hover:bg-white/65 hover:shadow-soft    ;\n  }\n  .stepper-shell {\n    @apply card-premium p-5 sm:p-6;\n  }\n  /* Border Styles */\n  .border-gradient {\n    @apply relative bg-white rounded-2xl ;\n  }\n  .border-gradient::before {\n    @apply absolute inset-0 rounded-2xl p-[1px] bg-gradient-to-r from-orange-400 to-amber-400;\n    content: '';\n    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n    mask-composite: xor;\n    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n  }\n  /* Animation Classes */\n  .hover-lift {\n    @apply transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-elegant;\n  }\n  .hover-glow {\n    @apply transition-[box-shadow,transform,color,background-color,border-color] duration-300 hover:shadow-glow;\n  }\n  .float-animation {\n    @apply animate-float;\n  }\n  /* Loading States */\n  .skeleton {\n    @apply bg-gradient-to-r from-secondary-200 via-secondary-300 to-secondary-200 bg-[length:200px_100%] animate-shimmer rounded   ;\n  }\n  .skeleton::before {\n    @apply absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent translate-x-[-100%] animate-shimmer ;\n    content: '';\n  }\n  /* Status Indicators */\n  .status-success {\n    @apply bg-success-500 text-white;\n  }\n  .status-warning {\n    @apply bg-warning-500 text-white;\n  }\n  .status-error {\n    @apply bg-error-500 text-white;\n  }\n  .status-info {\n    @apply bg-orange-400 text-white;\n  }\n  /* Premium Layout Classes */\n  .container-premium {\n    @apply mx-auto w-full max-w-[1600px] px-4 sm:px-6 2xl:px-8;\n  }\n  .grid-premium {\n    @apply grid gap-5 lg:gap-6;\n  }\n  .section-padding {\n    @apply py-5 lg:py-7;\n  }\n  /* Navigation Styles */\n  .nav-link {\n    @apply relative px-4 py-2 text-sm font-medium text-secondary-600 transition-[color] duration-300 hover:text-orange-500  ;\n  }\n  .nav-link::after {\n    @apply absolute bottom-0 left-0 h-0.5 w-0 bg-gradient-to-r from-orange-400 to-amber-400 transition-[width] duration-300;\n    content: '';\n  }\n  .nav-link:hover::after,\n  .nav-link.active::after {\n    @apply w-full;\n  }\n  .nav-link--compact {\n    @apply whitespace-nowrap px-2 py-2 text-xs xl:px-4 xl:text-sm;\n  }\n  .btn-primary--compact {\n    @apply px-4 py-2 text-xs xl:px-6 xl:py-3 xl:text-sm;\n  }\n  .btn-ghost--compact {\n    @apply px-4 py-2 text-xs xl:px-6 xl:py-3 xl:text-sm;\n  }\n  /* Notification Styles */\n  .notification {\n    @apply relative overflow-hidden rounded-2xl bg-white/90 backdrop-blur-md border border-orange-100/50 shadow-soft  ;\n  }\n  /* Shine sweep on filled buttons */\n  .btn-shine {\n    position: relative;\n    overflow: hidden;\n  }\n  .btn-shine::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    background: linear-gradient(105deg, transparent 40%, rgba(255, 255, 255, 0.38) 50%, transparent 60%);\n    transform: translateX(-130%);\n    transition: transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n    pointer-events: none;\n  }\n  .btn-shine:hover::after,\n  .btn-shine:focus-visible::after {\n    transform: translateX(130%);\n  }\n  .btn-shine:active::after {\n    transition-duration: 0.2s;\n    transform: translateX(40%);\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .btn-shine::after {\n      transition: none;\n      transform: none;\n      opacity: 0;\n    }\n  }\n\n  /* Crystalline CTA shine — used on NextBestAction button */\n  .btn-crystal-shine {\n    @apply relative isolate overflow-hidden;\n    background:\n      linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(255, 255, 255, 0.82) 45%, rgba(255, 247, 237, 0.92) 100%);\n    box-shadow:\n      0 0 0 1px rgba(255, 255, 255, 0.65),\n      inset 0 1px 0 rgba(255, 255, 255, 1),\n      inset 0 -1px 0 rgba(249, 115, 22, 0.1),\n      0 10px 30px rgba(255, 255, 255, 0.4),\n      0 4px 18px rgba(249, 115, 22, 0.25);\n  }\n  .btn-crystal-shine::before {\n    content: '';\n    position: absolute;\n    top: -20%;\n    bottom: -20%;\n    left: 0;\n    width: 45%;\n    border-radius: inherit;\n    background: linear-gradient(\n      105deg,\n      transparent 0%,\n      rgba(255, 255, 255, 0.15) 35%,\n      rgba(255, 255, 255, 0.7) 50%,\n      rgba(255, 255, 255, 0.2) 65%,\n      transparent 100%\n    );\n    transform: translateX(-160%) skewX(-16deg);\n    animation: crystal-shine-sweep 2.8s ease-in-out infinite;\n    pointer-events: none;\n    z-index: 1;\n    mix-blend-mode: soft-light;\n  }\n  @keyframes crystal-shine-sweep {\n    0%,\n    18% {\n      transform: translateX(-160%) skewX(-16deg);\n      opacity: 0;\n    }\n    28% {\n      opacity: 1;\n    }\n    55% {\n      transform: translateX(280%) skewX(-16deg);\n      opacity: 0.9;\n    }\n    56%,\n    100% {\n      transform: translateX(280%) skewX(-16deg);\n      opacity: 0;\n    }\n  }\n  @media (prefers-reduced-motion: reduce) {\n    .btn-crystal-shine::before {\n      animation: none;\n      opacity: 0.4;\n      transform: translateX(40%) skewX(-16deg);\n    }\n  }\n\n  /* ── Design-system roles (unified source of truth) ─────────────── */\n  .surface {\n    @apply rounded-2xl border border-secondary-200/60 bg-white/70 backdrop-blur-md shadow-soft;\n  }\n  .surface-brand {\n    @apply rounded-2xl border border-orange-100/60 bg-white/75 backdrop-blur-md shadow-soft;\n  }\n  .surface-hover {\n    @apply transition-[box-shadow,border-color,transform] duration-200 ease-out hover:border-orange-200/70 hover:shadow-medium;\n  }\n  .title-line {\n    @apply text-lg font-semibold tracking-tight text-secondary-900;\n  }\n  .title-xl {\n    @apply text-xl font-bold tracking-tight text-secondary-900 sm:text-2xl;\n  }\n  .micro {\n    @apply text-[0.66rem] font-semibold uppercase tracking-[0.14em] text-secondary-500;\n  }\n  .divider-soft {\n    @apply h-px w-full bg-secondary-200/60;\n  }\n}\n\n@tailwind utilities;\n/* Enhanced Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n::-webkit-scrollbar-track {\n  @apply bg-secondary-50 rounded-full ;\n}\n::-webkit-scrollbar-thumb {\n  @apply rounded-full bg-gradient-to-b from-orange-300/80 to-orange-400/90 hover:from-orange-400 hover:to-orange-500    ;\n}\n::-webkit-scrollbar-corner {\n  @apply bg-secondary-50 ;\n}\n/* Firefox scrollbar */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: rgb(251 146 60 / 0.7) rgb(248 250 252);\n}\n/* Keep card-premium shadow animation above utility classes (e.g. shadow-premium). */\n.card-premium {\n  box-shadow:\n    0 var(--card-shadow-y2) var(--card-shadow-blur2) rgb(15 23 42 / var(--card-shadow-alpha2)),\n    0 var(--card-shadow-y) var(--card-shadow-blur) var(--card-shadow-spread) rgb(15 23 42 / var(--card-shadow-alpha));\n  transform: translateY(var(--card-lift));\n  transition:\n    --card-lift var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    --card-shadow-y var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    --card-shadow-blur var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    --card-shadow-spread var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    --card-shadow-alpha var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    --card-shadow-y2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    --card-shadow-blur2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    --card-shadow-alpha2 var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    transform var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    border-color var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1)),\n    box-shadow var(--card-duration, 400ms) var(--card-ease, cubic-bezier(0.22, 1, 0.36, 1));\n}\n/* Scoped transitions — avoid fighting Framer mount animations on every node */\na:not(.card-premium),\nbutton:not(.card-premium),\ninput,\nselect,\ntextarea,\n.card,\n.card-glass,\n.card-gradient,\n.btn-primary,\n.btn-secondary,\n.btn-ghost,\n.btn-accent,\n.interactive-lift:not(.card-premium),\n.filter-chip {\n  transition-property: color, background-color, border-color, box-shadow, transform;\n  transition-timing-function: ease-in-out;\n  transition-duration: 150ms;\n}\n/* Print styles */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  * {\n    box-shadow: none !important;\n    text-shadow: none !important;\n  }\n}\n/* iOS auto-zoom guard: inputs under 16px zoom the whole page on focus (phones/small tablets).\n   :not() chain raises specificity above inline .text-sm utilities on touch form factors. */\n@media (max-width: 768px) {\n  input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='button']):not([type='submit']):not([type='reset']):not([type='image']),\n  select,\n  textarea {\n    font-size: 16px;\n  }\n}\n/* Hero depth background — scrolls with viewport scenes track */\n.hero-depth-scene {\n  isolation: isolate;\n}\n.hero-depth-scene--fixed {\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100dvh;\n}\n.hero-depth-scene__base {\n  position: absolute;\n  inset: 0;\n}\n.hero-depth-scene__base--track {\n  background: linear-gradient(\n    180deg,\n    rgb(255 247 237 / 0.98) 0%,\n    rgb(255 255 255 / 0.94) 14%,\n    rgb(255 250 247 / 0.92) 28%,\n    rgb(255 237 213 / 0.5) 46%,\n    rgb(255 255 255 / 0.9) 64%,\n    rgb(255 247 237 / 0.88) 80%,\n    rgb(254 226 210 / 0.48) 100%\n  );\n}\n.hero-depth-scene__mesh {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  background:\n    radial-gradient(ellipse 52% 42% at 12% 18%, rgb(251 146 60 / 0.14), transparent 72%),\n    radial-gradient(ellipse 48% 38% at 88% 28%, rgb(249 115 22 / 0.1), transparent 70%),\n    radial-gradient(ellipse 55% 45% at 72% 82%, rgb(245 158 11 / 0.08), transparent 68%),\n    radial-gradient(ellipse 60% 50% at 50% 100%, rgb(254 226 210 / 0.22), transparent 62%);\n}\n.hero-depth-scene__field {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  opacity: 0.28;\n  background-image: radial-gradient(circle, rgb(251 146 60 / 0.14) 1px, transparent 1px);\n  background-size: 40px 40px;\n  mask-image: radial-gradient(ellipse 90% 75% at 50% 40%, rgb(0 0 0 / 0.7) 15%, transparent 78%);\n}\n.hero-depth-scene__horizon {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  background: linear-gradient(\n    180deg,\n    transparent 0%,\n    transparent 42%,\n    rgb(251 146 60 / 0.04) 52%,\n    rgb(249 115 22 / 0.07) 58%,\n    transparent 68%\n  );\n}\n.hero-depth-scene__vignette {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background: radial-gradient(\n    ellipse 78% 68% at 50% 44%,\n    transparent 34%,\n    rgb(255 237 213 / 0.16) 100%\n  );\n  pointer-events: none;\n}\n.hero-depth-scene__stage {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  perspective: 1200px;\n  perspective-origin: 50% 50%;\n  transform-style: preserve-3d;\n}\n.hero-depth-scene__ambient {\n  position: absolute;\n  inset: 0;\n}\n.hero-depth-scene__ambient--track .hero-depth-scene__orb-anchor {\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n.hero-depth-scene__orb {\n  position: relative;\n  border-radius: 9999px;\n}\n.hero-depth-scene__orb--sm {\n  width: min(16rem, 34vw);\n  height: min(16rem, 34vw);\n  background: radial-gradient(\n    circle at center,\n    rgb(251 146 60 / 0.2) 0%,\n    rgb(251 146 60 / 0.09) 36%,\n    rgb(251 146 60 / 0.025) 58%,\n    transparent 72%\n  );\n}\n.hero-depth-scene__orb--md {\n  width: min(20rem, 40vw);\n  height: min(20rem, 40vw);\n  background: radial-gradient(\n    circle at center,\n    rgb(249 115 22 / 0.17) 0%,\n    rgb(249 115 22 / 0.075) 36%,\n    rgb(249 115 22 / 0.02) 58%,\n    transparent 72%\n  );\n}\n.hero-depth-scene__orb--lg {\n  width: min(24rem, 46vw);\n  height: min(24rem, 46vw);\n  background: radial-gradient(\n    circle at center,\n    rgb(234 88 12 / 0.18) 0%,\n    rgb(234 88 12 / 0.08) 36%,\n    rgb(234 88 12 / 0.025) 58%,\n    transparent 72%\n  );\n}\n.hero-depth-scene__orb--amber {\n  background: radial-gradient(\n    circle at center,\n    rgb(251 146 60 / 0.18) 0%,\n    rgb(251 146 60 / 0.075) 36%,\n    rgb(251 146 60 / 0.02) 58%,\n    transparent 72%\n  ) !important;\n}\n.hero-depth-scene__orb--coral {\n  background: radial-gradient(\n    circle at center,\n    rgb(234 88 12 / 0.17) 0%,\n    rgb(234 88 12 / 0.07) 36%,\n    rgb(234 88 12 / 0.018) 58%,\n    transparent 72%\n  ) !important;\n}\n.hero-depth-scene__orb--gold {\n  background: radial-gradient(\n    circle at center,\n    rgb(245 158 11 / 0.16) 0%,\n    rgb(245 158 11 / 0.065) 36%,\n    rgb(245 158 11 / 0.018) 58%,\n    transparent 72%\n  ) !important;\n}\n.hero-depth-scene__icons {\n  position: absolute;\n  inset: 0;\n}\n.hero-depth-icon {\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n.hero-depth-icon__depth {\n  transform: translate3d(0, 0, var(--depth-z, 0px)) scale(var(--icon-scale, 1));\n}\n.hero-depth-icon__float {\n  position: relative;\n  display: grid;\n  place-items: center;\n  transform: rotate(var(--icon-rotate, 0deg));\n}\n.hero-depth-icon__float--animated {\n  animation: hero-depth-drift cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;\n}\n.hero-depth-icon__float--pulse .hero-depth-icon__svg {\n  animation: hero-depth-icon-pulse 5.5s ease-in-out infinite;\n}\n@keyframes hero-depth-drift {\n  0%,\n  100% {\n    transform: translate(0, 0) rotate(var(--icon-rotate, 0deg));\n  }\n  33% {\n    transform: translate(var(--float-x, 4px), var(--float-y, -4px))\n      rotate(calc(var(--icon-rotate, 0deg) + 2deg));\n  }\n  66% {\n    transform: translate(calc(var(--float-x, 4px) * -0.65), calc(var(--float-y, -4px) * 0.75))\n      rotate(calc(var(--icon-rotate, 0deg) - 1.5deg));\n  }\n}\n@keyframes hero-depth-icon-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.82;\n  }\n}\n.hero-depth-icon__svg {\n  position: relative;\n  z-index: 1;\n  flex-shrink: 0;\n  aspect-ratio: 1 / 1;\n  color: rgb(var(--icon-accent-rgb) / 0.95);\n}\n.hero-depth-icon__svg--mid {\n  width: 2.35rem;\n  height: 2.35rem;\n  opacity: 0.68;\n}\n.hero-depth-icon__svg--near {\n  width: 3rem;\n  height: 3rem;\n  opacity: 0.9;\n}\n.hero-depth-icon__svg--very-near {\n  width: 3.65rem;\n  height: 3.65rem;\n  opacity: 1;\n}\n.hero-depth-icon--mid {\n  mix-blend-mode: multiply;\n}\n@media (prefers-reduced-motion: reduce) {\n  .hero-depth-icon__float--animated,\n  .hero-depth-icon__float--pulse .hero-depth-icon__svg {\n    animation: none !important;\n  }\n}\n/* Landing scenes — tint overlay (no backdrop-filter: re-blurs the animated background on scroll) */\n.landing-scene-glass {\n  background: rgb(255 255 255 / 0.52);\n}\n.landing-scene-glass--footer {\n  background: linear-gradient(\n    180deg,\n    rgb(255 255 255 / 0.48) 0%,\n    rgb(255 255 255 / 0.62) 100%\n  );\n}\n/* Landing scene proportions — fit one viewport per scene */\n.landing-scene-grid {\n  @apply grid gap-2 sm:gap-3 lg:gap-4;\n}\n.landing-scene-card {\n  @apply p-3 sm:p-4 lg:p-5;\n}\n.landing-scene-stat {\n  @apply text-lg font-bold leading-tight text-orange-600  sm:text-2xl lg:text-3xl;\n}\n.landing-scene-stat-label {\n  @apply text-[11px] font-medium leading-snug text-secondary-600 sm:text-xs lg:text-sm;\n}\n.landing-scene-card--compact {\n  @apply p-2.5 sm:p-3 lg:p-4;\n}\n@media (max-width: 1023px) {\n  .landing-scene-grid {\n    @apply gap-2.5;\n  }\n  .landing-scene-card {\n    @apply p-3.5;\n  }\n  .landing-scene-stat {\n    @apply text-xl leading-tight;\n  }\n  .landing-scene-stat-label {\n    @apply text-xs leading-snug;\n  }\n  .landing-scene-card--compact {\n    @apply p-3;\n  }\n}\n@media (min-width: 1024px) {\n  .landing-scene-card.landing-scene-card--compact {\n    @apply p-5;\n  }\n}\n.landing-pricing-grid {\n  @apply max-lg:mx-auto max-lg:w-full max-lg:max-w-md;\n}\n/* Full-viewport landing scenes */\n.viewport-scenes {\n  isolation: isolate;\n}\n.viewport-scene__inner {\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n.viewport-scene__inner::-webkit-scrollbar {\n  display: none;\n}\n/* Landing scene progress dots */\n.scene-progress__dot {\n  @apply h-5 w-5 p-0 border-0 bg-transparent cursor-pointer;\n}\n.scene-progress__marker {\n  @apply block h-2 w-2 rounded-full bg-secondary-300/80 transition-[transform,background-color,box-shadow] duration-300;\n}\n.scene-progress__dot--active .scene-progress__marker,\n.scene-progress__dot:hover .scene-progress__marker,\n.scene-progress__dot:focus-visible .scene-progress__marker {\n  @apply scale-125 bg-orange-500 shadow-glow;\n}\n.scene-progress__dot:focus-visible {\n  @apply outline-none ring-2 ring-orange-400/60 ring-offset-2 ring-offset-transparent rounded-full;\n}\n.nav-link--active {\n  @apply text-orange-600 font-semibold;\n}\n.viewport-scenes--native {\n  scroll-behavior: smooth;\n}\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n  .card-premium:hover,\n  .card-premium.interactive-lift:hover {\n    --card-lift: 0px;\n  }\n}\n/* High contrast mode */\n@media (prefers-contrast: high) {\n  .card,\n  .card-premium,\n  .card-glass {\n    @apply border-2 border-secondary-900;\n  }\n  .btn-primary,\n  .btn-secondary,\n  .btn-accent {\n    @apply border-2 border-secondary-900;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
